const stats = [
  {
    Kunta: "Akaa",
    Vakiluku: 16405,
    Vakiluvun_muutos: -0.40000000000000002,
    Alle15v: 15.300000000000001,
    Ika15_64v: 59.100000000000001,
    Yli64v: 25.600000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.1000000000000001,
    Taajamaa: 88.0,
    Syntyneiden_enemmyys: -105,
    Muuttovoitto: -18,
    Perheita: 4531,
    Asuntokuntia: 7995,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 71.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.399999999999999,
    Taloudellinen_huoltosuhde: 136.30000000000001,
    Tyopaikkaomavaraisuus: 66.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 6970,
    Ika20_64v_tyollisyysaste: 77.799999999999997,
    Asuinkunnassaan_tyossakayvia: 43.799999999999997,
    Tyottomia: 8.5,
    Elakelaisia: 28.300000000000001,
    Alueella_olevia_tyopaikkoja: 4622,
    Alkutuotannon_tyopaikkoja: 2.7999999999999998,
    Jalostuksen_tyopaikkoja: 36.700000000000003,
    Palvelujen_tyopaikkoja: 59.0,
  },
  {
    Kunta: "Alajärvi",
    Vakiluku: 9113,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 16.199999999999999,
    Ika15_64v: 53.100000000000001,
    Yli64v: 30.800000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 4.0,
    Taajamaa: 62.700000000000003,
    Syntyneiden_enemmyys: -65,
    Muuttovoitto: -124,
    Perheita: 2522,
    Asuntokuntia: 4037,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.0,
    Taloudellinen_huoltosuhde: 173.30000000000001,
    Tyopaikkaomavaraisuus: 99.5,
    Alueella_asuva_tyollinen_tyovoima: 3360,
    Ika20_64v_tyollisyysaste: 74.0,
    Asuinkunnassaan_tyossakayvia: 74.900000000000006,
    Tyottomia: 8.0999999999999996,
    Elakelaisia: 34.299999999999997,
    Alueella_olevia_tyopaikkoja: 3344,
    Alkutuotannon_tyopaikkoja: 9.5999999999999996,
    Jalostuksen_tyopaikkoja: 30.0,
    Palvelujen_tyopaikkoja: 59.100000000000001,
  },
  {
    Kunta: "Alavieska",
    Vakiluku: 2437,
    Vakiluvun_muutos: -0.40000000000000002,
    Alle15v: 18.300000000000001,
    Ika15_64v: 54.899999999999999,
    Yli64v: 26.899999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.8,
    Taajamaa: 51.799999999999997,
    Syntyneiden_enemmyys: -14,
    Muuttovoitto: -28,
    Perheita: 642,
    Asuntokuntia: 1095,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 18.600000000000001,
    Taloudellinen_huoltosuhde: 157.0,
    Tyopaikkaomavaraisuus: 72.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 952,
    Ika20_64v_tyollisyysaste: 76.700000000000003,
    Asuinkunnassaan_tyossakayvia: 45.799999999999997,
    Tyottomia: 9.8000000000000007,
    Elakelaisia: 30.199999999999999,
    Alueella_olevia_tyopaikkoja: 693,
    Alkutuotannon_tyopaikkoja: 23.800000000000001,
    Jalostuksen_tyopaikkoja: 22.899999999999999,
    Palvelujen_tyopaikkoja: 52.700000000000003,
  },
  {
    Kunta: "Alavus",
    Vakiluku: 10933,
    Vakiluvun_muutos: -1.5,
    Alle15v: 15.800000000000001,
    Ika15_64v: 54.299999999999997,
    Yli64v: 29.899999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.0,
    Taajamaa: 61.700000000000003,
    Syntyneiden_enemmyys: -145,
    Muuttovoitto: -92,
    Perheita: 2944,
    Asuntokuntia: 5181,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 86.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.300000000000001,
    Taloudellinen_huoltosuhde: 163.90000000000001,
    Tyopaikkaomavaraisuus: 96.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 4207,
    Ika20_64v_tyollisyysaste: 75.700000000000003,
    Asuinkunnassaan_tyossakayvia: 74.599999999999994,
    Tyottomia: 6.9000000000000004,
    Elakelaisia: 33.899999999999999,
    Alueella_olevia_tyopaikkoja: 4042,
    Alkutuotannon_tyopaikkoja: 8.5,
    Jalostuksen_tyopaikkoja: 23.0,
    Palvelujen_tyopaikkoja: 67.5,
  },
  {
    Kunta: "Asikkala",
    Vakiluku: 7968,
    Vakiluvun_muutos: -0.59999999999999998,
    Alle15v: 12.9,
    Ika15_64v: 52.0,
    Yli64v: 35.100000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.7000000000000002,
    Taajamaa: 65.400000000000006,
    Syntyneiden_enemmyys: -69,
    Muuttovoitto: -23,
    Perheita: 2255,
    Asuntokuntia: 3982,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 77.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 27.800000000000001,
    Taloudellinen_huoltosuhde: 171.90000000000001,
    Tyopaikkaomavaraisuus: 78.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 2947,
    Ika20_64v_tyollisyysaste: 75.099999999999994,
    Asuinkunnassaan_tyossakayvia: 49.5,
    Tyottomia: 8.6999999999999993,
    Elakelaisia: 38.0,
    Alueella_olevia_tyopaikkoja: 2318,
    Alkutuotannon_tyopaikkoja: 9.0999999999999996,
    Jalostuksen_tyopaikkoja: 29.0,
    Palvelujen_tyopaikkoja: 59.899999999999999,
  },
  {
    Kunta: "Askola",
    Vakiluku: 4700,
    Vakiluvun_muutos: -1.3,
    Alle15v: 17.399999999999999,
    Ika15_64v: 60.100000000000001,
    Yli64v: 22.399999999999999,
    Ruotsinkielisia: 3.7999999999999998,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 53.799999999999997,
    Syntyneiden_enemmyys: -18,
    Muuttovoitto: -48,
    Perheita: 1356,
    Asuntokuntia: 2102,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 13.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.800000000000001,
    Taloudellinen_huoltosuhde: 114.40000000000001,
    Tyopaikkaomavaraisuus: 61.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 2222,
    Ika20_64v_tyollisyysaste: 81.799999999999997,
    Asuinkunnassaan_tyossakayvia: 33.399999999999999,
    Tyottomia: 6.7000000000000002,
    Elakelaisia: 24.399999999999999,
    Alueella_olevia_tyopaikkoja: 1359,
    Alkutuotannon_tyopaikkoja: 7.5999999999999996,
    Jalostuksen_tyopaikkoja: 34.600000000000001,
    Palvelujen_tyopaikkoja: 55.399999999999999,
  },
  {
    Kunta: "Aura",
    Vakiluku: 3961,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 18.0,
    Ika15_64v: 59.399999999999999,
    Yli64v: 22.600000000000001,
    Ruotsinkielisia: 0.59999999999999998,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 70.700000000000003,
    Syntyneiden_enemmyys: -15,
    Muuttovoitto: -8,
    Perheita: 1132,
    Asuntokuntia: 1816,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 13.9,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.899999999999999,
    Taloudellinen_huoltosuhde: 119.8,
    Tyopaikkaomavaraisuus: 66.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 1804,
    Ika20_64v_tyollisyysaste: 82.799999999999997,
    Asuinkunnassaan_tyossakayvia: 29.399999999999999,
    Tyottomia: 5.5,
    Elakelaisia: 25.199999999999999,
    Alueella_olevia_tyopaikkoja: 1192,
    Alkutuotannon_tyopaikkoja: 4.7000000000000002,
    Jalostuksen_tyopaikkoja: 35.100000000000001,
    Palvelujen_tyopaikkoja: 58.700000000000003,
  },
  {
    Kunta: "Brändö",
    Vakiluku: 436,
    Vakiluvun_muutos: -3.1000000000000001,
    Alle15v: 8.9000000000000004,
    Ika15_64v: 55.5,
    Yli64v: 35.600000000000001,
    Ruotsinkielisia: 69.5,
    Ulkomaan_kansalaisia: 9.1999999999999993,
    Taajamaa: 0.0,
    Syntyneiden_enemmyys: -1,
    Muuttovoitto: -13,
    Perheita: 111,
    Asuntokuntia: 220,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 34.5,
    Taloudellinen_huoltosuhde: 111.3,
    Tyopaikkaomavaraisuus: 70.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 213,
    Ika20_64v_tyollisyysaste: 82.400000000000006,
    Asuinkunnassaan_tyossakayvia: 63.799999999999997,
    Tyottomia: 3.2000000000000002,
    Elakelaisia: 33.600000000000001,
    Alueella_olevia_tyopaikkoja: 151,
    Alkutuotannon_tyopaikkoja: 23.800000000000001,
    Jalostuksen_tyopaikkoja: 5.2999999999999998,
    Palvelujen_tyopaikkoja: 65.599999999999994,
  },
  {
    Kunta: "Eckerö",
    Vakiluku: 942,
    Vakiluvun_muutos: 0.29999999999999999,
    Alle15v: 13.199999999999999,
    Ika15_64v: 57.100000000000001,
    Yli64v: 29.699999999999999,
    Ruotsinkielisia: 86.799999999999997,
    Ulkomaan_kansalaisia: 13.4,
    Taajamaa: 41.100000000000001,
    Syntyneiden_enemmyys: -4,
    Muuttovoitto: -4,
    Perheita: 268,
    Asuntokuntia: 454,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.300000000000001,
    Taloudellinen_huoltosuhde: 118.90000000000001,
    Tyopaikkaomavaraisuus: 61.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 429,
    Ika20_64v_tyollisyysaste: 80.799999999999997,
    Asuinkunnassaan_tyossakayvia: 39.899999999999999,
    Tyottomia: 4.2000000000000002,
    Elakelaisia: 28.600000000000001,
    Alueella_olevia_tyopaikkoja: 263,
    Alkutuotannon_tyopaikkoja: 9.5,
    Jalostuksen_tyopaikkoja: 23.199999999999999,
    Palvelujen_tyopaikkoja: 60.100000000000001,
  },
  {
    Kunta: "Enonkoski",
    Vakiluku: 1320,
    Vakiluvun_muutos: -1.6000000000000001,
    Alle15v: 12.4,
    Ika15_64v: 48.299999999999997,
    Yli64v: 39.299999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.0,
    Taajamaa: 38.700000000000003,
    Syntyneiden_enemmyys: -15,
    Muuttovoitto: -12,
    Perheita: 368,
    Asuntokuntia: 679,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.699999999999999,
    Taloudellinen_huoltosuhde: 194.09999999999999,
    Tyopaikkaomavaraisuus: 86.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 456,
    Ika20_64v_tyollisyysaste: 72.700000000000003,
    Asuinkunnassaan_tyossakayvia: 56.399999999999999,
    Tyottomia: 11.6,
    Elakelaisia: 41.600000000000001,
    Alueella_olevia_tyopaikkoja: 394,
    Alkutuotannon_tyopaikkoja: 20.300000000000001,
    Jalostuksen_tyopaikkoja: 9.0999999999999996,
    Palvelujen_tyopaikkoja: 68.5,
  },
  {
    Kunta: "Enontekiö",
    Vakiluku: 1771,
    Vakiluvun_muutos: -2.2000000000000002,
    Alle15v: 11.699999999999999,
    Ika15_64v: 56.700000000000003,
    Yli64v: 31.600000000000001,
    Ruotsinkielisia: 0.80000000000000004,
    Ulkomaan_kansalaisia: 3.1000000000000001,
    Taajamaa: 28.0,
    Syntyneiden_enemmyys: -13,
    Muuttovoitto: -25,
    Perheita: 447,
    Asuntokuntia: 836,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.199999999999999,
    Taloudellinen_huoltosuhde: 136.09999999999999,
    Tyopaikkaomavaraisuus: 86.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 767,
    Ika20_64v_tyollisyysaste: 73.900000000000006,
    Asuinkunnassaan_tyossakayvia: 74.599999999999994,
    Tyottomia: 13.1,
    Elakelaisia: 32.0,
    Alueella_olevia_tyopaikkoja: 664,
    Alkutuotannon_tyopaikkoja: 10.5,
    Jalostuksen_tyopaikkoja: 11.6,
    Palvelujen_tyopaikkoja: 75.200000000000003,
  },
  {
    Kunta: "Espoo",
    Vakiluku: 314024,
    Vakiluvun_muutos: 2.8999999999999999,
    Alle15v: 17.699999999999999,
    Ika15_64v: 67.099999999999994,
    Yli64v: 15.1,
    Ruotsinkielisia: 6.4000000000000004,
    Ulkomaan_kansalaisia: 15.699999999999999,
    Taajamaa: 99.5,
    Syntyneiden_enemmyys: 1430,
    Muuttovoitto: 2396,
    Perheita: 82947,
    Asuntokuntia: 145341,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 36.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 40.799999999999997,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 47.100000000000001,
    Taloudellinen_huoltosuhde: 108.09999999999999,
    Tyopaikkaomavaraisuus: 92.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 146707,
    Ika20_64v_tyollisyysaste: 76.700000000000003,
    Asuinkunnassaan_tyossakayvia: 47.700000000000003,
    Tyottomia: 8.0999999999999996,
    Elakelaisia: 16.399999999999999,
    Alueella_olevia_tyopaikkoja: 135386,
    Alkutuotannon_tyopaikkoja: 0.10000000000000001,
    Jalostuksen_tyopaikkoja: 17.300000000000001,
    Palvelujen_tyopaikkoja: 81.0,
  },
  {
    Kunta: "Eura",
    Vakiluku: 11184,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 14.4,
    Ika15_64v: 56.100000000000001,
    Yli64v: 29.600000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 3.7999999999999998,
    Taajamaa: 71.299999999999997,
    Syntyneiden_enemmyys: -93,
    Muuttovoitto: -58,
    Perheita: 3138,
    Asuntokuntia: 5543,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 86.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.899999999999999,
    Taloudellinen_huoltosuhde: 141.19999999999999,
    Tyopaikkaomavaraisuus: 85.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 4674,
    Ika20_64v_tyollisyysaste: 78.5,
    Asuinkunnassaan_tyossakayvia: 54.899999999999999,
    Tyottomia: 7.7000000000000002,
    Elakelaisia: 32.5,
    Alueella_olevia_tyopaikkoja: 3992,
    Alkutuotannon_tyopaikkoja: 7.7000000000000002,
    Jalostuksen_tyopaikkoja: 37.200000000000003,
    Palvelujen_tyopaikkoja: 53.899999999999999,
  },
  {
    Kunta: "Eurajoki",
    Vakiluku: 9143,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 15.800000000000001,
    Ika15_64v: 57.100000000000001,
    Yli64v: 27.100000000000001,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 3.2999999999999998,
    Taajamaa: 64.400000000000006,
    Syntyneiden_enemmyys: -55,
    Muuttovoitto: -34,
    Perheita: 2680,
    Asuntokuntia: 4102,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 93.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 28.300000000000001,
    Taloudellinen_huoltosuhde: 138.59999999999999,
    Tyopaikkaomavaraisuus: 97.5,
    Alueella_asuva_tyollinen_tyovoima: 3861,
    Ika20_64v_tyollisyysaste: 79.299999999999997,
    Asuinkunnassaan_tyossakayvia: 41.799999999999997,
    Tyottomia: 6.9000000000000004,
    Elakelaisia: 29.699999999999999,
    Alueella_olevia_tyopaikkoja: 3763,
    Alkutuotannon_tyopaikkoja: 3.8999999999999999,
    Jalostuksen_tyopaikkoja: 49.399999999999999,
    Palvelujen_tyopaikkoja: 46.0,
  },
  {
    Kunta: "Evijärvi",
    Vakiluku: 2292,
    Vakiluvun_muutos: -2.2999999999999998,
    Alle15v: 15.699999999999999,
    Ika15_64v: 53.399999999999999,
    Yli64v: 31.0,
    Ruotsinkielisia: 2.1000000000000001,
    Ulkomaan_kansalaisia: 3.6000000000000001,
    Taajamaa: 36.399999999999999,
    Syntyneiden_enemmyys: -25,
    Muuttovoitto: -40,
    Perheita: 648,
    Asuntokuntia: 1064,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 18.800000000000001,
    Taloudellinen_huoltosuhde: 152.80000000000001,
    Tyopaikkaomavaraisuus: 88.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 928,
    Ika20_64v_tyollisyysaste: 77.599999999999994,
    Asuinkunnassaan_tyossakayvia: 59.399999999999999,
    Tyottomia: 6.7999999999999998,
    Elakelaisia: 33.600000000000001,
    Alueella_olevia_tyopaikkoja: 818,
    Alkutuotannon_tyopaikkoja: 21.100000000000001,
    Jalostuksen_tyopaikkoja: 28.0,
    Palvelujen_tyopaikkoja: 49.299999999999997,
  },
  {
    Kunta: "Finström",
    Vakiluku: 2610,
    Vakiluvun_muutos: 0.90000000000000002,
    Alle15v: 16.899999999999999,
    Ika15_64v: 60.0,
    Yli64v: 23.100000000000001,
    Ruotsinkielisia: 90.099999999999994,
    Ulkomaan_kansalaisia: 10.800000000000001,
    Taajamaa: 42.600000000000001,
    Syntyneiden_enemmyys: 16,
    Muuttovoitto: -9,
    Perheita: 749,
    Asuntokuntia: 1161,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.5,
    Taloudellinen_huoltosuhde: 114.2,
    Tyopaikkaomavaraisuus: 74.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 1208,
    Ika20_64v_tyollisyysaste: 82.700000000000003,
    Asuinkunnassaan_tyossakayvia: 30.899999999999999,
    Tyottomia: 4.0999999999999996,
    Elakelaisia: 24.100000000000001,
    Alueella_olevia_tyopaikkoja: 901,
    Alkutuotannon_tyopaikkoja: 8.9000000000000004,
    Jalostuksen_tyopaikkoja: 32.0,
    Palvelujen_tyopaikkoja: 55.600000000000001,
  },
  {
    Kunta: "Forssa",
    Vakiluku: 16469,
    Vakiluvun_muutos: 0.10000000000000001,
    Alle15v: 11.199999999999999,
    Ika15_64v: 55.700000000000003,
    Yli64v: 33.100000000000001,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 6.2000000000000002,
    Taajamaa: 91.599999999999994,
    Syntyneiden_enemmyys: -187,
    Muuttovoitto: -93,
    Perheita: 4185,
    Asuntokuntia: 9264,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 45.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 33.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.399999999999999,
    Taloudellinen_huoltosuhde: 162.19999999999999,
    Tyopaikkaomavaraisuus: 124.3,
    Alueella_asuva_tyollinen_tyovoima: 6277,
    Ika20_64v_tyollisyysaste: 71.900000000000006,
    Asuinkunnassaan_tyossakayvia: 70.900000000000006,
    Tyottomia: 10.1,
    Elakelaisia: 36.399999999999999,
    Alueella_olevia_tyopaikkoja: 7800,
    Alkutuotannon_tyopaikkoja: 2.0,
    Jalostuksen_tyopaikkoja: 35.200000000000003,
    Palvelujen_tyopaikkoja: 62.100000000000001,
  },
  {
    Kunta: "Föglö",
    Vakiluku: 509,
    Vakiluvun_muutos: 1.0,
    Alle15v: 15.1,
    Ika15_64v: 53.0,
    Yli64v: 31.800000000000001,
    Ruotsinkielisia: 82.299999999999997,
    Ulkomaan_kansalaisia: 22.199999999999999,
    Taajamaa: 0.0,
    Syntyneiden_enemmyys: -6,
    Muuttovoitto: 0,
    Perheita: 124,
    Asuntokuntia: 240,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 58.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 16.399999999999999,
    Taloudellinen_huoltosuhde: 133.30000000000001,
    Tyopaikkaomavaraisuus: 94.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 216,
    Ika20_64v_tyollisyysaste: 80.799999999999997,
    Asuinkunnassaan_tyossakayvia: 69.900000000000006,
    Tyottomia: 2.2999999999999998,
    Elakelaisia: 31.199999999999999,
    Alueella_olevia_tyopaikkoja: 205,
    Alkutuotannon_tyopaikkoja: 32.700000000000003,
    Jalostuksen_tyopaikkoja: 6.2999999999999998,
    Palvelujen_tyopaikkoja: 59.5,
  },
  {
    Kunta: "Geta",
    Vakiluku: 509,
    Vakiluvun_muutos: 0.40000000000000002,
    Alle15v: 16.100000000000001,
    Ika15_64v: 58.200000000000003,
    Yli64v: 25.699999999999999,
    Ruotsinkielisia: 83.5,
    Ulkomaan_kansalaisia: 14.1,
    Taajamaa: 0.0,
    Syntyneiden_enemmyys: -3,
    Muuttovoitto: -1,
    Perheita: 141,
    Asuntokuntia: 236,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 62.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 18.0,
    Taloudellinen_huoltosuhde: 116.7,
    Tyopaikkaomavaraisuus: 50.899999999999999,
    Alueella_asuva_tyollinen_tyovoima: 234,
    Ika20_64v_tyollisyysaste: 77.700000000000003,
    Asuinkunnassaan_tyossakayvia: 36.299999999999997,
    Tyottomia: 4.9000000000000004,
    Elakelaisia: 24.5,
    Alueella_olevia_tyopaikkoja: 119,
    Alkutuotannon_tyopaikkoja: 19.300000000000001,
    Jalostuksen_tyopaikkoja: 10.1,
    Palvelujen_tyopaikkoja: 60.5,
  },
  {
    Kunta: "Haapajärvi",
    Vakiluku: 6558,
    Vakiluvun_muutos: -1.8999999999999999,
    Alle15v: 17.199999999999999,
    Ika15_64v: 55.0,
    Yli64v: 27.800000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.3999999999999999,
    Taajamaa: 69.0,
    Syntyneiden_enemmyys: -44,
    Muuttovoitto: -106,
    Perheita: 1718,
    Asuntokuntia: 3108,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 83.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.199999999999999,
    Taloudellinen_huoltosuhde: 155.5,
    Tyopaikkaomavaraisuus: 103.09999999999999,
    Alueella_asuva_tyollinen_tyovoima: 2617,
    Ika20_64v_tyollisyysaste: 75.5,
    Asuinkunnassaan_tyossakayvia: 74.799999999999997,
    Tyottomia: 8.8000000000000007,
    Elakelaisia: 31.300000000000001,
    Alueella_olevia_tyopaikkoja: 2698,
    Alkutuotannon_tyopaikkoja: 8.9000000000000004,
    Jalostuksen_tyopaikkoja: 27.399999999999999,
    Palvelujen_tyopaikkoja: 62.700000000000003,
  },
  {
    Kunta: "Haapavesi",
    Vakiluku: 6473,
    Vakiluvun_muutos: -1.8,
    Alle15v: 18.600000000000001,
    Ika15_64v: 55.5,
    Yli64v: 25.800000000000001,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 3.2999999999999998,
    Taajamaa: 61.600000000000001,
    Syntyneiden_enemmyys: -47,
    Muuttovoitto: -122,
    Perheita: 1652,
    Asuntokuntia: 2891,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 18.100000000000001,
    Taloudellinen_huoltosuhde: 159.40000000000001,
    Tyopaikkaomavaraisuus: 104.0,
    Alueella_asuva_tyollinen_tyovoima: 2541,
    Ika20_64v_tyollisyysaste: 75.799999999999997,
    Asuinkunnassaan_tyossakayvia: 74.700000000000003,
    Tyottomia: 8.1999999999999993,
    Elakelaisia: 29.100000000000001,
    Alueella_olevia_tyopaikkoja: 2642,
    Alkutuotannon_tyopaikkoja: 11.4,
    Jalostuksen_tyopaikkoja: 34.100000000000001,
    Palvelujen_tyopaikkoja: 53.399999999999999,
  },
  {
    Kunta: "Hailuoto",
    Vakiluku: 948,
    Vakiluvun_muutos: -1.3,
    Alle15v: 11.800000000000001,
    Ika15_64v: 47.799999999999997,
    Yli64v: 40.399999999999999,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 1.2,
    Taajamaa: 53.799999999999997,
    Syntyneiden_enemmyys: -8,
    Muuttovoitto: -5,
    Perheita: 259,
    Asuntokuntia: 486,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 14.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 79.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 35.600000000000001,
    Taloudellinen_huoltosuhde: 176.69999999999999,
    Tyopaikkaomavaraisuus: 70.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 347,
    Ika20_64v_tyollisyysaste: 77.200000000000003,
    Asuinkunnassaan_tyossakayvia: 52.399999999999999,
    Tyottomia: 9.4000000000000004,
    Elakelaisia: 42.299999999999997,
    Alueella_olevia_tyopaikkoja: 245,
    Alkutuotannon_tyopaikkoja: 23.699999999999999,
    Jalostuksen_tyopaikkoja: 10.6,
    Palvelujen_tyopaikkoja: 64.900000000000006,
  },
  {
    Kunta: "Halsua",
    Vakiluku: 1013,
    Vakiluvun_muutos: -3.7000000000000002,
    Alle15v: 13.699999999999999,
    Ika15_64v: 49.299999999999997,
    Yli64v: 37.0,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 4.7000000000000002,
    Taajamaa: 44.299999999999997,
    Syntyneiden_enemmyys: -18,
    Muuttovoitto: -30,
    Perheita: 287,
    Asuntokuntia: 478,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 98.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 62.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 18.300000000000001,
    Taloudellinen_huoltosuhde: 172.5,
    Tyopaikkaomavaraisuus: 87.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 386,
    Ika20_64v_tyollisyysaste: 77.700000000000003,
    Asuinkunnassaan_tyossakayvia: 65.799999999999997,
    Tyottomia: 9.4000000000000004,
    Elakelaisia: 39.399999999999999,
    Alueella_olevia_tyopaikkoja: 337,
    Alkutuotannon_tyopaikkoja: 27.0,
    Jalostuksen_tyopaikkoja: 24.0,
    Palvelujen_tyopaikkoja: 47.799999999999997,
  },
  {
    Kunta: "Hamina",
    Vakiluku: 19534,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 12.199999999999999,
    Ika15_64v: 56.399999999999999,
    Yli64v: 31.399999999999999,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 4.9000000000000004,
    Taajamaa: 87.799999999999997,
    Syntyneiden_enemmyys: -194,
    Muuttovoitto: -110,
    Perheita: 5326,
    Asuntokuntia: 10303,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 71.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.800000000000001,
    Taloudellinen_huoltosuhde: 158.90000000000001,
    Tyopaikkaomavaraisuus: 81.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 7552,
    Ika20_64v_tyollisyysaste: 72.700000000000003,
    Asuinkunnassaan_tyossakayvia: 53.600000000000001,
    Tyottomia: 11.6,
    Elakelaisia: 35.399999999999999,
    Alueella_olevia_tyopaikkoja: 6166,
    Alkutuotannon_tyopaikkoja: 3.2000000000000002,
    Jalostuksen_tyopaikkoja: 21.699999999999999,
    Palvelujen_tyopaikkoja: 73.900000000000006,
  },
  {
    Kunta: "Hammarland",
    Vakiluku: 1646,
    Vakiluvun_muutos: 1.1000000000000001,
    Alle15v: 16.699999999999999,
    Ika15_64v: 60.100000000000001,
    Yli64v: 23.100000000000001,
    Ruotsinkielisia: 89.900000000000006,
    Ulkomaan_kansalaisia: 12.0,
    Taajamaa: 41.5,
    Syntyneiden_enemmyys: 6,
    Muuttovoitto: 0,
    Perheita: 492,
    Asuntokuntia: 734,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 93.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.5,
    Taloudellinen_huoltosuhde: 105.3,
    Tyopaikkaomavaraisuus: 46.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 793,
    Ika20_64v_tyollisyysaste: 83.700000000000003,
    Asuinkunnassaan_tyossakayvia: 28.800000000000001,
    Tyottomia: 4.5999999999999996,
    Elakelaisia: 23.199999999999999,
    Alueella_olevia_tyopaikkoja: 367,
    Alkutuotannon_tyopaikkoja: 15.0,
    Jalostuksen_tyopaikkoja: 16.600000000000001,
    Palvelujen_tyopaikkoja: 61.299999999999997,
  },
  {
    Kunta: "Hankasalmi",
    Vakiluku: 4549,
    Vakiluvun_muutos: -1.1000000000000001,
    Alle15v: 12.800000000000001,
    Ika15_64v: 52.299999999999997,
    Yli64v: 34.899999999999999,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 46.899999999999999,
    Syntyneiden_enemmyys: -56,
    Muuttovoitto: -52,
    Perheita: 1233,
    Asuntokuntia: 2309,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.800000000000001,
    Taloudellinen_huoltosuhde: 178.0,
    Tyopaikkaomavaraisuus: 78.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1655,
    Ika20_64v_tyollisyysaste: 72.799999999999997,
    Asuinkunnassaan_tyossakayvia: 57.5,
    Tyottomia: 11.1,
    Elakelaisia: 38.200000000000003,
    Alueella_olevia_tyopaikkoja: 1294,
    Alkutuotannon_tyopaikkoja: 15.800000000000001,
    Jalostuksen_tyopaikkoja: 21.100000000000001,
    Palvelujen_tyopaikkoja: 61.399999999999999,
  },
  {
    Kunta: "Hanko",
    Vakiluku: 7721,
    Vakiluvun_muutos: -1.3999999999999999,
    Alle15v: 10.800000000000001,
    Ika15_64v: 54.200000000000003,
    Yli64v: 35.0,
    Ruotsinkielisia: 42.299999999999997,
    Ulkomaan_kansalaisia: 4.0,
    Taajamaa: 96.5,
    Syntyneiden_enemmyys: -97,
    Muuttovoitto: -51,
    Perheita: 2091,
    Asuntokuntia: 4198,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 63.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 25.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 64.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.0,
    Taloudellinen_huoltosuhde: 150.90000000000001,
    Tyopaikkaomavaraisuus: 109.90000000000001,
    Alueella_asuva_tyollinen_tyovoima: 3122,
    Ika20_64v_tyollisyysaste: 76.700000000000003,
    Asuinkunnassaan_tyossakayvia: 82.0,
    Tyottomia: 9.9000000000000004,
    Elakelaisia: 37.399999999999999,
    Alueella_olevia_tyopaikkoja: 3431,
    Alkutuotannon_tyopaikkoja: 0.29999999999999999,
    Jalostuksen_tyopaikkoja: 36.5,
    Palvelujen_tyopaikkoja: 62.399999999999999,
  },
  {
    Kunta: "Harjavalta",
    Vakiluku: 6703,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 13.300000000000001,
    Ika15_64v: 53.600000000000001,
    Yli64v: 33.100000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 4.0,
    Taajamaa: 93.200000000000003,
    Syntyneiden_enemmyys: -62,
    Muuttovoitto: -28,
    Perheita: 1770,
    Asuntokuntia: 3633,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 72.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 25.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.399999999999999,
    Taloudellinen_huoltosuhde: 169.59999999999999,
    Tyopaikkaomavaraisuus: 153.90000000000001,
    Alueella_asuva_tyollinen_tyovoima: 2505,
    Ika20_64v_tyollisyysaste: 72.799999999999997,
    Asuinkunnassaan_tyossakayvia: 56.299999999999997,
    Tyottomia: 10.0,
    Elakelaisia: 37.0,
    Alueella_olevia_tyopaikkoja: 3856,
    Alkutuotannon_tyopaikkoja: 1.0,
    Jalostuksen_tyopaikkoja: 46.200000000000003,
    Palvelujen_tyopaikkoja: 52.0,
  },
  {
    Kunta: "Hartola",
    Vakiluku: 2531,
    Vakiluvun_muutos: -1.7,
    Alle15v: 9.1999999999999993,
    Ika15_64v: 47.200000000000003,
    Yli64v: 43.600000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.7999999999999998,
    Taajamaa: 53.700000000000003,
    Syntyneiden_enemmyys: -35,
    Muuttovoitto: -16,
    Perheita: 665,
    Asuntokuntia: 1446,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 85.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 62.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.399999999999999,
    Taloudellinen_huoltosuhde: 202.09999999999999,
    Tyopaikkaomavaraisuus: 94.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 852,
    Ika20_64v_tyollisyysaste: 69.0,
    Asuinkunnassaan_tyossakayvia: 64.400000000000006,
    Tyottomia: 15.199999999999999,
    Elakelaisia: 46.399999999999999,
    Alueella_olevia_tyopaikkoja: 803,
    Alkutuotannon_tyopaikkoja: 16.199999999999999,
    Jalostuksen_tyopaikkoja: 18.800000000000001,
    Palvelujen_tyopaikkoja: 63.100000000000001,
  },
  {
    Kunta: "Hattula",
    Vakiluku: 9371,
    Vakiluvun_muutos: 0.10000000000000001,
    Alle15v: 15.9,
    Ika15_64v: 58.899999999999999,
    Yli64v: 25.100000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 1.5,
    Taajamaa: 74.700000000000003,
    Syntyneiden_enemmyys: -44,
    Muuttovoitto: 45,
    Perheita: 2721,
    Asuntokuntia: 4319,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 85.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 77.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 32.299999999999997,
    Taloudellinen_huoltosuhde: 123.5,
    Tyopaikkaomavaraisuus: 67.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 4187,
    Ika20_64v_tyollisyysaste: 81.799999999999997,
    Asuinkunnassaan_tyossakayvia: 29.300000000000001,
    Tyottomia: 5.7999999999999998,
    Elakelaisia: 27.399999999999999,
    Alueella_olevia_tyopaikkoja: 2822,
    Alkutuotannon_tyopaikkoja: 3.5,
    Jalostuksen_tyopaikkoja: 17.899999999999999,
    Palvelujen_tyopaikkoja: 77.400000000000006,
  },
  {
    Kunta: "Hausjärvi",
    Vakiluku: 7998,
    Vakiluvun_muutos: -0.40000000000000002,
    Alle15v: 15.800000000000001,
    Ika15_64v: 59.899999999999999,
    Yli64v: 24.199999999999999,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 2.6000000000000001,
    Taajamaa: 65.0,
    Syntyneiden_enemmyys: -42,
    Muuttovoitto: -4,
    Perheita: 2314,
    Asuntokuntia: 3750,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.800000000000001,
    Taloudellinen_huoltosuhde: 123.0,
    Tyopaikkaomavaraisuus: 51.100000000000001,
    Alueella_asuva_tyollinen_tyovoima: 3602,
    Ika20_64v_tyollisyysaste: 80.0,
    Asuinkunnassaan_tyossakayvia: 27.800000000000001,
    Tyottomia: 6.5999999999999996,
    Elakelaisia: 27.100000000000001,
    Alueella_olevia_tyopaikkoja: 1842,
    Alkutuotannon_tyopaikkoja: 9.0999999999999996,
    Jalostuksen_tyopaikkoja: 26.600000000000001,
    Palvelujen_tyopaikkoja: 61.899999999999999,
  },
  {
    Kunta: "Heinola",
    Vakiluku: 17953,
    Vakiluvun_muutos: -1.0,
    Alle15v: 10.199999999999999,
    Ika15_64v: 52.600000000000001,
    Yli64v: 37.200000000000003,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.7000000000000002,
    Taajamaa: 91.200000000000003,
    Syntyneiden_enemmyys: -273,
    Muuttovoitto: 1,
    Perheita: 4799,
    Asuntokuntia: 10169,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 51.399999999999999,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 32.700000000000003,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.100000000000001,
    Taloudellinen_huoltosuhde: 185.5,
    Tyopaikkaomavaraisuus: 97.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 6351,
    Ika20_64v_tyollisyysaste: 69.299999999999997,
    Asuinkunnassaan_tyossakayvia: 69.799999999999997,
    Tyottomia: 14.9,
    Elakelaisia: 40.600000000000001,
    Alueella_olevia_tyopaikkoja: 6208,
    Alkutuotannon_tyopaikkoja: 2.0,
    Jalostuksen_tyopaikkoja: 34.200000000000003,
    Palvelujen_tyopaikkoja: 62.899999999999999,
  },
  {
    Kunta: "Heinävesi",
    Vakiluku: 3001,
    Vakiluvun_muutos: -2.0,
    Alle15v: 8.8000000000000007,
    Ika15_64v: 48.5,
    Yli64v: 42.799999999999997,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 3.7999999999999998,
    Taajamaa: 43.299999999999997,
    Syntyneiden_enemmyys: -51,
    Muuttovoitto: -44,
    Perheita: 813,
    Asuntokuntia: 1688,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 83.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.100000000000001,
    Taloudellinen_huoltosuhde: 208.90000000000001,
    Tyopaikkaomavaraisuus: 94.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 991,
    Ika20_64v_tyollisyysaste: 68.599999999999994,
    Asuinkunnassaan_tyossakayvia: 74.799999999999997,
    Tyottomia: 13.0,
    Elakelaisia: 46.5,
    Alueella_olevia_tyopaikkoja: 938,
    Alkutuotannon_tyopaikkoja: 13.300000000000001,
    Jalostuksen_tyopaikkoja: 22.800000000000001,
    Palvelujen_tyopaikkoja: 61.299999999999997,
  },
  {
    Kunta: "Helsinki",
    Vakiluku: 674500,
    Vakiluvun_muutos: 1.6000000000000001,
    Alle15v: 14.1,
    Ika15_64v: 68.299999999999997,
    Yli64v: 17.600000000000001,
    Ruotsinkielisia: 5.5,
    Ulkomaan_kansalaisia: 11.9,
    Taajamaa: 100.0,
    Syntyneiden_enemmyys: 359,
    Muuttovoitto: 1992,
    Perheita: 163008,
    Asuntokuntia: 356248,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 12.800000000000001,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 50.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 76.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 45.299999999999997,
    Taloudellinen_huoltosuhde: 105.7,
    Tyopaikkaomavaraisuus: 132.19999999999999,
    Alueella_asuva_tyollinen_tyovoima: 322759,
    Ika20_64v_tyollisyysaste: 74.200000000000003,
    Asuinkunnassaan_tyossakayvia: 76.299999999999997,
    Tyottomia: 10.1,
    Elakelaisia: 19.199999999999999,
    Alueella_olevia_tyopaikkoja: 426738,
    Alkutuotannon_tyopaikkoja: 0.10000000000000001,
    Jalostuksen_tyopaikkoja: 10.0,
    Palvelujen_tyopaikkoja: 88.599999999999994,
  },
  {
    Kunta: "Hirvensalmi",
    Vakiluku: 2062,
    Vakiluvun_muutos: -1.3999999999999999,
    Alle15v: 9.9000000000000004,
    Ika15_64v: 49.899999999999999,
    Yli64v: 40.200000000000003,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 35.0,
    Syntyneiden_enemmyys: -19,
    Muuttovoitto: -48,
    Perheita: 566,
    Asuntokuntia: 1092,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.0,
    Taloudellinen_huoltosuhde: 181.0,
    Tyopaikkaomavaraisuus: 70.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 744,
    Ika20_64v_tyollisyysaste: 71.5,
    Asuinkunnassaan_tyossakayvia: 47.200000000000003,
    Tyottomia: 11.6,
    Elakelaisia: 43.600000000000001,
    Alueella_olevia_tyopaikkoja: 527,
    Alkutuotannon_tyopaikkoja: 17.300000000000001,
    Jalostuksen_tyopaikkoja: 26.0,
    Palvelujen_tyopaikkoja: 54.5,
  },
  {
    Kunta: "Hollola",
    Vakiluku: 22885,
    Vakiluvun_muutos: -0.29999999999999999,
    Alle15v: 16.100000000000001,
    Ika15_64v: 57.0,
    Yli64v: 26.899999999999999,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 1.8999999999999999,
    Taajamaa: 80.0,
    Syntyneiden_enemmyys: -111,
    Muuttovoitto: 11,
    Perheita: 6551,
    Asuntokuntia: 10714,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 71.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 31.399999999999999,
    Taloudellinen_huoltosuhde: 138.0,
    Tyopaikkaomavaraisuus: 61.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 9638,
    Ika20_64v_tyollisyysaste: 79.200000000000003,
    Asuinkunnassaan_tyossakayvia: 30.5,
    Tyottomia: 7.9000000000000004,
    Elakelaisia: 29.300000000000001,
    Alueella_olevia_tyopaikkoja: 5912,
    Alkutuotannon_tyopaikkoja: 5.7999999999999998,
    Jalostuksen_tyopaikkoja: 28.899999999999999,
    Palvelujen_tyopaikkoja: 63.299999999999997,
  },
  {
    Kunta: "Huittinen",
    Vakiluku: 9646,
    Vakiluvun_muutos: -1.0,
    Alle15v: 13.4,
    Ika15_64v: 55.600000000000001,
    Yli64v: 30.899999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.8999999999999999,
    Taajamaa: 71.400000000000006,
    Syntyneiden_enemmyys: -91,
    Muuttovoitto: -75,
    Perheita: 2568,
    Asuntokuntia: 5032,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 80.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.800000000000001,
    Taloudellinen_huoltosuhde: 142.69999999999999,
    Tyopaikkaomavaraisuus: 100.5,
    Alueella_asuva_tyollinen_tyovoima: 4015,
    Ika20_64v_tyollisyysaste: 78.299999999999997,
    Asuinkunnassaan_tyossakayvia: 67.099999999999994,
    Tyottomia: 6.7000000000000002,
    Elakelaisia: 34.100000000000001,
    Alueella_olevia_tyopaikkoja: 4036,
    Alkutuotannon_tyopaikkoja: 9.1999999999999993,
    Jalostuksen_tyopaikkoja: 24.5,
    Palvelujen_tyopaikkoja: 64.900000000000006,
  },
  {
    Kunta: "Humppila",
    Vakiluku: 2125,
    Vakiluvun_muutos: -1.7,
    Alle15v: 12.800000000000001,
    Ika15_64v: 55.0,
    Yli64v: 32.200000000000003,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.6000000000000001,
    Taajamaa: 62.0,
    Syntyneiden_enemmyys: -12,
    Muuttovoitto: -25,
    Perheita: 587,
    Asuntokuntia: 1086,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 80.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.699999999999999,
    Taloudellinen_huoltosuhde: 151.0,
    Tyopaikkaomavaraisuus: 58.5,
    Alueella_asuva_tyollinen_tyovoima: 861,
    Ika20_64v_tyollisyysaste: 75.0,
    Asuinkunnassaan_tyossakayvia: 36.799999999999997,
    Tyottomia: 10.1,
    Elakelaisia: 34.200000000000003,
    Alueella_olevia_tyopaikkoja: 504,
    Alkutuotannon_tyopaikkoja: 16.100000000000001,
    Jalostuksen_tyopaikkoja: 20.0,
    Palvelujen_tyopaikkoja: 61.5,
  },
  {
    Kunta: "Hyrynsalmi",
    Vakiluku: 2063,
    Vakiluvun_muutos: -1.5,
    Alle15v: 9.5,
    Ika15_64v: 45.200000000000003,
    Yli64v: 45.299999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.3999999999999999,
    Taajamaa: 57.0,
    Syntyneiden_enemmyys: -35,
    Muuttovoitto: -4,
    Perheita: 574,
    Asuntokuntia: 1102,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 16.399999999999999,
    Taloudellinen_huoltosuhde: 240.5,
    Tyopaikkaomavaraisuus: 80.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 615,
    Ika20_64v_tyollisyysaste: 65.200000000000003,
    Asuinkunnassaan_tyossakayvia: 58.700000000000003,
    Tyottomia: 14.6,
    Elakelaisia: 50.799999999999997,
    Alueella_olevia_tyopaikkoja: 493,
    Alkutuotannon_tyopaikkoja: 8.0999999999999996,
    Jalostuksen_tyopaikkoja: 13.199999999999999,
    Palvelujen_tyopaikkoja: 77.299999999999997,
  },
  {
    Kunta: "Hyvinkää",
    Vakiluku: 46901,
    Vakiluvun_muutos: 0.20000000000000001,
    Alle15v: 14.300000000000001,
    Ika15_64v: 61.5,
    Yli64v: 24.100000000000001,
    Ruotsinkielisia: 0.90000000000000002,
    Ulkomaan_kansalaisia: 5.2000000000000002,
    Taajamaa: 94.700000000000003,
    Syntyneiden_enemmyys: -194,
    Muuttovoitto: -156,
    Perheita: 12479,
    Asuntokuntia: 24117,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 45.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 34.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 32.0,
    Taloudellinen_huoltosuhde: 123.7,
    Tyopaikkaomavaraisuus: 95.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 20917,
    Ika20_64v_tyollisyysaste: 77.0,
    Asuinkunnassaan_tyossakayvia: 52.399999999999999,
    Tyottomia: 9.5,
    Elakelaisia: 26.399999999999999,
    Alueella_olevia_tyopaikkoja: 19913,
    Alkutuotannon_tyopaikkoja: 0.5,
    Jalostuksen_tyopaikkoja: 26.5,
    Palvelujen_tyopaikkoja: 72.0,
  },
  {
    Kunta: "Hämeenkyrö",
    Vakiluku: 10319,
    Vakiluvun_muutos: 0.59999999999999998,
    Alle15v: 16.600000000000001,
    Ika15_64v: 58.0,
    Yli64v: 25.300000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.6000000000000001,
    Taajamaa: 60.899999999999999,
    Syntyneiden_enemmyys: -51,
    Muuttovoitto: 80,
    Perheita: 2856,
    Asuntokuntia: 4873,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 83.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.699999999999999,
    Taloudellinen_huoltosuhde: 136.09999999999999,
    Tyopaikkaomavaraisuus: 66.5,
    Alueella_asuva_tyollinen_tyovoima: 4344,
    Ika20_64v_tyollisyysaste: 77.700000000000003,
    Asuinkunnassaan_tyossakayvia: 41.5,
    Tyottomia: 8.0999999999999996,
    Elakelaisia: 29.0,
    Alueella_olevia_tyopaikkoja: 2888,
    Alkutuotannon_tyopaikkoja: 8.0999999999999996,
    Jalostuksen_tyopaikkoja: 27.0,
    Palvelujen_tyopaikkoja: 63.200000000000003,
  },
  {
    Kunta: "Hämeenlinna",
    Vakiluku: 68319,
    Vakiluvun_muutos: 0.40000000000000002,
    Alle15v: 13.800000000000001,
    Ika15_64v: 59.100000000000001,
    Yli64v: 27.100000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 4.7999999999999998,
    Taajamaa: 88.599999999999994,
    Syntyneiden_enemmyys: -427,
    Muuttovoitto: -16,
    Perheita: 17889,
    Asuntokuntia: 36105,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 52.600000000000001,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 35.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 33.200000000000003,
    Taloudellinen_huoltosuhde: 140.40000000000001,
    Tyopaikkaomavaraisuus: 101.40000000000001,
    Alueella_asuva_tyollinen_tyovoima: 28302,
    Ika20_64v_tyollisyysaste: 74.700000000000003,
    Asuinkunnassaan_tyossakayvia: 70.200000000000003,
    Tyottomia: 10.1,
    Elakelaisia: 30.0,
    Alueella_olevia_tyopaikkoja: 28711,
    Alkutuotannon_tyopaikkoja: 2.5,
    Jalostuksen_tyopaikkoja: 20.300000000000001,
    Palvelujen_tyopaikkoja: 76.200000000000003,
  },
  {
    Kunta: "Ii",
    Vakiluku: 9766,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 20.800000000000001,
    Ika15_64v: 56.399999999999999,
    Yli64v: 22.699999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 0.59999999999999998,
    Taajamaa: 79.0,
    Syntyneiden_enemmyys: -1,
    Muuttovoitto: -95,
    Perheita: 2633,
    Asuntokuntia: 4200,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.199999999999999,
    Taloudellinen_huoltosuhde: 165.40000000000001,
    Tyopaikkaomavaraisuus: 67.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 3712,
    Ika20_64v_tyollisyysaste: 73.099999999999994,
    Asuinkunnassaan_tyossakayvia: 45.200000000000003,
    Tyottomia: 11.9,
    Elakelaisia: 26.5,
    Alueella_olevia_tyopaikkoja: 2489,
    Alkutuotannon_tyopaikkoja: 7.0999999999999996,
    Jalostuksen_tyopaikkoja: 23.199999999999999,
    Palvelujen_tyopaikkoja: 68.099999999999994,
  },
  {
    Kunta: "Iisalmi",
    Vakiluku: 20618,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 14.199999999999999,
    Ika15_64v: 56.600000000000001,
    Yli64v: 29.199999999999999,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 3.2000000000000002,
    Taajamaa: 76.700000000000003,
    Syntyneiden_enemmyys: -164,
    Muuttovoitto: -189,
    Perheita: 5531,
    Asuntokuntia: 10822,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 55.100000000000001,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 33.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.600000000000001,
    Taloudellinen_huoltosuhde: 157.90000000000001,
    Tyopaikkaomavaraisuus: 110.7,
    Alueella_asuva_tyollinen_tyovoima: 8065,
    Ika20_64v_tyollisyysaste: 72.5,
    Asuinkunnassaan_tyossakayvia: 78.5,
    Tyottomia: 12.1,
    Elakelaisia: 32.700000000000003,
    Alueella_olevia_tyopaikkoja: 8931,
    Alkutuotannon_tyopaikkoja: 3.5,
    Jalostuksen_tyopaikkoja: 28.0,
    Palvelujen_tyopaikkoja: 67.599999999999994,
  },
  {
    Kunta: "Iitti",
    Vakiluku: 6444,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 13.4,
    Ika15_64v: 52.799999999999997,
    Yli64v: 33.799999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.8999999999999999,
    Taajamaa: 59.799999999999997,
    Syntyneiden_enemmyys: -69,
    Muuttovoitto: -9,
    Perheita: 1745,
    Asuntokuntia: 3373,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 84.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.899999999999999,
    Taloudellinen_huoltosuhde: 164.80000000000001,
    Tyopaikkaomavaraisuus: 79.5,
    Alueella_asuva_tyollinen_tyovoima: 2456,
    Ika20_64v_tyollisyysaste: 74.799999999999997,
    Asuinkunnassaan_tyossakayvia: 48.399999999999999,
    Tyottomia: 10.0,
    Elakelaisia: 36.799999999999997,
    Alueella_olevia_tyopaikkoja: 1952,
    Alkutuotannon_tyopaikkoja: 9.0,
    Jalostuksen_tyopaikkoja: 37.5,
    Palvelujen_tyopaikkoja: 51.200000000000003,
  },
  {
    Kunta: "Ikaalinen",
    Vakiluku: 6850,
    Vakiluvun_muutos: 0.69999999999999996,
    Alle15v: 13.1,
    Ika15_64v: 53.399999999999999,
    Yli64v: 33.5,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.8999999999999999,
    Taajamaa: 60.0,
    Syntyneiden_enemmyys: -84,
    Muuttovoitto: 0,
    Perheita: 1855,
    Asuntokuntia: 3498,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 76.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.600000000000001,
    Taloudellinen_huoltosuhde: 176.19999999999999,
    Tyopaikkaomavaraisuus: 89.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 2463,
    Ika20_64v_tyollisyysaste: 72.299999999999997,
    Asuinkunnassaan_tyossakayvia: 59.0,
    Tyottomia: 9.8000000000000007,
    Elakelaisia: 37.200000000000003,
    Alueella_olevia_tyopaikkoja: 2209,
    Alkutuotannon_tyopaikkoja: 9.8000000000000007,
    Jalostuksen_tyopaikkoja: 19.100000000000001,
    Palvelujen_tyopaikkoja: 69.5,
  },
  {
    Kunta: "Ilmajoki",
    Vakiluku: 12343,
    Vakiluvun_muutos: -0.20000000000000001,
    Alle15v: 18.899999999999999,
    Ika15_64v: 58.100000000000001,
    Yli64v: 23.0,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.1000000000000001,
    Taajamaa: 76.900000000000006,
    Syntyneiden_enemmyys: -5,
    Muuttovoitto: -52,
    Perheita: 3481,
    Asuntokuntia: 5494,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 93.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 76.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 27.600000000000001,
    Taloudellinen_huoltosuhde: 126.2,
    Tyopaikkaomavaraisuus: 63.0,
    Alueella_asuva_tyollinen_tyovoima: 5469,
    Ika20_64v_tyollisyysaste: 81.400000000000006,
    Asuinkunnassaan_tyossakayvia: 38.200000000000003,
    Tyottomia: 6.0,
    Elakelaisia: 25.300000000000001,
    Alueella_olevia_tyopaikkoja: 3445,
    Alkutuotannon_tyopaikkoja: 10.4,
    Jalostuksen_tyopaikkoja: 22.5,
    Palvelujen_tyopaikkoja: 65.900000000000006,
  },
  {
    Kunta: "Ilomantsi",
    Vakiluku: 4406,
    Vakiluvun_muutos: -1.8999999999999999,
    Alle15v: 8.0999999999999996,
    Ika15_64v: 45.899999999999999,
    Yli64v: 46.0,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.6000000000000001,
    Taajamaa: 53.100000000000001,
    Syntyneiden_enemmyys: -99,
    Muuttovoitto: -3,
    Perheita: 1182,
    Asuntokuntia: 2483,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 87.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 16.800000000000001,
    Taloudellinen_huoltosuhde: 229.30000000000001,
    Tyopaikkaomavaraisuus: 97.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1364,
    Ika20_64v_tyollisyysaste: 65.599999999999994,
    Asuinkunnassaan_tyossakayvia: 75.200000000000003,
    Tyottomia: 15.0,
    Elakelaisia: 50.399999999999999,
    Alueella_olevia_tyopaikkoja: 1332,
    Alkutuotannon_tyopaikkoja: 9.3000000000000007,
    Jalostuksen_tyopaikkoja: 18.899999999999999,
    Palvelujen_tyopaikkoja: 70.0,
  },
  {
    Kunta: "Imatra",
    Vakiluku: 24919,
    Vakiluvun_muutos: -1.1000000000000001,
    Alle15v: 11.199999999999999,
    Ika15_64v: 56.200000000000003,
    Yli64v: 32.600000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 5.4000000000000004,
    Taajamaa: 97.400000000000006,
    Syntyneiden_enemmyys: -307,
    Muuttovoitto: -276,
    Perheita: 6626,
    Asuntokuntia: 13895,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 57.600000000000001,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 29.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.0,
    Taloudellinen_huoltosuhde: 174.69999999999999,
    Tyopaikkaomavaraisuus: 99.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 9177,
    Ika20_64v_tyollisyysaste: 68.599999999999994,
    Asuinkunnassaan_tyossakayvia: 67.900000000000006,
    Tyottomia: 14.5,
    Elakelaisia: 36.799999999999997,
    Alueella_olevia_tyopaikkoja: 9139,
    Alkutuotannon_tyopaikkoja: 0.69999999999999996,
    Jalostuksen_tyopaikkoja: 33.899999999999999,
    Palvelujen_tyopaikkoja: 64.299999999999997,
  },
  {
    Kunta: "Inari",
    Vakiluku: 7127,
    Vakiluvun_muutos: 1.1000000000000001,
    Alle15v: 12.0,
    Ika15_64v: 60.0,
    Yli64v: 28.0,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 4.2999999999999998,
    Taajamaa: 66.200000000000003,
    Syntyneiden_enemmyys: -48,
    Muuttovoitto: 66,
    Perheita: 1866,
    Asuntokuntia: 3420,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 88.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 31.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.5,
    Taloudellinen_huoltosuhde: 114.7,
    Tyopaikkaomavaraisuus: 98.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 3283,
    Ika20_64v_tyollisyysaste: 78.700000000000003,
    Asuinkunnassaan_tyossakayvia: 85.0,
    Tyottomia: 8.0999999999999996,
    Elakelaisia: 30.699999999999999,
    Alueella_olevia_tyopaikkoja: 3226,
    Alkutuotannon_tyopaikkoja: 5.2000000000000002,
    Jalostuksen_tyopaikkoja: 7.2999999999999998,
    Palvelujen_tyopaikkoja: 86.0,
  },
  {
    Kunta: "Inkoo",
    Vakiluku: 5379,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 14.199999999999999,
    Ika15_64v: 58.799999999999997,
    Yli64v: 26.899999999999999,
    Ruotsinkielisia: 51.600000000000001,
    Ulkomaan_kansalaisia: 3.7999999999999998,
    Taajamaa: 41.799999999999997,
    Syntyneiden_enemmyys: -34,
    Muuttovoitto: 26,
    Perheita: 1591,
    Asuntokuntia: 2487,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 87.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 14.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 36.399999999999999,
    Taloudellinen_huoltosuhde: 121.59999999999999,
    Tyopaikkaomavaraisuus: 58.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 2430,
    Ika20_64v_tyollisyysaste: 81.799999999999997,
    Asuinkunnassaan_tyossakayvia: 35.600000000000001,
    Tyottomia: 6.2999999999999998,
    Elakelaisia: 28.5,
    Alueella_olevia_tyopaikkoja: 1417,
    Alkutuotannon_tyopaikkoja: 7.5999999999999996,
    Jalostuksen_tyopaikkoja: 23.399999999999999,
    Palvelujen_tyopaikkoja: 66.700000000000003,
  },
  {
    Kunta: "Isojoki",
    Vakiluku: 1814,
    Vakiluvun_muutos: -2.1000000000000001,
    Alle15v: 11.300000000000001,
    Ika15_64v: 52.600000000000001,
    Yli64v: 36.100000000000001,
    Ruotsinkielisia: 0.80000000000000004,
    Ulkomaan_kansalaisia: 4.0999999999999996,
    Taajamaa: 40.799999999999997,
    Syntyneiden_enemmyys: -48,
    Muuttovoitto: -2,
    Perheita: 481,
    Asuntokuntia: 928,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 63.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 16.899999999999999,
    Taloudellinen_huoltosuhde: 146.90000000000001,
    Tyopaikkaomavaraisuus: 86.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 750,
    Ika20_64v_tyollisyysaste: 78.5,
    Asuinkunnassaan_tyossakayvia: 67.200000000000003,
    Tyottomia: 6.2999999999999998,
    Elakelaisia: 39.5,
    Alueella_olevia_tyopaikkoja: 652,
    Alkutuotannon_tyopaikkoja: 19.5,
    Jalostuksen_tyopaikkoja: 30.399999999999999,
    Palvelujen_tyopaikkoja: 48.5,
  },
  {
    Kunta: "Isokyrö",
    Vakiluku: 4357,
    Vakiluvun_muutos: -1.1000000000000001,
    Alle15v: 14.9,
    Ika15_64v: 55.5,
    Yli64v: 29.600000000000001,
    Ruotsinkielisia: 0.69999999999999996,
    Ulkomaan_kansalaisia: 1.3999999999999999,
    Taajamaa: 69.799999999999997,
    Syntyneiden_enemmyys: -39,
    Muuttovoitto: -31,
    Perheita: 1169,
    Asuntokuntia: 2086,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.600000000000001,
    Taloudellinen_huoltosuhde: 145.90000000000001,
    Tyopaikkaomavaraisuus: 77.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 1792,
    Ika20_64v_tyollisyysaste: 78.799999999999997,
    Asuinkunnassaan_tyossakayvia: 43.0,
    Tyottomia: 5.5,
    Elakelaisia: 32.299999999999997,
    Alueella_olevia_tyopaikkoja: 1382,
    Alkutuotannon_tyopaikkoja: 12.6,
    Jalostuksen_tyopaikkoja: 20.899999999999999,
    Palvelujen_tyopaikkoja: 64.799999999999997,
  },
  {
    Kunta: "Janakkala",
    Vakiluku: 16123,
    Vakiluvun_muutos: -1.0,
    Alle15v: 15.4,
    Ika15_64v: 58.899999999999999,
    Yli64v: 25.699999999999999,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 2.7000000000000002,
    Taajamaa: 77.400000000000006,
    Syntyneiden_enemmyys: -120,
    Muuttovoitto: -76,
    Perheita: 4528,
    Asuntokuntia: 7859,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 73.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.399999999999999,
    Taloudellinen_huoltosuhde: 129.30000000000001,
    Tyopaikkaomavaraisuus: 71.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 7101,
    Ika20_64v_tyollisyysaste: 79.0,
    Asuinkunnassaan_tyossakayvia: 39.100000000000001,
    Tyottomia: 7.7999999999999998,
    Elakelaisia: 28.399999999999999,
    Alueella_olevia_tyopaikkoja: 5048,
    Alkutuotannon_tyopaikkoja: 5.2999999999999998,
    Jalostuksen_tyopaikkoja: 30.399999999999999,
    Palvelujen_tyopaikkoja: 63.0,
  },
  {
    Kunta: "Joensuu",
    Vakiluku: 78062,
    Vakiluvun_muutos: 0.69999999999999996,
    Alle15v: 12.9,
    Ika15_64v: 63.700000000000003,
    Yli64v: 23.399999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 5.2000000000000002,
    Taajamaa: 90.0,
    Syntyneiden_enemmyys: -384,
    Muuttovoitto: -142,
    Perheita: 19310,
    Asuntokuntia: 43139,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 48.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 44.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 79.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 33.0,
    Taloudellinen_huoltosuhde: 148.5,
    Tyopaikkaomavaraisuus: 113.7,
    Alueella_asuva_tyollinen_tyovoima: 31189,
    Ika20_64v_tyollisyysaste: 66.799999999999997,
    Asuinkunnassaan_tyossakayvia: 82.200000000000003,
    Tyottomia: 13.5,
    Elakelaisia: 26.199999999999999,
    Alueella_olevia_tyopaikkoja: 35453,
    Alkutuotannon_tyopaikkoja: 1.7,
    Jalostuksen_tyopaikkoja: 19.800000000000001,
    Palvelujen_tyopaikkoja: 77.599999999999994,
  },
  {
    Kunta: "Jokioinen",
    Vakiluku: 4916,
    Vakiluvun_muutos: -1.5,
    Alle15v: 14.0,
    Ika15_64v: 56.399999999999999,
    Yli64v: 29.600000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 2.7000000000000002,
    Taajamaa: 62.100000000000001,
    Syntyneiden_enemmyys: -40,
    Muuttovoitto: -49,
    Perheita: 1448,
    Asuntokuntia: 2371,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 88.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.699999999999999,
    Taloudellinen_huoltosuhde: 138.19999999999999,
    Tyopaikkaomavaraisuus: 79.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 2095,
    Ika20_64v_tyollisyysaste: 79.599999999999994,
    Asuinkunnassaan_tyossakayvia: 38.5,
    Tyottomia: 8.1999999999999993,
    Elakelaisia: 31.199999999999999,
    Alueella_olevia_tyopaikkoja: 1664,
    Alkutuotannon_tyopaikkoja: 5.4000000000000004,
    Jalostuksen_tyopaikkoja: 27.100000000000001,
    Palvelujen_tyopaikkoja: 66.0,
  },
  {
    Kunta: "Jomala",
    Vakiluku: 5697,
    Vakiluvun_muutos: 1.6000000000000001,
    Alle15v: 20.100000000000001,
    Ika15_64v: 63.799999999999997,
    Yli64v: 16.199999999999999,
    Ruotsinkielisia: 87.5,
    Ulkomaan_kansalaisia: 8.1999999999999993,
    Taajamaa: 69.900000000000006,
    Syntyneiden_enemmyys: 33,
    Muuttovoitto: 59,
    Perheita: 1659,
    Asuntokuntia: 2379,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 86.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 32.799999999999997,
    Taloudellinen_huoltosuhde: 89.799999999999997,
    Tyopaikkaomavaraisuus: 85.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 2956,
    Ika20_64v_tyollisyysaste: 87.599999999999994,
    Asuinkunnassaan_tyossakayvia: 31.899999999999999,
    Tyottomia: 2.6000000000000001,
    Elakelaisia: 16.300000000000001,
    Alueella_olevia_tyopaikkoja: 2530,
    Alkutuotannon_tyopaikkoja: 2.7000000000000002,
    Jalostuksen_tyopaikkoja: 23.399999999999999,
    Palvelujen_tyopaikkoja: 70.299999999999997,
  },
  {
    Kunta: "Joroinen",
    Vakiluku: 4590,
    Vakiluvun_muutos: 1.1000000000000001,
    Alle15v: 13.0,
    Ika15_64v: 53.899999999999999,
    Yli64v: 33.100000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 4.9000000000000004,
    Taajamaa: 58.299999999999997,
    Syntyneiden_enemmyys: -48,
    Muuttovoitto: 18,
    Perheita: 1294,
    Asuntokuntia: 2333,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 90.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.100000000000001,
    Taloudellinen_huoltosuhde: 159.0,
    Tyopaikkaomavaraisuus: 74.0,
    Alueella_asuva_tyollinen_tyovoima: 1753,
    Ika20_64v_tyollisyysaste: 74.200000000000003,
    Asuinkunnassaan_tyossakayvia: 46.600000000000001,
    Tyottomia: 9.0999999999999996,
    Elakelaisia: 37.299999999999997,
    Alueella_olevia_tyopaikkoja: 1298,
    Alkutuotannon_tyopaikkoja: 25.300000000000001,
    Jalostuksen_tyopaikkoja: 21.600000000000001,
    Palvelujen_tyopaikkoja: 51.100000000000001,
  },
  {
    Kunta: "Joutsa",
    Vakiluku: 4079,
    Vakiluvun_muutos: -2.2000000000000002,
    Alle15v: 9.8000000000000007,
    Ika15_64v: 49.100000000000001,
    Yli64v: 41.100000000000001,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 58.700000000000003,
    Syntyneiden_enemmyys: -94,
    Muuttovoitto: -27,
    Perheita: 1081,
    Asuntokuntia: 2272,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 86.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.600000000000001,
    Taloudellinen_huoltosuhde: 196.0,
    Tyopaikkaomavaraisuus: 90.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1409,
    Ika20_64v_tyollisyysaste: 71.099999999999994,
    Asuinkunnassaan_tyossakayvia: 66.5,
    Tyottomia: 13.300000000000001,
    Elakelaisia: 44.0,
    Alueella_olevia_tyopaikkoja: 1278,
    Alkutuotannon_tyopaikkoja: 13.6,
    Jalostuksen_tyopaikkoja: 21.300000000000001,
    Palvelujen_tyopaikkoja: 63.600000000000001,
  },
  {
    Kunta: "Juuka",
    Vakiluku: 4259,
    Vakiluvun_muutos: -2.1000000000000001,
    Alle15v: 8.5999999999999996,
    Ika15_64v: 51.0,
    Yli64v: 40.299999999999997,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 46.399999999999999,
    Syntyneiden_enemmyys: -72,
    Muuttovoitto: -46,
    Perheita: 1127,
    Asuntokuntia: 2398,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.5,
    Taloudellinen_huoltosuhde: 214.5,
    Tyopaikkaomavaraisuus: 96.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1384,
    Ika20_64v_tyollisyysaste: 64.799999999999997,
    Asuinkunnassaan_tyossakayvia: 77.299999999999997,
    Tyottomia: 16.699999999999999,
    Elakelaisia: 44.899999999999999,
    Alueella_olevia_tyopaikkoja: 1338,
    Alkutuotannon_tyopaikkoja: 9.4000000000000004,
    Jalostuksen_tyopaikkoja: 27.899999999999999,
    Palvelujen_tyopaikkoja: 61.299999999999997,
  },
  {
    Kunta: "Juupajoki",
    Vakiluku: 1708,
    Vakiluvun_muutos: -3.3999999999999999,
    Alle15v: 13.5,
    Ika15_64v: 52.600000000000001,
    Yli64v: 33.799999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.3,
    Taajamaa: 44.799999999999997,
    Syntyneiden_enemmyys: -20,
    Muuttovoitto: -42,
    Perheita: 488,
    Asuntokuntia: 840,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 90.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.600000000000001,
    Taloudellinen_huoltosuhde: 151.09999999999999,
    Tyopaikkaomavaraisuus: 93.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 704,
    Ika20_64v_tyollisyysaste: 77.400000000000006,
    Asuinkunnassaan_tyossakayvia: 47.299999999999997,
    Tyottomia: 6.5999999999999996,
    Elakelaisia: 36.100000000000001,
    Alueella_olevia_tyopaikkoja: 660,
    Alkutuotannon_tyopaikkoja: 11.5,
    Jalostuksen_tyopaikkoja: 44.799999999999997,
    Palvelujen_tyopaikkoja: 42.399999999999999,
  },
  {
    Kunta: "Juva",
    Vakiluku: 5734,
    Vakiluvun_muutos: -0.59999999999999998,
    Alle15v: 11.1,
    Ika15_64v: 50.600000000000001,
    Yli64v: 38.299999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.0,
    Taajamaa: 50.899999999999999,
    Syntyneiden_enemmyys: -66,
    Muuttovoitto: -40,
    Perheita: 1557,
    Asuntokuntia: 3072,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 81.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.300000000000001,
    Taloudellinen_huoltosuhde: 167.09999999999999,
    Tyopaikkaomavaraisuus: 82.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 2160,
    Ika20_64v_tyollisyysaste: 76.200000000000003,
    Asuinkunnassaan_tyossakayvia: 62.799999999999997,
    Tyottomia: 8.4000000000000004,
    Elakelaisia: 41.5,
    Alueella_olevia_tyopaikkoja: 1787,
    Alkutuotannon_tyopaikkoja: 18.100000000000001,
    Jalostuksen_tyopaikkoja: 17.300000000000001,
    Palvelujen_tyopaikkoja: 63.0,
  },
  {
    Kunta: "Jyväskylä",
    Vakiluku: 147746,
    Vakiluvun_muutos: 1.3,
    Alle15v: 14.199999999999999,
    Ika15_64v: 66.599999999999994,
    Yli64v: 19.100000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 4.5,
    Taajamaa: 95.400000000000006,
    Syntyneiden_enemmyys: -73,
    Muuttovoitto: 399,
    Perheita: 36651,
    Asuntokuntia: 80333,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 35.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 46.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 80.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 37.700000000000003,
    Taloudellinen_huoltosuhde: 130.90000000000001,
    Tyopaikkaomavaraisuus: 106.09999999999999,
    Alueella_asuva_tyollinen_tyovoima: 63193,
    Ika20_64v_tyollisyysaste: 69.299999999999997,
    Asuinkunnassaan_tyossakayvia: 83.400000000000006,
    Tyottomia: 12.300000000000001,
    Elakelaisia: 21.600000000000001,
    Alueella_olevia_tyopaikkoja: 67071,
    Alkutuotannon_tyopaikkoja: 0.69999999999999996,
    Jalostuksen_tyopaikkoja: 16.699999999999999,
    Palvelujen_tyopaikkoja: 81.299999999999997,
  },
  {
    Kunta: "Jämijärvi",
    Vakiluku: 1682,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 14.1,
    Ika15_64v: 53.600000000000001,
    Yli64v: 32.200000000000003,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.7000000000000002,
    Taajamaa: 35.299999999999997,
    Syntyneiden_enemmyys: -22,
    Muuttovoitto: 5,
    Perheita: 486,
    Asuntokuntia: 798,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.100000000000001,
    Taloudellinen_huoltosuhde: 147.5,
    Tyopaikkaomavaraisuus: 66.0,
    Alueella_asuva_tyollinen_tyovoima: 680,
    Ika20_64v_tyollisyysaste: 79.700000000000003,
    Asuinkunnassaan_tyossakayvia: 43.399999999999999,
    Tyottomia: 7.2000000000000002,
    Elakelaisia: 35.200000000000003,
    Alueella_olevia_tyopaikkoja: 449,
    Alkutuotannon_tyopaikkoja: 23.199999999999999,
    Jalostuksen_tyopaikkoja: 25.199999999999999,
    Palvelujen_tyopaikkoja: 49.399999999999999,
  },
  {
    Kunta: "Jämsä",
    Vakiluku: 19182,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 11.5,
    Ika15_64v: 53.799999999999997,
    Yli64v: 34.799999999999997,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 74.400000000000006,
    Syntyneiden_enemmyys: -199,
    Muuttovoitto: -127,
    Perheita: 5251,
    Asuntokuntia: 10314,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 72.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.199999999999999,
    Taloudellinen_huoltosuhde: 170.0,
    Tyopaikkaomavaraisuus: 97.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 7166,
    Ika20_64v_tyollisyysaste: 72.099999999999994,
    Asuinkunnassaan_tyossakayvia: 77.5,
    Tyottomia: 13.800000000000001,
    Elakelaisia: 37.799999999999997,
    Alueella_olevia_tyopaikkoja: 6978,
    Alkutuotannon_tyopaikkoja: 3.7000000000000002,
    Jalostuksen_tyopaikkoja: 32.700000000000003,
    Palvelujen_tyopaikkoja: 62.600000000000001,
  },
  {
    Kunta: "Järvenpää",
    Vakiluku: 46490,
    Vakiluvun_muutos: 1.8999999999999999,
    Alle15v: 16.199999999999999,
    Ika15_64v: 63.899999999999999,
    Yli64v: 20.0,
    Ruotsinkielisia: 1.1000000000000001,
    Ulkomaan_kansalaisia: 5.7999999999999998,
    Taajamaa: 99.900000000000006,
    Syntyneiden_enemmyys: 73,
    Muuttovoitto: 244,
    Perheita: 12369,
    Asuntokuntia: 23360,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 49.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 35.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 35.600000000000001,
    Taloudellinen_huoltosuhde: 110.7,
    Tyopaikkaomavaraisuus: 65.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 21661,
    Ika20_64v_tyollisyysaste: 79.0,
    Asuinkunnassaan_tyossakayvia: 33.799999999999997,
    Tyottomia: 8.8000000000000007,
    Elakelaisia: 22.0,
    Alueella_olevia_tyopaikkoja: 14245,
    Alkutuotannon_tyopaikkoja: 0.10000000000000001,
    Jalostuksen_tyopaikkoja: 22.0,
    Palvelujen_tyopaikkoja: 76.200000000000003,
  },
  {
    Kunta: "Kaarina",
    Vakiluku: 36339,
    Vakiluvun_muutos: 1.3999999999999999,
    Alle15v: 18.300000000000001,
    Ika15_64v: 60.100000000000001,
    Yli64v: 21.600000000000001,
    Ruotsinkielisia: 4.9000000000000004,
    Ulkomaan_kansalaisia: 3.2999999999999998,
    Taajamaa: 95.900000000000006,
    Syntyneiden_enemmyys: 65,
    Muuttovoitto: 277,
    Perheita: 10471,
    Asuntokuntia: 16527,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 67.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 78.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 41.100000000000001,
    Taloudellinen_huoltosuhde: 115.2,
    Tyopaikkaomavaraisuus: 64.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 16655,
    Ika20_64v_tyollisyysaste: 82.400000000000006,
    Asuinkunnassaan_tyossakayvia: 27.0,
    Tyottomia: 5.7999999999999998,
    Elakelaisia: 23.600000000000001,
    Alueella_olevia_tyopaikkoja: 10672,
    Alkutuotannon_tyopaikkoja: 1.1000000000000001,
    Jalostuksen_tyopaikkoja: 30.899999999999999,
    Palvelujen_tyopaikkoja: 66.200000000000003,
  },
  {
    Kunta: "Kaavi",
    Vakiluku: 2628,
    Vakiluvun_muutos: -2.2999999999999998,
    Alle15v: 10.1,
    Ika15_64v: 51.0,
    Yli64v: 39.0,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.6000000000000001,
    Taajamaa: 46.100000000000001,
    Syntyneiden_enemmyys: -41,
    Muuttovoitto: -22,
    Perheita: 728,
    Asuntokuntia: 1433,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 87.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 15.1,
    Taloudellinen_huoltosuhde: 211.19999999999999,
    Tyopaikkaomavaraisuus: 88.5,
    Alueella_asuva_tyollinen_tyovoima: 864,
    Ika20_64v_tyollisyysaste: 64.200000000000003,
    Asuinkunnassaan_tyossakayvia: 56.899999999999999,
    Tyottomia: 14.300000000000001,
    Elakelaisia: 45.399999999999999,
    Alueella_olevia_tyopaikkoja: 765,
    Alkutuotannon_tyopaikkoja: 12.800000000000001,
    Jalostuksen_tyopaikkoja: 24.100000000000001,
    Palvelujen_tyopaikkoja: 61.799999999999997,
  },
  {
    Kunta: "Kajaani",
    Vakiluku: 36513,
    Vakiluvun_muutos: 0.59999999999999998,
    Alle15v: 14.9,
    Ika15_64v: 60.399999999999999,
    Yli64v: 24.699999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 5.4000000000000004,
    Taajamaa: 88.5,
    Syntyneiden_enemmyys: -220,
    Muuttovoitto: -391,
    Perheita: 9314,
    Asuntokuntia: 18850,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 52.100000000000001,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 34.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 77.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 30.5,
    Taloudellinen_huoltosuhde: 143.0,
    Tyopaikkaomavaraisuus: 105.8,
    Alueella_asuva_tyollinen_tyovoima: 14934,
    Ika20_64v_tyollisyysaste: 72.900000000000006,
    Asuinkunnassaan_tyossakayvia: 86.200000000000003,
    Tyottomia: 9.6999999999999993,
    Elakelaisia: 28.399999999999999,
    Alueella_olevia_tyopaikkoja: 15797,
    Alkutuotannon_tyopaikkoja: 2.1000000000000001,
    Jalostuksen_tyopaikkoja: 16.5,
    Palvelujen_tyopaikkoja: 80.799999999999997,
  },
  {
    Kunta: "Kalajoki",
    Vakiluku: 12372,
    Vakiluvun_muutos: 0.29999999999999999,
    Alle15v: 17.199999999999999,
    Ika15_64v: 55.200000000000003,
    Yli64v: 27.600000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 3.2999999999999998,
    Taajamaa: 77.400000000000006,
    Syntyneiden_enemmyys: -11,
    Muuttovoitto: -53,
    Perheita: 3384,
    Asuntokuntia: 5478,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.0,
    Taloudellinen_huoltosuhde: 148.5,
    Tyopaikkaomavaraisuus: 92.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 4964,
    Ika20_64v_tyollisyysaste: 78.0,
    Asuinkunnassaan_tyossakayvia: 70.599999999999994,
    Tyottomia: 7.2000000000000002,
    Elakelaisia: 29.800000000000001,
    Alueella_olevia_tyopaikkoja: 4598,
    Alkutuotannon_tyopaikkoja: 11.199999999999999,
    Jalostuksen_tyopaikkoja: 32.899999999999999,
    Palvelujen_tyopaikkoja: 54.600000000000001,
  },
  {
    Kunta: "Kangasala",
    Vakiluku: 33473,
    Vakiluvun_muutos: 1.6000000000000001,
    Alle15v: 17.899999999999999,
    Ika15_64v: 61.0,
    Yli64v: 21.199999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.0,
    Taajamaa: 87.0,
    Syntyneiden_enemmyys: -20,
    Muuttovoitto: 472,
    Perheita: 9446,
    Asuntokuntia: 15427,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 64.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 78.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 36.799999999999997,
    Taloudellinen_huoltosuhde: 117.8,
    Tyopaikkaomavaraisuus: 58.899999999999999,
    Alueella_asuva_tyollinen_tyovoima: 15130,
    Ika20_64v_tyollisyysaste: 81.599999999999994,
    Asuinkunnassaan_tyossakayvia: 34.600000000000001,
    Tyottomia: 6.5,
    Elakelaisia: 23.5,
    Alueella_olevia_tyopaikkoja: 8909,
    Alkutuotannon_tyopaikkoja: 3.1000000000000001,
    Jalostuksen_tyopaikkoja: 27.0,
    Palvelujen_tyopaikkoja: 67.700000000000003,
  },
  {
    Kunta: "Kangasniemi",
    Vakiluku: 5114,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 10.800000000000001,
    Ika15_64v: 50.399999999999999,
    Yli64v: 38.799999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.2000000000000002,
    Taajamaa: 51.200000000000003,
    Syntyneiden_enemmyys: -74,
    Muuttovoitto: -24,
    Perheita: 1361,
    Asuntokuntia: 2740,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 84.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.0,
    Taloudellinen_huoltosuhde: 184.30000000000001,
    Tyopaikkaomavaraisuus: 87.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 1813,
    Ika20_64v_tyollisyysaste: 73.200000000000003,
    Asuinkunnassaan_tyossakayvia: 72.299999999999997,
    Tyottomia: 10.0,
    Elakelaisia: 42.5,
    Alueella_olevia_tyopaikkoja: 1593,
    Alkutuotannon_tyopaikkoja: 14.9,
    Jalostuksen_tyopaikkoja: 26.5,
    Palvelujen_tyopaikkoja: 56.299999999999997,
  },
  {
    Kunta: "Kankaanpää",
    Vakiluku: 12394,
    Vakiluvun_muutos: -1.1000000000000001,
    Alle15v: 13.699999999999999,
    Ika15_64v: 55.600000000000001,
    Yli64v: 30.699999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 4.2999999999999998,
    Taajamaa: 69.900000000000006,
    Syntyneiden_enemmyys: -127,
    Muuttovoitto: -103,
    Perheita: 3345,
    Asuntokuntia: 6400,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 78.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 29.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.300000000000001,
    Taloudellinen_huoltosuhde: 158.5,
    Tyopaikkaomavaraisuus: 109.8,
    Alueella_asuva_tyollinen_tyovoima: 4846,
    Ika20_64v_tyollisyysaste: 72.599999999999994,
    Asuinkunnassaan_tyossakayvia: 80.0,
    Tyottomia: 9.8000000000000007,
    Elakelaisia: 34.399999999999999,
    Alueella_olevia_tyopaikkoja: 5320,
    Alkutuotannon_tyopaikkoja: 5.5999999999999996,
    Jalostuksen_tyopaikkoja: 24.300000000000001,
    Palvelujen_tyopaikkoja: 69.0,
  },
  {
    Kunta: "Kannonkoski",
    Vakiluku: 1217,
    Vakiluvun_muutos: -4.0999999999999996,
    Alle15v: 11.199999999999999,
    Ika15_64v: 50.0,
    Yli64v: 38.899999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.2,
    Taajamaa: 36.0,
    Syntyneiden_enemmyys: -23,
    Muuttovoitto: -30,
    Perheita: 321,
    Asuntokuntia: 628,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.399999999999999,
    Taloudellinen_huoltosuhde: 197.90000000000001,
    Tyopaikkaomavaraisuus: 89.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 426,
    Ika20_64v_tyollisyysaste: 68.5,
    Asuinkunnassaan_tyossakayvia: 58.700000000000003,
    Tyottomia: 13.1,
    Elakelaisia: 42.700000000000003,
    Alueella_olevia_tyopaikkoja: 382,
    Alkutuotannon_tyopaikkoja: 16.5,
    Jalostuksen_tyopaikkoja: 23.0,
    Palvelujen_tyopaikkoja: 58.899999999999999,
  },
  {
    Kunta: "Kannus",
    Vakiluku: 5246,
    Vakiluvun_muutos: -2.0,
    Alle15v: 17.800000000000001,
    Ika15_64v: 55.5,
    Yli64v: 26.699999999999999,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 73.799999999999997,
    Syntyneiden_enemmyys: -23,
    Muuttovoitto: -95,
    Perheita: 1434,
    Asuntokuntia: 2429,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 88.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.100000000000001,
    Taloudellinen_huoltosuhde: 140.5,
    Tyopaikkaomavaraisuus: 92.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 2225,
    Ika20_64v_tyollisyysaste: 78.700000000000003,
    Asuinkunnassaan_tyossakayvia: 63.100000000000001,
    Tyottomia: 7.0999999999999996,
    Elakelaisia: 28.800000000000001,
    Alueella_olevia_tyopaikkoja: 2064,
    Alkutuotannon_tyopaikkoja: 12.199999999999999,
    Jalostuksen_tyopaikkoja: 27.699999999999999,
    Palvelujen_tyopaikkoja: 59.100000000000001,
  },
  {
    Kunta: "Karijoki",
    Vakiluku: 1188,
    Vakiluvun_muutos: -1.0,
    Alle15v: 11.4,
    Ika15_64v: 50.0,
    Yli64v: 38.600000000000001,
    Ruotsinkielisia: 1.7,
    Ulkomaan_kansalaisia: 2.2000000000000002,
    Taajamaa: 39.700000000000003,
    Syntyneiden_enemmyys: -20,
    Muuttovoitto: -3,
    Perheita: 313,
    Asuntokuntia: 635,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 63.899999999999999,
    Korkeaasteen_tutkinnon_suorittaneita15v: 13.9,
    Taloudellinen_huoltosuhde: 166.69999999999999,
    Tyopaikkaomavaraisuus: 76.0,
    Alueella_asuva_tyollinen_tyovoima: 450,
    Ika20_64v_tyollisyysaste: 74.900000000000006,
    Asuinkunnassaan_tyossakayvia: 50.0,
    Tyottomia: 9.8000000000000007,
    Elakelaisia: 42.0,
    Alueella_olevia_tyopaikkoja: 342,
    Alkutuotannon_tyopaikkoja: 28.699999999999999,
    Jalostuksen_tyopaikkoja: 26.300000000000001,
    Palvelujen_tyopaikkoja: 43.600000000000001,
  },
  {
    Kunta: "Karkkila",
    Vakiluku: 8581,
    Vakiluvun_muutos: -0.29999999999999999,
    Alle15v: 13.9,
    Ika15_64v: 57.700000000000003,
    Yli64v: 28.399999999999999,
    Ruotsinkielisia: 0.69999999999999996,
    Ulkomaan_kansalaisia: 7.4000000000000004,
    Taajamaa: 85.599999999999994,
    Syntyneiden_enemmyys: -80,
    Muuttovoitto: -62,
    Perheita: 2310,
    Asuntokuntia: 4310,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 68.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 26.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.199999999999999,
    Taloudellinen_huoltosuhde: 141.30000000000001,
    Tyopaikkaomavaraisuus: 77.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 3566,
    Ika20_64v_tyollisyysaste: 76.400000000000006,
    Asuinkunnassaan_tyossakayvia: 53.700000000000003,
    Tyottomia: 9.9000000000000004,
    Elakelaisia: 30.899999999999999,
    Alueella_olevia_tyopaikkoja: 2770,
    Alkutuotannon_tyopaikkoja: 1.3999999999999999,
    Jalostuksen_tyopaikkoja: 38.899999999999999,
    Palvelujen_tyopaikkoja: 58.399999999999999,
  },
  {
    Kunta: "Karstula",
    Vakiluku: 3625,
    Vakiluvun_muutos: -1.1000000000000001,
    Alle15v: 10.9,
    Ika15_64v: 50.799999999999997,
    Yli64v: 38.299999999999997,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.8999999999999999,
    Taajamaa: 50.600000000000001,
    Syntyneiden_enemmyys: -51,
    Muuttovoitto: -23,
    Perheita: 1023,
    Asuntokuntia: 1856,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.199999999999999,
    Taloudellinen_huoltosuhde: 189.0,
    Tyopaikkaomavaraisuus: 99.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1268,
    Ika20_64v_tyollisyysaste: 73.099999999999994,
    Asuinkunnassaan_tyossakayvia: 72.200000000000003,
    Tyottomia: 12.199999999999999,
    Elakelaisia: 41.399999999999999,
    Alueella_olevia_tyopaikkoja: 1258,
    Alkutuotannon_tyopaikkoja: 16.600000000000001,
    Jalostuksen_tyopaikkoja: 30.399999999999999,
    Palvelujen_tyopaikkoja: 51.600000000000001,
  },
  {
    Kunta: "Karvia",
    Vakiluku: 2216,
    Vakiluvun_muutos: -1.1000000000000001,
    Alle15v: 12.6,
    Ika15_64v: 51.600000000000001,
    Yli64v: 35.799999999999997,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 4.9000000000000004,
    Taajamaa: 33.899999999999999,
    Syntyneiden_enemmyys: -40,
    Muuttovoitto: -4,
    Perheita: 605,
    Asuntokuntia: 1137,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 14.5,
    Taloudellinen_huoltosuhde: 161.09999999999999,
    Tyopaikkaomavaraisuus: 81.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 858,
    Ika20_64v_tyollisyysaste: 77.0,
    Asuinkunnassaan_tyossakayvia: 66.099999999999994,
    Tyottomia: 8.5999999999999996,
    Elakelaisia: 38.899999999999999,
    Alueella_olevia_tyopaikkoja: 701,
    Alkutuotannon_tyopaikkoja: 22.399999999999999,
    Jalostuksen_tyopaikkoja: 26.100000000000001,
    Palvelujen_tyopaikkoja: 49.399999999999999,
  },
  {
    Kunta: "Kaskinen",
    Vakiluku: 1208,
    Vakiluvun_muutos: -3.7999999999999998,
    Alle15v: 12.5,
    Ika15_64v: 44.399999999999999,
    Yli64v: 43.100000000000001,
    Ruotsinkielisia: 27.5,
    Ulkomaan_kansalaisia: 11.5,
    Taajamaa: 99.799999999999997,
    Syntyneiden_enemmyys: -13,
    Muuttovoitto: -66,
    Perheita: 347,
    Asuntokuntia: 646,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 68.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 64.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.100000000000001,
    Taloudellinen_huoltosuhde: 186.09999999999999,
    Tyopaikkaomavaraisuus: 99.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 439,
    Ika20_64v_tyollisyysaste: 76.5,
    Asuinkunnassaan_tyossakayvia: 46.700000000000003,
    Tyottomia: 9.9000000000000004,
    Elakelaisia: 43.5,
    Alueella_olevia_tyopaikkoja: 435,
    Alkutuotannon_tyopaikkoja: 1.1000000000000001,
    Jalostuksen_tyopaikkoja: 43.399999999999999,
    Palvelujen_tyopaikkoja: 53.600000000000001,
  },
  {
    Kunta: "Kauhajoki",
    Vakiluku: 12618,
    Vakiluvun_muutos: -1.0,
    Alle15v: 14.4,
    Ika15_64v: 55.5,
    Yli64v: 30.100000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 3.0,
    Taajamaa: 68.700000000000003,
    Syntyneiden_enemmyys: -85,
    Muuttovoitto: -136,
    Perheita: 3467,
    Asuntokuntia: 6313,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.5,
    Taloudellinen_huoltosuhde: 154.0,
    Tyopaikkaomavaraisuus: 103.2,
    Alueella_asuva_tyollinen_tyovoima: 5019,
    Ika20_64v_tyollisyysaste: 73.900000000000006,
    Asuinkunnassaan_tyossakayvia: 75.700000000000003,
    Tyottomia: 9.9000000000000004,
    Elakelaisia: 33.399999999999999,
    Alueella_olevia_tyopaikkoja: 5178,
    Alkutuotannon_tyopaikkoja: 8.5,
    Jalostuksen_tyopaikkoja: 26.800000000000001,
    Palvelujen_tyopaikkoja: 63.799999999999997,
  },
  {
    Kunta: "Kauhava",
    Vakiluku: 15165,
    Vakiluvun_muutos: 0.29999999999999999,
    Alle15v: 14.199999999999999,
    Ika15_64v: 54.899999999999999,
    Yli64v: 30.800000000000001,
    Ruotsinkielisia: 0.69999999999999996,
    Ulkomaan_kansalaisia: 4.7999999999999998,
    Taajamaa: 66.5,
    Syntyneiden_enemmyys: -132,
    Muuttovoitto: -161,
    Perheita: 4163,
    Asuntokuntia: 7335,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.0,
    Taloudellinen_huoltosuhde: 150.30000000000001,
    Tyopaikkaomavaraisuus: 101.09999999999999,
    Alueella_asuva_tyollinen_tyovoima: 6040,
    Ika20_64v_tyollisyysaste: 78.200000000000003,
    Asuinkunnassaan_tyossakayvia: 75.5,
    Tyottomia: 6.5999999999999996,
    Elakelaisia: 34.399999999999999,
    Alueella_olevia_tyopaikkoja: 6106,
    Alkutuotannon_tyopaikkoja: 10.800000000000001,
    Jalostuksen_tyopaikkoja: 33.799999999999997,
    Palvelujen_tyopaikkoja: 54.600000000000001,
  },
  {
    Kunta: "Kauniainen",
    Vakiluku: 10270,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 17.300000000000001,
    Ika15_64v: 59.399999999999999,
    Yli64v: 23.300000000000001,
    Ruotsinkielisia: 30.399999999999999,
    Ulkomaan_kansalaisia: 7.5999999999999996,
    Taajamaa: 100.0,
    Syntyneiden_enemmyys: -3,
    Muuttovoitto: -102,
    Perheita: 2864,
    Asuntokuntia: 4462,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 45.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 31.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 81.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 60.299999999999997,
    Taloudellinen_huoltosuhde: 130.59999999999999,
    Tyopaikkaomavaraisuus: 54.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 4460,
    Ika20_64v_tyollisyysaste: 79.799999999999997,
    Asuinkunnassaan_tyossakayvia: 17.300000000000001,
    Tyottomia: 5.9000000000000004,
    Elakelaisia: 23.600000000000001,
    Alueella_olevia_tyopaikkoja: 2443,
    Alkutuotannon_tyopaikkoja: 0.5,
    Jalostuksen_tyopaikkoja: 3.7999999999999998,
    Palvelujen_tyopaikkoja: 92.099999999999994,
  },
  {
    Kunta: "Kaustinen",
    Vakiluku: 4137,
    Vakiluvun_muutos: -1.5,
    Alle15v: 17.300000000000001,
    Ika15_64v: 56.700000000000003,
    Yli64v: 26.0,
    Ruotsinkielisia: 1.8,
    Ulkomaan_kansalaisia: 2.2000000000000002,
    Taajamaa: 67.099999999999994,
    Syntyneiden_enemmyys: -25,
    Muuttovoitto: -65,
    Perheita: 1173,
    Asuntokuntia: 1865,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.899999999999999,
    Taloudellinen_huoltosuhde: 134.80000000000001,
    Tyopaikkaomavaraisuus: 86.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 1788,
    Ika20_64v_tyollisyysaste: 80.400000000000006,
    Asuinkunnassaan_tyossakayvia: 56.799999999999997,
    Tyottomia: 8.5,
    Elakelaisia: 27.399999999999999,
    Alueella_olevia_tyopaikkoja: 1553,
    Alkutuotannon_tyopaikkoja: 11.699999999999999,
    Jalostuksen_tyopaikkoja: 21.199999999999999,
    Palvelujen_tyopaikkoja: 65.900000000000006,
  },
  {
    Kunta: "Keitele",
    Vakiluku: 2035,
    Vakiluvun_muutos: 0.29999999999999999,
    Alle15v: 10.9,
    Ika15_64v: 47.399999999999999,
    Yli64v: 41.700000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 3.3999999999999999,
    Taajamaa: 49.100000000000001,
    Syntyneiden_enemmyys: -27,
    Muuttovoitto: -4,
    Perheita: 560,
    Asuntokuntia: 1078,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.199999999999999,
    Taloudellinen_huoltosuhde: 186.59999999999999,
    Tyopaikkaomavaraisuus: 132.5,
    Alueella_asuva_tyollinen_tyovoima: 708,
    Ika20_64v_tyollisyysaste: 74.700000000000003,
    Asuinkunnassaan_tyossakayvia: 77.400000000000006,
    Tyottomia: 8.5,
    Elakelaisia: 45.5,
    Alueella_olevia_tyopaikkoja: 938,
    Alkutuotannon_tyopaikkoja: 12.4,
    Jalostuksen_tyopaikkoja: 38.399999999999999,
    Palvelujen_tyopaikkoja: 48.399999999999999,
  },
  {
    Kunta: "Kemi",
    Vakiluku: 19371,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 13.4,
    Ika15_64v: 55.899999999999999,
    Yli64v: 30.699999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 4.4000000000000004,
    Taajamaa: 99.5,
    Syntyneiden_enemmyys: -204,
    Muuttovoitto: -152,
    Perheita: 4911,
    Asuntokuntia: 10688,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 53.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 34.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.300000000000001,
    Taloudellinen_huoltosuhde: 187.90000000000001,
    Tyopaikkaomavaraisuus: 119.09999999999999,
    Alueella_asuva_tyollinen_tyovoima: 6773,
    Ika20_64v_tyollisyysaste: 65.799999999999997,
    Asuinkunnassaan_tyossakayvia: 71.099999999999994,
    Tyottomia: 15.9,
    Elakelaisia: 35.899999999999999,
    Alueella_olevia_tyopaikkoja: 8065,
    Alkutuotannon_tyopaikkoja: 0.20000000000000001,
    Jalostuksen_tyopaikkoja: 21.199999999999999,
    Palvelujen_tyopaikkoja: 77.900000000000006,
  },
  {
    Kunta: "Kemijärvi",
    Vakiluku: 7030,
    Vakiluvun_muutos: 0.5,
    Alle15v: 9.8000000000000007,
    Ika15_64v: 48.799999999999997,
    Yli64v: 41.399999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 3.7000000000000002,
    Taajamaa: 70.0,
    Syntyneiden_enemmyys: -149,
    Muuttovoitto: 47,
    Perheita: 1893,
    Asuntokuntia: 3865,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 68.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 25.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.199999999999999,
    Taloudellinen_huoltosuhde: 210.69999999999999,
    Tyopaikkaomavaraisuus: 94.0,
    Alueella_asuva_tyollinen_tyovoima: 2252,
    Ika20_64v_tyollisyysaste: 67.0,
    Asuinkunnassaan_tyossakayvia: 79.099999999999994,
    Tyottomia: 15.4,
    Elakelaisia: 46.700000000000003,
    Alueella_olevia_tyopaikkoja: 2118,
    Alkutuotannon_tyopaikkoja: 6.5,
    Jalostuksen_tyopaikkoja: 16.600000000000001,
    Palvelujen_tyopaikkoja: 76.0,
  },
  {
    Kunta: "Keminmaa",
    Vakiluku: 7691,
    Vakiluvun_muutos: -1.0,
    Alle15v: 15.699999999999999,
    Ika15_64v: 56.299999999999997,
    Yli64v: 28.0,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 0.90000000000000002,
    Taajamaa: 88.900000000000006,
    Syntyneiden_enemmyys: -23,
    Muuttovoitto: -63,
    Perheita: 2241,
    Asuntokuntia: 3659,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 86.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 78.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 30.800000000000001,
    Taloudellinen_huoltosuhde: 143.5,
    Tyopaikkaomavaraisuus: 84.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 3191,
    Ika20_64v_tyollisyysaste: 77.5,
    Asuinkunnassaan_tyossakayvia: 37.0,
    Tyottomia: 9.0,
    Elakelaisia: 30.800000000000001,
    Alueella_olevia_tyopaikkoja: 2687,
    Alkutuotannon_tyopaikkoja: 2.2999999999999998,
    Jalostuksen_tyopaikkoja: 39.200000000000003,
    Palvelujen_tyopaikkoja: 57.5,
  },
  {
    Kunta: "Kemiönsaari",
    Vakiluku: 6462,
    Vakiluvun_muutos: -1.3,
    Alle15v: 11.6,
    Ika15_64v: 52.0,
    Yli64v: 36.399999999999999,
    Ruotsinkielisia: 66.200000000000003,
    Ulkomaan_kansalaisia: 3.8999999999999999,
    Taajamaa: 44.799999999999997,
    Syntyneiden_enemmyys: -98,
    Muuttovoitto: -44,
    Perheita: 1784,
    Asuntokuntia: 3359,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 81.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 27.100000000000001,
    Taloudellinen_huoltosuhde: 158.90000000000001,
    Tyopaikkaomavaraisuus: 84.5,
    Alueella_asuva_tyollinen_tyovoima: 2530,
    Ika20_64v_tyollisyysaste: 77.0,
    Asuinkunnassaan_tyossakayvia: 71.200000000000003,
    Tyottomia: 7.2999999999999998,
    Elakelaisia: 39.299999999999997,
    Alueella_olevia_tyopaikkoja: 2138,
    Alkutuotannon_tyopaikkoja: 7.5,
    Jalostuksen_tyopaikkoja: 20.100000000000001,
    Palvelujen_tyopaikkoja: 69.299999999999997,
  },
  {
    Kunta: "Kempele",
    Vakiluku: 19514,
    Vakiluvun_muutos: 1.1000000000000001,
    Alle15v: 22.800000000000001,
    Ika15_64v: 60.399999999999999,
    Yli64v: 16.899999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 0.80000000000000004,
    Taajamaa: 96.5,
    Syntyneiden_enemmyys: 86,
    Muuttovoitto: 120,
    Perheita: 5456,
    Asuntokuntia: 8068,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 80.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 79.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 37.700000000000003,
    Taloudellinen_huoltosuhde: 126.0,
    Tyopaikkaomavaraisuus: 83.5,
    Alueella_asuva_tyollinen_tyovoima: 8538,
    Ika20_64v_tyollisyysaste: 80.5,
    Asuinkunnassaan_tyossakayvia: 30.399999999999999,
    Tyottomia: 7.5999999999999996,
    Elakelaisia: 19.100000000000001,
    Alueella_olevia_tyopaikkoja: 7128,
    Alkutuotannon_tyopaikkoja: 0.69999999999999996,
    Jalostuksen_tyopaikkoja: 33.5,
    Palvelujen_tyopaikkoja: 64.5,
  },
  {
    Kunta: "Kerava",
    Vakiluku: 38211,
    Vakiluvun_muutos: 1.3999999999999999,
    Alle15v: 15.699999999999999,
    Ika15_64v: 63.700000000000003,
    Yli64v: 20.600000000000001,
    Ruotsinkielisia: 1.2,
    Ulkomaan_kansalaisia: 11.5,
    Taajamaa: 99.900000000000006,
    Syntyneiden_enemmyys: -35,
    Muuttovoitto: 211,
    Perheita: 9959,
    Asuntokuntia: 19407,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 34.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 39.299999999999997,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 31.5,
    Taloudellinen_huoltosuhde: 116.09999999999999,
    Tyopaikkaomavaraisuus: 71.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 17431,
    Ika20_64v_tyollisyysaste: 76.900000000000006,
    Asuinkunnassaan_tyossakayvia: 30.600000000000001,
    Tyottomia: 9.4000000000000004,
    Elakelaisia: 22.600000000000001,
    Alueella_olevia_tyopaikkoja: 12419,
    Alkutuotannon_tyopaikkoja: 0.29999999999999999,
    Jalostuksen_tyopaikkoja: 24.300000000000001,
    Palvelujen_tyopaikkoja: 73.700000000000003,
  },
  {
    Kunta: "Keuruu",
    Vakiluku: 9184,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 12.6,
    Ika15_64v: 50.899999999999999,
    Yli64v: 36.5,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.2000000000000002,
    Taajamaa: 70.900000000000006,
    Syntyneiden_enemmyys: -139,
    Muuttovoitto: -33,
    Perheita: 2477,
    Asuntokuntia: 4882,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 66.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 26.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.399999999999999,
    Taloudellinen_huoltosuhde: 178.40000000000001,
    Tyopaikkaomavaraisuus: 98.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 3322,
    Ika20_64v_tyollisyysaste: 73.200000000000003,
    Asuinkunnassaan_tyossakayvia: 74.099999999999994,
    Tyottomia: 10.1,
    Elakelaisia: 39.299999999999997,
    Alueella_olevia_tyopaikkoja: 3268,
    Alkutuotannon_tyopaikkoja: 4.2999999999999998,
    Jalostuksen_tyopaikkoja: 30.600000000000001,
    Palvelujen_tyopaikkoja: 63.799999999999997,
  },
  {
    Kunta: "Kihniö",
    Vakiluku: 1749,
    Vakiluvun_muutos: -1.2,
    Alle15v: 11.9,
    Ika15_64v: 50.399999999999999,
    Yli64v: 37.700000000000003,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 1.3999999999999999,
    Taajamaa: 34.600000000000001,
    Syntyneiden_enemmyys: -30,
    Muuttovoitto: 3,
    Perheita: 511,
    Asuntokuntia: 858,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 16.399999999999999,
    Taloudellinen_huoltosuhde: 167.09999999999999,
    Tyopaikkaomavaraisuus: 83.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 663,
    Ika20_64v_tyollisyysaste: 76.0,
    Asuinkunnassaan_tyossakayvia: 64.599999999999994,
    Tyottomia: 7.9000000000000004,
    Elakelaisia: 40.899999999999999,
    Alueella_olevia_tyopaikkoja: 555,
    Alkutuotannon_tyopaikkoja: 9.5,
    Jalostuksen_tyopaikkoja: 39.100000000000001,
    Palvelujen_tyopaikkoja: 49.200000000000003,
  },
  {
    Kunta: "Kinnula",
    Vakiluku: 1523,
    Vakiluvun_muutos: -2.0,
    Alle15v: 17.699999999999999,
    Ika15_64v: 47.100000000000001,
    Yli64v: 35.200000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.2,
    Taajamaa: 52.600000000000001,
    Syntyneiden_enemmyys: -16,
    Muuttovoitto: -25,
    Perheita: 394,
    Asuntokuntia: 689,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 63.100000000000001,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.5,
    Taloudellinen_huoltosuhde: 209.59999999999999,
    Tyopaikkaomavaraisuus: 83.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 502,
    Ika20_64v_tyollisyysaste: 70.5,
    Asuinkunnassaan_tyossakayvia: 69.299999999999997,
    Tyottomia: 12.4,
    Elakelaisia: 39.0,
    Alueella_olevia_tyopaikkoja: 421,
    Alkutuotannon_tyopaikkoja: 19.0,
    Jalostuksen_tyopaikkoja: 8.0999999999999996,
    Palvelujen_tyopaikkoja: 71.0,
  },
  {
    Kunta: "Kirkkonummi",
    Vakiluku: 41154,
    Vakiluvun_muutos: 1.1000000000000001,
    Alle15v: 17.399999999999999,
    Ika15_64v: 64.599999999999994,
    Yli64v: 18.0,
    Ruotsinkielisia: 14.800000000000001,
    Ulkomaan_kansalaisia: 8.5999999999999996,
    Taajamaa: 91.599999999999994,
    Syntyneiden_enemmyys: 10,
    Muuttovoitto: 21,
    Perheita: 11476,
    Asuntokuntia: 18575,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 64.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 29.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 40.399999999999999,
    Taloudellinen_huoltosuhde: 106.8,
    Tyopaikkaomavaraisuus: 55.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 19696,
    Ika20_64v_tyollisyysaste: 81.099999999999994,
    Asuinkunnassaan_tyossakayvia: 30.899999999999999,
    Tyottomia: 6.5999999999999996,
    Elakelaisia: 19.399999999999999,
    Alueella_olevia_tyopaikkoja: 10998,
    Alkutuotannon_tyopaikkoja: 0.80000000000000004,
    Jalostuksen_tyopaikkoja: 20.100000000000001,
    Palvelujen_tyopaikkoja: 76.700000000000003,
  },
  {
    Kunta: "Kitee",
    Vakiluku: 9689,
    Vakiluvun_muutos: -0.40000000000000002,
    Alle15v: 10.6,
    Ika15_64v: 49.200000000000003,
    Yli64v: 40.200000000000003,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 5.4000000000000004,
    Taajamaa: 54.200000000000003,
    Syntyneiden_enemmyys: -126,
    Muuttovoitto: -108,
    Perheita: 2655,
    Asuntokuntia: 5165,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 76.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.699999999999999,
    Taloudellinen_huoltosuhde: 209.69999999999999,
    Tyopaikkaomavaraisuus: 99.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 3141,
    Ika20_64v_tyollisyysaste: 67.799999999999997,
    Asuinkunnassaan_tyossakayvia: 78.900000000000006,
    Tyottomia: 14.5,
    Elakelaisia: 43.799999999999997,
    Alueella_olevia_tyopaikkoja: 3135,
    Alkutuotannon_tyopaikkoja: 11.6,
    Jalostuksen_tyopaikkoja: 23.0,
    Palvelujen_tyopaikkoja: 63.799999999999997,
  },
  {
    Kunta: "Kittilä",
    Vakiluku: 6822,
    Vakiluvun_muutos: 2.7999999999999998,
    Alle15v: 14.800000000000001,
    Ika15_64v: 63.5,
    Yli64v: 21.699999999999999,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 3.7999999999999998,
    Taajamaa: 57.0,
    Syntyneiden_enemmyys: -19,
    Muuttovoitto: 162,
    Perheita: 1621,
    Asuntokuntia: 2949,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 84.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 32.299999999999997,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 77.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.600000000000001,
    Taloudellinen_huoltosuhde: 99.299999999999997,
    Tyopaikkaomavaraisuus: 113.40000000000001,
    Alueella_asuva_tyollinen_tyovoima: 3330,
    Ika20_64v_tyollisyysaste: 82.0,
    Asuinkunnassaan_tyossakayvia: 83.799999999999997,
    Tyottomia: 7.5,
    Elakelaisia: 24.300000000000001,
    Alueella_olevia_tyopaikkoja: 3776,
    Alkutuotannon_tyopaikkoja: 3.1000000000000001,
    Jalostuksen_tyopaikkoja: 24.899999999999999,
    Palvelujen_tyopaikkoja: 71.0,
  },
  {
    Kunta: "Kiuruvesi",
    Vakiluku: 7475,
    Vakiluvun_muutos: -1.6000000000000001,
    Alle15v: 14.199999999999999,
    Ika15_64v: 52.299999999999997,
    Yli64v: 33.5,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 1.6000000000000001,
    Taajamaa: 50.399999999999999,
    Syntyneiden_enemmyys: -89,
    Muuttovoitto: -55,
    Perheita: 1979,
    Asuntokuntia: 3837,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 81.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 26.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.199999999999999,
    Taloudellinen_huoltosuhde: 173.5,
    Tyopaikkaomavaraisuus: 82.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 2778,
    Ika20_64v_tyollisyysaste: 73.599999999999994,
    Asuinkunnassaan_tyossakayvia: 68.400000000000006,
    Tyottomia: 11.699999999999999,
    Elakelaisia: 36.899999999999999,
    Alueella_olevia_tyopaikkoja: 2280,
    Alkutuotannon_tyopaikkoja: 23.5,
    Jalostuksen_tyopaikkoja: 15.0,
    Palvelujen_tyopaikkoja: 59.600000000000001,
  },
  {
    Kunta: "Kivijärvi",
    Vakiluku: 1035,
    Vakiluvun_muutos: -2.7000000000000002,
    Alle15v: 12.9,
    Ika15_64v: 48.299999999999997,
    Yli64v: 38.799999999999997,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 2.0,
    Taajamaa: 52.0,
    Syntyneiden_enemmyys: -9,
    Muuttovoitto: -21,
    Perheita: 265,
    Asuntokuntia: 514,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 62.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 12.699999999999999,
    Taloudellinen_huoltosuhde: 212.0,
    Tyopaikkaomavaraisuus: 66.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 341,
    Ika20_64v_tyollisyysaste: 67.900000000000006,
    Asuinkunnassaan_tyossakayvia: 51.0,
    Tyottomia: 15.800000000000001,
    Elakelaisia: 41.600000000000001,
    Alueella_olevia_tyopaikkoja: 227,
    Alkutuotannon_tyopaikkoja: 13.699999999999999,
    Jalostuksen_tyopaikkoja: 17.600000000000001,
    Palvelujen_tyopaikkoja: 66.5,
  },
  {
    Kunta: "Kokemäki",
    Vakiluku: 6766,
    Vakiluvun_muutos: -2.0,
    Alle15v: 12.1,
    Ika15_64v: 55.399999999999999,
    Yli64v: 32.600000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.7999999999999998,
    Taajamaa: 59.799999999999997,
    Syntyneiden_enemmyys: -73,
    Muuttovoitto: -70,
    Perheita: 1873,
    Asuntokuntia: 3552,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 86.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.199999999999999,
    Taloudellinen_huoltosuhde: 156.80000000000001,
    Tyopaikkaomavaraisuus: 84.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 2688,
    Ika20_64v_tyollisyysaste: 74.400000000000006,
    Asuinkunnassaan_tyossakayvia: 52.299999999999997,
    Tyottomia: 9.3000000000000007,
    Elakelaisia: 35.799999999999997,
    Alueella_olevia_tyopaikkoja: 2260,
    Alkutuotannon_tyopaikkoja: 7.7000000000000002,
    Jalostuksen_tyopaikkoja: 28.800000000000001,
    Palvelujen_tyopaikkoja: 62.0,
  },
  {
    Kunta: "Kokkola",
    Vakiluku: 48295,
    Vakiluvun_muutos: 0.59999999999999998,
    Alle15v: 18.0,
    Ika15_64v: 58.899999999999999,
    Yli64v: 23.100000000000001,
    Ruotsinkielisia: 12.0,
    Ulkomaan_kansalaisia: 3.6000000000000001,
    Taajamaa: 89.099999999999994,
    Syntyneiden_enemmyys: -56,
    Muuttovoitto: -13,
    Perheita: 13040,
    Asuntokuntia: 22302,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 65.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 29.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 29.600000000000001,
    Taloudellinen_huoltosuhde: 136.09999999999999,
    Tyopaikkaomavaraisuus: 105.5,
    Alueella_asuva_tyollinen_tyovoima: 20335,
    Ika20_64v_tyollisyysaste: 77.599999999999994,
    Asuinkunnassaan_tyossakayvia: 86.900000000000006,
    Tyottomia: 8.5,
    Elakelaisia: 25.699999999999999,
    Alueella_olevia_tyopaikkoja: 21454,
    Alkutuotannon_tyopaikkoja: 2.5,
    Jalostuksen_tyopaikkoja: 23.199999999999999,
    Palvelujen_tyopaikkoja: 73.5,
  },
  {
    Kunta: "Kolari",
    Vakiluku: 4011,
    Vakiluvun_muutos: 0.29999999999999999,
    Alle15v: 15.300000000000001,
    Ika15_64v: 57.0,
    Yli64v: 27.699999999999999,
    Ruotsinkielisia: 0.59999999999999998,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 50.399999999999999,
    Syntyneiden_enemmyys: -18,
    Muuttovoitto: 1,
    Perheita: 989,
    Asuntokuntia: 1828,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 93.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.600000000000001,
    Taloudellinen_huoltosuhde: 124.8,
    Tyopaikkaomavaraisuus: 93.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 1779,
    Ika20_64v_tyollisyysaste: 80.0,
    Asuinkunnassaan_tyossakayvia: 76.299999999999997,
    Tyottomia: 7.9000000000000004,
    Elakelaisia: 29.699999999999999,
    Alueella_olevia_tyopaikkoja: 1671,
    Alkutuotannon_tyopaikkoja: 3.6000000000000001,
    Jalostuksen_tyopaikkoja: 10.199999999999999,
    Palvelujen_tyopaikkoja: 83.700000000000003,
  },
  {
    Kunta: "Konnevesi",
    Vakiluku: 2499,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 12.4,
    Ika15_64v: 51.299999999999997,
    Yli64v: 36.299999999999997,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 1.7,
    Taajamaa: 40.5,
    Syntyneiden_enemmyys: -47,
    Muuttovoitto: -1,
    Perheita: 678,
    Asuntokuntia: 1286,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.0,
    Taloudellinen_huoltosuhde: 166.19999999999999,
    Tyopaikkaomavaraisuus: 81.5,
    Alueella_asuva_tyollinen_tyovoima: 947,
    Ika20_64v_tyollisyysaste: 75.299999999999997,
    Asuinkunnassaan_tyossakayvia: 55.100000000000001,
    Tyottomia: 11.300000000000001,
    Elakelaisia: 38.899999999999999,
    Alueella_olevia_tyopaikkoja: 772,
    Alkutuotannon_tyopaikkoja: 17.100000000000001,
    Jalostuksen_tyopaikkoja: 7.5,
    Palvelujen_tyopaikkoja: 73.299999999999997,
  },
  {
    Kunta: "Kontiolahti",
    Vakiluku: 15136,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 20.100000000000001,
    Ika15_64v: 60.799999999999997,
    Yli64v: 19.100000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.1000000000000001,
    Taajamaa: 72.299999999999997,
    Syntyneiden_enemmyys: 39,
    Muuttovoitto: -77,
    Perheita: 4335,
    Asuntokuntia: 6560,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 93.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 80.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 34.5,
    Taloudellinen_huoltosuhde: 124.5,
    Tyopaikkaomavaraisuus: 58.5,
    Alueella_asuva_tyollinen_tyovoima: 6751,
    Ika20_64v_tyollisyysaste: 79.5,
    Asuinkunnassaan_tyossakayvia: 28.800000000000001,
    Tyottomia: 9.5,
    Elakelaisia: 21.199999999999999,
    Alueella_olevia_tyopaikkoja: 3948,
    Alkutuotannon_tyopaikkoja: 3.7999999999999998,
    Jalostuksen_tyopaikkoja: 40.399999999999999,
    Palvelujen_tyopaikkoja: 54.399999999999999,
  },
  {
    Kunta: "Korsnäs",
    Vakiluku: 2015,
    Vakiluvun_muutos: -0.40000000000000002,
    Alle15v: 14.1,
    Ika15_64v: 55.100000000000001,
    Yli64v: 30.699999999999999,
    Ruotsinkielisia: 83.700000000000003,
    Ulkomaan_kansalaisia: 9.3000000000000007,
    Taajamaa: 55.700000000000003,
    Syntyneiden_enemmyys: -7,
    Muuttovoitto: -26,
    Perheita: 589,
    Asuntokuntia: 912,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 15.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.699999999999999,
    Taloudellinen_huoltosuhde: 133.40000000000001,
    Tyopaikkaomavaraisuus: 69.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 867,
    Ika20_64v_tyollisyysaste: 78.599999999999994,
    Asuinkunnassaan_tyossakayvia: 49.600000000000001,
    Tyottomia: 8.0,
    Elakelaisia: 31.399999999999999,
    Alueella_olevia_tyopaikkoja: 604,
    Alkutuotannon_tyopaikkoja: 13.9,
    Jalostuksen_tyopaikkoja: 19.0,
    Palvelujen_tyopaikkoja: 64.400000000000006,
  },
  {
    Kunta: "Koski Tl",
    Vakiluku: 2207,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 12.699999999999999,
    Ika15_64v: 53.700000000000003,
    Yli64v: 33.600000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 4.2000000000000002,
    Taajamaa: 53.299999999999997,
    Syntyneiden_enemmyys: -23,
    Muuttovoitto: -20,
    Perheita: 599,
    Asuntokuntia: 1139,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 90.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.100000000000001,
    Taloudellinen_huoltosuhde: 155.69999999999999,
    Tyopaikkaomavaraisuus: 103.3,
    Alueella_asuva_tyollinen_tyovoima: 871,
    Ika20_64v_tyollisyysaste: 77.5,
    Asuinkunnassaan_tyossakayvia: 56.5,
    Tyottomia: 7.0,
    Elakelaisia: 36.5,
    Alueella_olevia_tyopaikkoja: 900,
    Alkutuotannon_tyopaikkoja: 12.800000000000001,
    Jalostuksen_tyopaikkoja: 27.600000000000001,
    Palvelujen_tyopaikkoja: 59.200000000000003,
  },
  {
    Kunta: "Kotka",
    Vakiluku: 50500,
    Vakiluvun_muutos: -0.20000000000000001,
    Alle15v: 12.199999999999999,
    Ika15_64v: 58.799999999999997,
    Yli64v: 29.0,
    Ruotsinkielisia: 1.0,
    Ulkomaan_kansalaisia: 6.2000000000000002,
    Taajamaa: 98.200000000000003,
    Syntyneiden_enemmyys: -530,
    Muuttovoitto: -184,
    Perheita: 12965,
    Asuntokuntia: 27830,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 43.399999999999999,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 36.799999999999997,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 28.800000000000001,
    Taloudellinen_huoltosuhde: 158.69999999999999,
    Tyopaikkaomavaraisuus: 111.7,
    Alueella_asuva_tyollinen_tyovoima: 19568,
    Ika20_64v_tyollisyysaste: 69.400000000000006,
    Asuinkunnassaan_tyossakayvia: 79.299999999999997,
    Tyottomia: 13.199999999999999,
    Elakelaisia: 32.600000000000001,
    Alueella_olevia_tyopaikkoja: 21867,
    Alkutuotannon_tyopaikkoja: 0.5,
    Jalostuksen_tyopaikkoja: 21.899999999999999,
    Palvelujen_tyopaikkoja: 76.799999999999997,
  },
  {
    Kunta: "Kouvola",
    Vakiluku: 78880,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 12.300000000000001,
    Ika15_64v: 57.5,
    Yli64v: 30.100000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 3.2999999999999998,
    Taajamaa: 86.099999999999994,
    Syntyneiden_enemmyys: -758,
    Muuttovoitto: -335,
    Perheita: 21088,
    Asuntokuntia: 42714,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 62.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 29.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.899999999999999,
    Taloudellinen_huoltosuhde: 153.19999999999999,
    Tyopaikkaomavaraisuus: 96.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 31371,
    Ika20_64v_tyollisyysaste: 72.599999999999994,
    Asuinkunnassaan_tyossakayvia: 82.599999999999994,
    Tyottomia: 10.9,
    Elakelaisia: 34.0,
    Alueella_olevia_tyopaikkoja: 30171,
    Alkutuotannon_tyopaikkoja: 2.8999999999999999,
    Jalostuksen_tyopaikkoja: 22.5,
    Palvelujen_tyopaikkoja: 73.400000000000006,
  },
  {
    Kunta: "Kristiinankaupunki",
    Vakiluku: 6199,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 12.300000000000001,
    Ika15_64v: 49.799999999999997,
    Yli64v: 38.0,
    Ruotsinkielisia: 52.899999999999999,
    Ulkomaan_kansalaisia: 6.2000000000000002,
    Taajamaa: 68.599999999999994,
    Syntyneiden_enemmyys: -64,
    Muuttovoitto: -146,
    Perheita: 1759,
    Asuntokuntia: 3088,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.600000000000001,
    Taloudellinen_huoltosuhde: 152.69999999999999,
    Tyopaikkaomavaraisuus: 93.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 2470,
    Ika20_64v_tyollisyysaste: 81.0,
    Asuinkunnassaan_tyossakayvia: 73.099999999999994,
    Tyottomia: 4.7000000000000002,
    Elakelaisia: 40.100000000000001,
    Alueella_olevia_tyopaikkoja: 2319,
    Alkutuotannon_tyopaikkoja: 11.300000000000001,
    Jalostuksen_tyopaikkoja: 17.399999999999999,
    Palvelujen_tyopaikkoja: 69.900000000000006,
  },
  {
    Kunta: "Kruunupyy",
    Vakiluku: 6368,
    Vakiluvun_muutos: -0.59999999999999998,
    Alle15v: 16.5,
    Ika15_64v: 56.799999999999997,
    Yli64v: 26.699999999999999,
    Ruotsinkielisia: 76.0,
    Ulkomaan_kansalaisia: 4.0,
    Taajamaa: 57.299999999999997,
    Syntyneiden_enemmyys: -25,
    Muuttovoitto: -57,
    Perheita: 1888,
    Asuntokuntia: 2674,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.6,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.600000000000001,
    Taloudellinen_huoltosuhde: 128.80000000000001,
    Tyopaikkaomavaraisuus: 79.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 2799,
    Ika20_64v_tyollisyysaste: 82.299999999999997,
    Asuinkunnassaan_tyossakayvia: 52.399999999999999,
    Tyottomia: 5.0999999999999996,
    Elakelaisia: 28.5,
    Alueella_olevia_tyopaikkoja: 2218,
    Alkutuotannon_tyopaikkoja: 12.4,
    Jalostuksen_tyopaikkoja: 39.899999999999999,
    Palvelujen_tyopaikkoja: 45.899999999999999,
  },
  {
    Kunta: "Kuhmo",
    Vakiluku: 7582,
    Vakiluvun_muutos: -2.2000000000000002,
    Alle15v: 10.0,
    Ika15_64v: 50.100000000000001,
    Yli64v: 39.899999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.6000000000000001,
    Taajamaa: 64.400000000000006,
    Syntyneiden_enemmyys: -132,
    Muuttovoitto: -53,
    Perheita: 2049,
    Asuntokuntia: 4170,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 78.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.0,
    Taloudellinen_huoltosuhde: 193.90000000000001,
    Tyopaikkaomavaraisuus: 97.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 2639,
    Ika20_64v_tyollisyysaste: 70.299999999999997,
    Asuinkunnassaan_tyossakayvia: 86.400000000000006,
    Tyottomia: 12.5,
    Elakelaisia: 44.399999999999999,
    Alueella_olevia_tyopaikkoja: 2567,
    Alkutuotannon_tyopaikkoja: 12.5,
    Jalostuksen_tyopaikkoja: 19.899999999999999,
    Palvelujen_tyopaikkoja: 66.700000000000003,
  },
  {
    Kunta: "Kuhmoinen",
    Vakiluku: 2092,
    Vakiluvun_muutos: -1.3,
    Alle15v: 8.3000000000000007,
    Ika15_64v: 45.700000000000003,
    Yli64v: 45.899999999999999,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 2.0,
    Taajamaa: 55.0,
    Syntyneiden_enemmyys: -48,
    Muuttovoitto: -6,
    Perheita: 544,
    Asuntokuntia: 1200,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 79.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.899999999999999,
    Taloudellinen_huoltosuhde: 209.80000000000001,
    Tyopaikkaomavaraisuus: 84.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 684,
    Ika20_64v_tyollisyysaste: 72.700000000000003,
    Asuinkunnassaan_tyossakayvia: 65.799999999999997,
    Tyottomia: 10.1,
    Elakelaisia: 49.700000000000003,
    Alueella_olevia_tyopaikkoja: 579,
    Alkutuotannon_tyopaikkoja: 11.6,
    Jalostuksen_tyopaikkoja: 19.899999999999999,
    Palvelujen_tyopaikkoja: 66.5,
  },
  {
    Kunta: "Kumlinge",
    Vakiluku: 290,
    Vakiluvun_muutos: -5.2000000000000002,
    Alle15v: 9.6999999999999993,
    Ika15_64v: 49.0,
    Yli64v: 41.399999999999999,
    Ruotsinkielisia: 84.799999999999997,
    Ulkomaan_kansalaisia: 10.0,
    Taajamaa: 0.0,
    Syntyneiden_enemmyys: 0.0,
    Muuttovoitto: -9,
    Perheita: 73,
    Asuntokuntia: 163,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 64.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 27.300000000000001,
    Taloudellinen_huoltosuhde: 125.0,
    Tyopaikkaomavaraisuus: 62.5,
    Alueella_asuva_tyollinen_tyovoima: 136,
    Ika20_64v_tyollisyysaste: 85.900000000000006,
    Asuinkunnassaan_tyossakayvia: 52.200000000000003,
    Tyottomia: 1.3999999999999999,
    Elakelaisia: 39.5,
    Alueella_olevia_tyopaikkoja: 85,
    Alkutuotannon_tyopaikkoja: 8.1999999999999993,
    Jalostuksen_tyopaikkoja: 2.3999999999999999,
    Palvelujen_tyopaikkoja: 82.400000000000006,
  },
  {
    Kunta: "Kuopio",
    Vakiluku: 124021,
    Vakiluvun_muutos: 1.2,
    Alle15v: 14.0,
    Ika15_64v: 63.600000000000001,
    Yli64v: 22.399999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 3.8999999999999999,
    Taajamaa: 87.200000000000003,
    Syntyneiden_enemmyys: -304,
    Muuttovoitto: 751,
    Perheita: 32305,
    Asuntokuntia: 66134,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 40.100000000000001,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 42.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 79.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 35.299999999999997,
    Taloudellinen_huoltosuhde: 128.0,
    Tyopaikkaomavaraisuus: 103.0,
    Alueella_asuva_tyollinen_tyovoima: 53779,
    Ika20_64v_tyollisyysaste: 72.700000000000003,
    Asuinkunnassaan_tyossakayvia: 84.0,
    Tyottomia: 9.9000000000000004,
    Elakelaisia: 25.600000000000001,
    Alueella_olevia_tyopaikkoja: 55401,
    Alkutuotannon_tyopaikkoja: 2.3999999999999999,
    Jalostuksen_tyopaikkoja: 15.1,
    Palvelujen_tyopaikkoja: 81.5,
  },
  {
    Kunta: "Kuortane",
    Vakiluku: 3381,
    Vakiluvun_muutos: -1.6000000000000001,
    Alle15v: 12.5,
    Ika15_64v: 53.399999999999999,
    Yli64v: 34.200000000000003,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.8999999999999999,
    Taajamaa: 36.600000000000001,
    Syntyneiden_enemmyys: -47,
    Muuttovoitto: -26,
    Perheita: 963,
    Asuntokuntia: 1614,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.199999999999999,
    Taloudellinen_huoltosuhde: 150.30000000000001,
    Tyopaikkaomavaraisuus: 95.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 1373,
    Ika20_64v_tyollisyysaste: 81.200000000000003,
    Asuinkunnassaan_tyossakayvia: 58.299999999999997,
    Tyottomia: 5.0,
    Elakelaisia: 36.799999999999997,
    Alueella_olevia_tyopaikkoja: 1306,
    Alkutuotannon_tyopaikkoja: 11.9,
    Jalostuksen_tyopaikkoja: 21.300000000000001,
    Palvelujen_tyopaikkoja: 65.099999999999994,
  },
  {
    Kunta: "Kurikka",
    Vakiluku: 19759,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 14.199999999999999,
    Ika15_64v: 53.799999999999997,
    Yli64v: 32.0,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 2.6000000000000001,
    Taajamaa: 62.0,
    Syntyneiden_enemmyys: -183,
    Muuttovoitto: -118,
    Perheita: 5559,
    Asuntokuntia: 9721,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 88.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.399999999999999,
    Taloudellinen_huoltosuhde: 156.09999999999999,
    Tyopaikkaomavaraisuus: 88.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 7768,
    Ika20_64v_tyollisyysaste: 76.799999999999997,
    Asuinkunnassaan_tyossakayvia: 64.799999999999997,
    Tyottomia: 8.4000000000000004,
    Elakelaisia: 35.100000000000001,
    Alueella_olevia_tyopaikkoja: 6865,
    Alkutuotannon_tyopaikkoja: 11.199999999999999,
    Jalostuksen_tyopaikkoja: 31.100000000000001,
    Palvelujen_tyopaikkoja: 56.600000000000001,
  },
  {
    Kunta: "Kustavi",
    Vakiluku: 949,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 7.5999999999999996,
    Ika15_64v: 49.600000000000001,
    Yli64v: 42.799999999999997,
    Ruotsinkielisia: 1.8999999999999999,
    Ulkomaan_kansalaisia: 3.7000000000000002,
    Taajamaa: 36.200000000000003,
    Syntyneiden_enemmyys: -9,
    Muuttovoitto: -3,
    Perheita: 266,
    Asuntokuntia: 513,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 30.199999999999999,
    Taloudellinen_huoltosuhde: 156.80000000000001,
    Tyopaikkaomavaraisuus: 81.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 370,
    Ika20_64v_tyollisyysaste: 77.299999999999997,
    Asuinkunnassaan_tyossakayvia: 48.100000000000001,
    Tyottomia: 7.5,
    Elakelaisia: 44.299999999999997,
    Alueella_olevia_tyopaikkoja: 303,
    Alkutuotannon_tyopaikkoja: 11.9,
    Jalostuksen_tyopaikkoja: 29.699999999999999,
    Palvelujen_tyopaikkoja: 56.799999999999997,
  },
  {
    Kunta: "Kuusamo",
    Vakiluku: 15019,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 14.1,
    Ika15_64v: 55.399999999999999,
    Yli64v: 30.5,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 3.2000000000000002,
    Taajamaa: 65.200000000000003,
    Syntyneiden_enemmyys: -129,
    Muuttovoitto: -125,
    Perheita: 4155,
    Asuntokuntia: 7317,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 73.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 26.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.199999999999999,
    Taloudellinen_huoltosuhde: 155.80000000000001,
    Tyopaikkaomavaraisuus: 102.0,
    Alueella_asuva_tyollinen_tyovoima: 5922,
    Ika20_64v_tyollisyysaste: 73.799999999999997,
    Asuinkunnassaan_tyossakayvia: 91.200000000000003,
    Tyottomia: 9.6999999999999993,
    Elakelaisia: 34.399999999999999,
    Alueella_olevia_tyopaikkoja: 6038,
    Alkutuotannon_tyopaikkoja: 5.2999999999999998,
    Jalostuksen_tyopaikkoja: 16.800000000000001,
    Palvelujen_tyopaikkoja: 77.0,
  },
  {
    Kunta: "Kyyjärvi",
    Vakiluku: 1174,
    Vakiluvun_muutos: -1.8,
    Alle15v: 15.800000000000001,
    Ika15_64v: 45.100000000000001,
    Yli64v: 39.100000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.6000000000000001,
    Taajamaa: 56.799999999999997,
    Syntyneiden_enemmyys: -19,
    Muuttovoitto: -15,
    Perheita: 313,
    Asuntokuntia: 569,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 63.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 16.899999999999999,
    Taloudellinen_huoltosuhde: 196.0,
    Tyopaikkaomavaraisuus: 102.7,
    Alueella_asuva_tyollinen_tyovoima: 404,
    Ika20_64v_tyollisyysaste: 75.099999999999994,
    Asuinkunnassaan_tyossakayvia: 66.799999999999997,
    Tyottomia: 8.1999999999999993,
    Elakelaisia: 41.299999999999997,
    Alueella_olevia_tyopaikkoja: 415,
    Alkutuotannon_tyopaikkoja: 12.0,
    Jalostuksen_tyopaikkoja: 39.299999999999997,
    Palvelujen_tyopaikkoja: 47.5,
  },
  {
    Kunta: "Kärkölä",
    Vakiluku: 4114,
    Vakiluvun_muutos: -2.0,
    Alle15v: 12.5,
    Ika15_64v: 58.200000000000003,
    Yli64v: 29.300000000000001,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 3.6000000000000001,
    Taajamaa: 67.200000000000003,
    Syntyneiden_enemmyys: -56,
    Muuttovoitto: -62,
    Perheita: 1165,
    Asuntokuntia: 2128,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.699999999999999,
    Taloudellinen_huoltosuhde: 142.5,
    Tyopaikkaomavaraisuus: 92.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 1731,
    Ika20_64v_tyollisyysaste: 74.900000000000006,
    Asuinkunnassaan_tyossakayvia: 46.399999999999999,
    Tyottomia: 10.1,
    Elakelaisia: 32.600000000000001,
    Alueella_olevia_tyopaikkoja: 1595,
    Alkutuotannon_tyopaikkoja: 7.2000000000000002,
    Jalostuksen_tyopaikkoja: 52.0,
    Palvelujen_tyopaikkoja: 39.399999999999999,
  },
  {
    Kunta: "Kärsämäki",
    Vakiluku: 2440,
    Vakiluvun_muutos: -1.3999999999999999,
    Alle15v: 16.899999999999999,
    Ika15_64v: 52.5,
    Yli64v: 30.5,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.3,
    Taajamaa: 46.899999999999999,
    Syntyneiden_enemmyys: -27,
    Muuttovoitto: -16,
    Perheita: 606,
    Asuntokuntia: 1116,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 14.1,
    Taloudellinen_huoltosuhde: 178.30000000000001,
    Tyopaikkaomavaraisuus: 109.2,
    Alueella_asuva_tyollinen_tyovoima: 889,
    Ika20_64v_tyollisyysaste: 73.400000000000006,
    Asuinkunnassaan_tyossakayvia: 70.0,
    Tyottomia: 9.4000000000000004,
    Elakelaisia: 34.700000000000003,
    Alueella_olevia_tyopaikkoja: 971,
    Alkutuotannon_tyopaikkoja: 19.399999999999999,
    Jalostuksen_tyopaikkoja: 26.800000000000001,
    Palvelujen_tyopaikkoja: 53.200000000000003,
  },
  {
    Kunta: "Kökar",
    Vakiluku: 225,
    Vakiluvun_muutos: 0.90000000000000002,
    Alle15v: 4.4000000000000004,
    Ika15_64v: 59.600000000000001,
    Yli64v: 36.0,
    Ruotsinkielisia: 87.099999999999994,
    Ulkomaan_kansalaisia: 6.2000000000000002,
    Taajamaa: 0.0,
    Syntyneiden_enemmyys: -2,
    Muuttovoitto: 3,
    Perheita: 64,
    Asuntokuntia: 114,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.5,
    Taloudellinen_huoltosuhde: 129.90000000000001,
    Tyopaikkaomavaraisuus: 93.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 97,
    Ika20_64v_tyollisyysaste: 75.599999999999994,
    Asuinkunnassaan_tyossakayvia: 68.0,
    Tyottomia: 6.7000000000000002,
    Elakelaisia: 38.600000000000001,
    Alueella_olevia_tyopaikkoja: 91,
    Alkutuotannon_tyopaikkoja: 5.5,
    Jalostuksen_tyopaikkoja: 7.7000000000000002,
    Palvelujen_tyopaikkoja: 78.0,
  },
  {
    Kunta: "Lahti",
    Vakiluku: 120693,
    Vakiluvun_muutos: 0.40000000000000002,
    Alle15v: 13.6,
    Ika15_64v: 60.799999999999997,
    Yli64v: 25.5,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 6.0,
    Taajamaa: 97.599999999999994,
    Syntyneiden_enemmyys: -667,
    Muuttovoitto: -39,
    Perheita: 30474,
    Asuntokuntia: 66356,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 32.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 42.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 30.100000000000001,
    Taloudellinen_huoltosuhde: 146.5,
    Tyopaikkaomavaraisuus: 105.90000000000001,
    Alueella_asuva_tyollinen_tyovoima: 48752,
    Ika20_64v_tyollisyysaste: 71.0,
    Asuinkunnassaan_tyossakayvia: 76.400000000000006,
    Tyottomia: 13.699999999999999,
    Elakelaisia: 28.300000000000001,
    Alueella_olevia_tyopaikkoja: 51608,
    Alkutuotannon_tyopaikkoja: 0.5,
    Jalostuksen_tyopaikkoja: 24.699999999999999,
    Palvelujen_tyopaikkoja: 73.700000000000003,
  },
  {
    Kunta: "Laihia",
    Vakiluku: 7682,
    Vakiluvun_muutos: -1.7,
    Alle15v: 18.5,
    Ika15_64v: 56.600000000000001,
    Yli64v: 24.899999999999999,
    Ruotsinkielisia: 1.1000000000000001,
    Ulkomaan_kansalaisia: 1.3,
    Taajamaa: 82.400000000000006,
    Syntyneiden_enemmyys: -46,
    Muuttovoitto: -100,
    Perheita: 2151,
    Asuntokuntia: 3510,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 88.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 31.5,
    Taloudellinen_huoltosuhde: 131.0,
    Tyopaikkaomavaraisuus: 51.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 3384,
    Ika20_64v_tyollisyysaste: 82.0,
    Asuinkunnassaan_tyossakayvia: 34.0,
    Tyottomia: 6.0,
    Elakelaisia: 27.100000000000001,
    Alueella_olevia_tyopaikkoja: 1749,
    Alkutuotannon_tyopaikkoja: 8.0999999999999996,
    Jalostuksen_tyopaikkoja: 21.399999999999999,
    Palvelujen_tyopaikkoja: 68.599999999999994,
  },
  {
    Kunta: "Laitila",
    Vakiluku: 8441,
    Vakiluvun_muutos: 0.90000000000000002,
    Alle15v: 16.0,
    Ika15_64v: 58.200000000000003,
    Yli64v: 25.800000000000001,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 11.1,
    Taajamaa: 72.700000000000003,
    Syntyneiden_enemmyys: -38,
    Muuttovoitto: -143,
    Perheita: 2253,
    Asuntokuntia: 4086,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 73.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.699999999999999,
    Taloudellinen_huoltosuhde: 129.69999999999999,
    Tyopaikkaomavaraisuus: 99.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 3642,
    Ika20_64v_tyollisyysaste: 78.900000000000006,
    Asuinkunnassaan_tyossakayvia: 61.700000000000003,
    Tyottomia: 7.0,
    Elakelaisia: 28.899999999999999,
    Alueella_olevia_tyopaikkoja: 3610,
    Alkutuotannon_tyopaikkoja: 9.1999999999999993,
    Jalostuksen_tyopaikkoja: 40.5,
    Palvelujen_tyopaikkoja: 48.799999999999997,
  },
  {
    Kunta: "Lapinjärvi",
    Vakiluku: 2449,
    Vakiluvun_muutos: -2.7000000000000002,
    Alle15v: 12.9,
    Ika15_64v: 55.899999999999999,
    Yli64v: 31.199999999999999,
    Ruotsinkielisia: 30.0,
    Ulkomaan_kansalaisia: 6.2000000000000002,
    Taajamaa: 28.0,
    Syntyneiden_enemmyys: -36,
    Muuttovoitto: -53,
    Perheita: 663,
    Asuntokuntia: 1220,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 64.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.199999999999999,
    Taloudellinen_huoltosuhde: 145.40000000000001,
    Tyopaikkaomavaraisuus: 76.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 1026,
    Ika20_64v_tyollisyysaste: 77.400000000000006,
    Asuinkunnassaan_tyossakayvia: 47.600000000000001,
    Tyottomia: 9.3000000000000007,
    Elakelaisia: 32.799999999999997,
    Alueella_olevia_tyopaikkoja: 786,
    Alkutuotannon_tyopaikkoja: 22.5,
    Jalostuksen_tyopaikkoja: 17.199999999999999,
    Palvelujen_tyopaikkoja: 58.700000000000003,
  },
  {
    Kunta: "Lapinlahti",
    Vakiluku: 8975,
    Vakiluvun_muutos: -1.3999999999999999,
    Alle15v: 13.9,
    Ika15_64v: 55.899999999999999,
    Yli64v: 30.300000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.0,
    Taajamaa: 53.899999999999999,
    Syntyneiden_enemmyys: -115,
    Muuttovoitto: -55,
    Perheita: 2463,
    Asuntokuntia: 4545,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 90.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.600000000000001,
    Taloudellinen_huoltosuhde: 155.90000000000001,
    Tyopaikkaomavaraisuus: 77.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 3555,
    Ika20_64v_tyollisyysaste: 74.0,
    Asuinkunnassaan_tyossakayvia: 58.100000000000001,
    Tyottomia: 10.699999999999999,
    Elakelaisia: 34.200000000000003,
    Alueella_olevia_tyopaikkoja: 2763,
    Alkutuotannon_tyopaikkoja: 16.5,
    Jalostuksen_tyopaikkoja: 25.600000000000001,
    Palvelujen_tyopaikkoja: 56.5,
  },
  {
    Kunta: "Lappajärvi",
    Vakiluku: 2789,
    Vakiluvun_muutos: -1.1000000000000001,
    Alle15v: 13.4,
    Ika15_64v: 48.399999999999999,
    Yli64v: 38.100000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 5.0999999999999996,
    Taajamaa: 54.200000000000003,
    Syntyneiden_enemmyys: -28,
    Muuttovoitto: -49,
    Perheita: 783,
    Asuntokuntia: 1330,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 15.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.199999999999999,
    Taloudellinen_huoltosuhde: 189.80000000000001,
    Tyopaikkaomavaraisuus: 83.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 973,
    Ika20_64v_tyollisyysaste: 74.900000000000006,
    Asuinkunnassaan_tyossakayvia: 59.200000000000003,
    Tyottomia: 8.0,
    Elakelaisia: 41.200000000000003,
    Alueella_olevia_tyopaikkoja: 814,
    Alkutuotannon_tyopaikkoja: 15.6,
    Jalostuksen_tyopaikkoja: 20.600000000000001,
    Palvelujen_tyopaikkoja: 62.5,
  },
  {
    Kunta: "Lappeenranta",
    Vakiluku: 72988,
    Vakiluvun_muutos: 0.5,
    Alle15v: 12.9,
    Ika15_64v: 62.0,
    Yli64v: 25.199999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 6.2999999999999998,
    Taajamaa: 90.700000000000003,
    Syntyneiden_enemmyys: -464,
    Muuttovoitto: -315,
    Perheita: 18722,
    Asuntokuntia: 39478,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 44.100000000000001,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 38.700000000000003,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 32.0,
    Taloudellinen_huoltosuhde: 145.40000000000001,
    Tyopaikkaomavaraisuus: 107.2,
    Alueella_asuva_tyollinen_tyovoima: 29602,
    Ika20_64v_tyollisyysaste: 70.099999999999994,
    Asuinkunnassaan_tyossakayvia: 84.200000000000003,
    Tyottomia: 11.1,
    Elakelaisia: 28.100000000000001,
    Alueella_olevia_tyopaikkoja: 31746,
    Alkutuotannon_tyopaikkoja: 1.3999999999999999,
    Jalostuksen_tyopaikkoja: 22.899999999999999,
    Palvelujen_tyopaikkoja: 74.700000000000003,
  },
  {
    Kunta: "Lapua",
    Vakiluku: 14024,
    Vakiluvun_muutos: -0.5,
    Alle15v: 16.699999999999999,
    Ika15_64v: 57.700000000000003,
    Yli64v: 25.600000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.0,
    Taajamaa: 78.5,
    Syntyneiden_enemmyys: -90,
    Muuttovoitto: -126,
    Perheita: 3847,
    Asuntokuntia: 6501,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 81.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 29.399999999999999,
    Taloudellinen_huoltosuhde: 138.30000000000001,
    Tyopaikkaomavaraisuus: 77.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 5916,
    Ika20_64v_tyollisyysaste: 78.900000000000006,
    Asuinkunnassaan_tyossakayvia: 54.899999999999999,
    Tyottomia: 6.5,
    Elakelaisia: 29.100000000000001,
    Alueella_olevia_tyopaikkoja: 4588,
    Alkutuotannon_tyopaikkoja: 7.5999999999999996,
    Jalostuksen_tyopaikkoja: 32.700000000000003,
    Palvelujen_tyopaikkoja: 58.700000000000003,
  },
  {
    Kunta: "Laukaa",
    Vakiluku: 18762,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 21.300000000000001,
    Ika15_64v: 57.0,
    Yli64v: 21.699999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.3999999999999999,
    Taajamaa: 73.599999999999994,
    Syntyneiden_enemmyys: -62,
    Muuttovoitto: -43,
    Perheita: 5167,
    Asuntokuntia: 8068,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 86.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 76.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 29.199999999999999,
    Taloudellinen_huoltosuhde: 143.69999999999999,
    Tyopaikkaomavaraisuus: 70.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 7705,
    Ika20_64v_tyollisyysaste: 78.799999999999997,
    Asuinkunnassaan_tyossakayvia: 37.799999999999997,
    Tyottomia: 9.6999999999999993,
    Elakelaisia: 24.300000000000001,
    Alueella_olevia_tyopaikkoja: 5412,
    Alkutuotannon_tyopaikkoja: 4.0999999999999996,
    Jalostuksen_tyopaikkoja: 27.199999999999999,
    Palvelujen_tyopaikkoja: 67.0,
  },
  {
    Kunta: "Lemi",
    Vakiluku: 2862,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 16.600000000000001,
    Ika15_64v: 56.399999999999999,
    Yli64v: 26.899999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.2,
    Taajamaa: 57.200000000000003,
    Syntyneiden_enemmyys: -19,
    Muuttovoitto: -7,
    Perheita: 821,
    Asuntokuntia: 1349,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 14.9,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.199999999999999,
    Taloudellinen_huoltosuhde: 140.90000000000001,
    Tyopaikkaomavaraisuus: 38.899999999999999,
    Alueella_asuva_tyollinen_tyovoima: 1198,
    Ika20_64v_tyollisyysaste: 78.799999999999997,
    Asuinkunnassaan_tyossakayvia: 24.0,
    Tyottomia: 8.5,
    Elakelaisia: 29.899999999999999,
    Alueella_olevia_tyopaikkoja: 466,
    Alkutuotannon_tyopaikkoja: 12.0,
    Jalostuksen_tyopaikkoja: 18.199999999999999,
    Palvelujen_tyopaikkoja: 66.299999999999997,
  },
  {
    Kunta: "Lemland",
    Vakiluku: 2127,
    Vakiluvun_muutos: -0.20000000000000001,
    Alle15v: 20.800000000000001,
    Ika15_64v: 59.5,
    Yli64v: 19.699999999999999,
    Ruotsinkielisia: 91.299999999999997,
    Ulkomaan_kansalaisia: 9.1999999999999993,
    Taajamaa: 33.5,
    Syntyneiden_enemmyys: 5,
    Muuttovoitto: -13,
    Perheita: 636,
    Asuntokuntia: 866,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 11.1,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 32.600000000000001,
    Taloudellinen_huoltosuhde: 103.7,
    Tyopaikkaomavaraisuus: 35.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 1046,
    Ika20_64v_tyollisyysaste: 87.0,
    Asuinkunnassaan_tyossakayvia: 20.0,
    Tyottomia: 2.2000000000000002,
    Elakelaisia: 19.300000000000001,
    Alueella_olevia_tyopaikkoja: 374,
    Alkutuotannon_tyopaikkoja: 4.2999999999999998,
    Jalostuksen_tyopaikkoja: 19.300000000000001,
    Palvelujen_tyopaikkoja: 67.900000000000006,
  },
  {
    Kunta: "Lempäälä",
    Vakiluku: 24711,
    Vakiluvun_muutos: 0.5,
    Alle15v: 20.5,
    Ika15_64v: 62.0,
    Yli64v: 17.5,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 1.7,
    Taajamaa: 89.900000000000006,
    Syntyneiden_enemmyys: 70,
    Muuttovoitto: 44,
    Perheita: 6920,
    Asuntokuntia: 10719,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 72.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 79.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 39.200000000000003,
    Taloudellinen_huoltosuhde: 115.3,
    Tyopaikkaomavaraisuus: 70.5,
    Alueella_asuva_tyollinen_tyovoima: 11416,
    Ika20_64v_tyollisyysaste: 82.400000000000006,
    Asuinkunnassaan_tyossakayvia: 30.5,
    Tyottomia: 5.9000000000000004,
    Elakelaisia: 19.100000000000001,
    Alueella_olevia_tyopaikkoja: 8048,
    Alkutuotannon_tyopaikkoja: 2.0,
    Jalostuksen_tyopaikkoja: 25.399999999999999,
    Palvelujen_tyopaikkoja: 71.0,
  },
  {
    Kunta: "Leppävirta",
    Vakiluku: 9049,
    Vakiluvun_muutos: -1.3999999999999999,
    Alle15v: 12.9,
    Ika15_64v: 53.5,
    Yli64v: 33.600000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.8,
    Taajamaa: 58.0,
    Syntyneiden_enemmyys: -75,
    Muuttovoitto: -75,
    Perheita: 2569,
    Asuntokuntia: 4633,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 83.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.0,
    Taloudellinen_huoltosuhde: 157.59999999999999,
    Tyopaikkaomavaraisuus: 80.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 3562,
    Ika20_64v_tyollisyysaste: 74.900000000000006,
    Asuinkunnassaan_tyossakayvia: 55.0,
    Tyottomia: 9.0999999999999996,
    Elakelaisia: 37.100000000000001,
    Alueella_olevia_tyopaikkoja: 2863,
    Alkutuotannon_tyopaikkoja: 6.7000000000000002,
    Jalostuksen_tyopaikkoja: 40.700000000000003,
    Palvelujen_tyopaikkoja: 51.600000000000001,
  },
  {
    Kunta: "Lestijärvi",
    Vakiluku: 682,
    Vakiluvun_muutos: -1.8999999999999999,
    Alle15v: 16.0,
    Ika15_64v: 50.299999999999997,
    Yli64v: 33.700000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.2,
    Taajamaa: 33.700000000000003,
    Syntyneiden_enemmyys: -19,
    Muuttovoitto: 6,
    Perheita: 189,
    Asuntokuntia: 315,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.699999999999999,
    Taloudellinen_huoltosuhde: 184.80000000000001,
    Tyopaikkaomavaraisuus: 100.8,
    Alueella_asuva_tyollinen_tyovoima: 244,
    Ika20_64v_tyollisyysaste: 72.900000000000006,
    Asuinkunnassaan_tyossakayvia: 65.200000000000003,
    Tyottomia: 7.2000000000000002,
    Elakelaisia: 38.700000000000003,
    Alueella_olevia_tyopaikkoja: 246,
    Alkutuotannon_tyopaikkoja: 32.5,
    Jalostuksen_tyopaikkoja: 15.0,
    Palvelujen_tyopaikkoja: 51.600000000000001,
  },
  {
    Kunta: "Lieksa",
    Vakiluku: 10228,
    Vakiluvun_muutos: -1.3999999999999999,
    Alle15v: 9.3000000000000007,
    Ika15_64v: 49.5,
    Yli64v: 41.200000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 4.5,
    Taajamaa: 69.700000000000003,
    Syntyneiden_enemmyys: -169,
    Muuttovoitto: -86,
    Perheita: 2645,
    Asuntokuntia: 5823,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 72.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 25.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.600000000000001,
    Taloudellinen_huoltosuhde: 220.09999999999999,
    Tyopaikkaomavaraisuus: 100.5,
    Alueella_asuva_tyollinen_tyovoima: 3240,
    Ika20_64v_tyollisyysaste: 64.400000000000006,
    Asuinkunnassaan_tyossakayvia: 86.400000000000006,
    Tyottomia: 16.300000000000001,
    Elakelaisia: 45.399999999999999,
    Alueella_olevia_tyopaikkoja: 3257,
    Alkutuotannon_tyopaikkoja: 7.4000000000000004,
    Jalostuksen_tyopaikkoja: 23.899999999999999,
    Palvelujen_tyopaikkoja: 67.599999999999994,
  },
  {
    Kunta: "Lieto",
    Vakiluku: 20637,
    Vakiluvun_muutos: 0.69999999999999996,
    Alle15v: 18.800000000000001,
    Ika15_64v: 60.600000000000001,
    Yli64v: 20.600000000000001,
    Ruotsinkielisia: 1.5,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 84.5,
    Syntyneiden_enemmyys: 12,
    Muuttovoitto: 81,
    Perheita: 6166,
    Asuntokuntia: 8945,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 78.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 77.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 36.600000000000001,
    Taloudellinen_huoltosuhde: 111.59999999999999,
    Tyopaikkaomavaraisuus: 72.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 9688,
    Ika20_64v_tyollisyysaste: 84.200000000000003,
    Asuinkunnassaan_tyossakayvia: 28.100000000000001,
    Tyottomia: 4.7000000000000002,
    Elakelaisia: 22.600000000000001,
    Alueella_olevia_tyopaikkoja: 7002,
    Alkutuotannon_tyopaikkoja: 2.6000000000000001,
    Jalostuksen_tyopaikkoja: 32.299999999999997,
    Palvelujen_tyopaikkoja: 63.399999999999999,
  },
  {
    Kunta: "Liminka",
    Vakiluku: 10256,
    Vakiluvun_muutos: 0.0,
    Alle15v: 29.5,
    Ika15_64v: 59.100000000000001,
    Yli64v: 11.4,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 0.59999999999999998,
    Taajamaa: 81.400000000000006,
    Syntyneiden_enemmyys: 76,
    Muuttovoitto: -103,
    Perheita: 2569,
    Asuntokuntia: 3489,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 14.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 76.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 34.299999999999997,
    Taloudellinen_huoltosuhde: 140.09999999999999,
    Tyopaikkaomavaraisuus: 61.399999999999999,
    Alueella_asuva_tyollinen_tyovoima: 4272,
    Ika20_64v_tyollisyysaste: 81.900000000000006,
    Asuinkunnassaan_tyossakayvia: 30.5,
    Tyottomia: 6.4000000000000004,
    Elakelaisia: 13.4,
    Alueella_olevia_tyopaikkoja: 2625,
    Alkutuotannon_tyopaikkoja: 5.5999999999999996,
    Jalostuksen_tyopaikkoja: 21.899999999999999,
    Palvelujen_tyopaikkoja: 70.900000000000006,
  },
  {
    Kunta: "Liperi",
    Vakiluku: 11969,
    Vakiluvun_muutos: 0.10000000000000001,
    Alle15v: 17.399999999999999,
    Ika15_64v: 58.600000000000001,
    Yli64v: 24.0,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 1.3999999999999999,
    Taajamaa: 57.899999999999999,
    Syntyneiden_enemmyys: -26,
    Muuttovoitto: 3,
    Perheita: 3336,
    Asuntokuntia: 5565,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 78.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 28.199999999999999,
    Taloudellinen_huoltosuhde: 139.0,
    Tyopaikkaomavaraisuus: 67.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 5004,
    Ika20_64v_tyollisyysaste: 76.099999999999994,
    Asuinkunnassaan_tyossakayvia: 35.600000000000001,
    Tyottomia: 10.6,
    Elakelaisia: 27.399999999999999,
    Alueella_olevia_tyopaikkoja: 3369,
    Alkutuotannon_tyopaikkoja: 9.3000000000000007,
    Jalostuksen_tyopaikkoja: 25.100000000000001,
    Palvelujen_tyopaikkoja: 64.299999999999997,
  },
  {
    Kunta: "Lohja",
    Vakiluku: 45645,
    Vakiluvun_muutos: -0.40000000000000002,
    Alle15v: 14.6,
    Ika15_64v: 59.299999999999997,
    Yli64v: 26.199999999999999,
    Ruotsinkielisia: 3.5,
    Ulkomaan_kansalaisia: 4.7000000000000002,
    Taajamaa: 82.400000000000006,
    Syntyneiden_enemmyys: -308,
    Muuttovoitto: -136,
    Perheita: 12597,
    Asuntokuntia: 22422,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 63.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 27.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 28.199999999999999,
    Taloudellinen_huoltosuhde: 134.40000000000001,
    Tyopaikkaomavaraisuus: 79.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 19548,
    Ika20_64v_tyollisyysaste: 77.200000000000003,
    Asuinkunnassaan_tyossakayvia: 57.899999999999999,
    Tyottomia: 8.9000000000000004,
    Elakelaisia: 28.600000000000001,
    Alueella_olevia_tyopaikkoja: 15577,
    Alkutuotannon_tyopaikkoja: 2.2999999999999998,
    Jalostuksen_tyopaikkoja: 26.0,
    Palvelujen_tyopaikkoja: 70.099999999999994,
  },
  {
    Kunta: "Loimaa",
    Vakiluku: 15420,
    Vakiluvun_muutos: 0.20000000000000001,
    Alle15v: 13.0,
    Ika15_64v: 54.399999999999999,
    Yli64v: 32.600000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 4.7000000000000002,
    Taajamaa: 67.799999999999997,
    Syntyneiden_enemmyys: -137,
    Muuttovoitto: -51,
    Perheita: 4090,
    Asuntokuntia: 8060,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 74.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.5,
    Taloudellinen_huoltosuhde: 157.30000000000001,
    Tyopaikkaomavaraisuus: 103.2,
    Alueella_asuva_tyollinen_tyovoima: 5983,
    Ika20_64v_tyollisyysaste: 74.5,
    Asuinkunnassaan_tyossakayvia: 74.200000000000003,
    Tyottomia: 8.6999999999999993,
    Elakelaisia: 35.700000000000003,
    Alueella_olevia_tyopaikkoja: 6177,
    Alkutuotannon_tyopaikkoja: 8.8000000000000007,
    Jalostuksen_tyopaikkoja: 30.199999999999999,
    Palvelujen_tyopaikkoja: 59.799999999999997,
  },
  {
    Kunta: "Loppi",
    Vakiluku: 7692,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 15.0,
    Ika15_64v: 57.700000000000003,
    Yli64v: 27.399999999999999,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 56.100000000000001,
    Syntyneiden_enemmyys: -64,
    Muuttovoitto: -5,
    Perheita: 2175,
    Asuntokuntia: 3569,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 14.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.600000000000001,
    Taloudellinen_huoltosuhde: 131.40000000000001,
    Tyopaikkaomavaraisuus: 58.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 3349,
    Ika20_64v_tyollisyysaste: 80.200000000000003,
    Asuinkunnassaan_tyossakayvia: 34.600000000000001,
    Tyottomia: 5.5,
    Elakelaisia: 30.100000000000001,
    Alueella_olevia_tyopaikkoja: 1951,
    Alkutuotannon_tyopaikkoja: 8.5,
    Jalostuksen_tyopaikkoja: 25.699999999999999,
    Palvelujen_tyopaikkoja: 64.0,
  },
  {
    Kunta: "Loviisa",
    Vakiluku: 14458,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 12.9,
    Ika15_64v: 56.0,
    Yli64v: 31.100000000000001,
    Ruotsinkielisia: 39.0,
    Ulkomaan_kansalaisia: 4.5,
    Taajamaa: 74.5,
    Syntyneiden_enemmyys: -158,
    Muuttovoitto: -59,
    Perheita: 3993,
    Asuntokuntia: 7454,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 72.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 27.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.0,
    Taloudellinen_huoltosuhde: 144.5,
    Tyopaikkaomavaraisuus: 82.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 5958,
    Ika20_64v_tyollisyysaste: 76.400000000000006,
    Asuinkunnassaan_tyossakayvia: 57.0,
    Tyottomia: 10.0,
    Elakelaisia: 34.0,
    Alueella_olevia_tyopaikkoja: 4889,
    Alkutuotannon_tyopaikkoja: 5.0,
    Jalostuksen_tyopaikkoja: 35.899999999999999,
    Palvelujen_tyopaikkoja: 57.100000000000001,
  },
  {
    Kunta: "Luhanka",
    Vakiluku: 702,
    Vakiluvun_muutos: 1.3999999999999999,
    Alle15v: 9.0,
    Ika15_64v: 47.399999999999999,
    Yli64v: 43.600000000000001,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 0.69999999999999996,
    Taajamaa: 0.0,
    Syntyneiden_enemmyys: -8,
    Muuttovoitto: 14,
    Perheita: 190,
    Asuntokuntia: 380,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.800000000000001,
    Taloudellinen_huoltosuhde: 180.19999999999999,
    Tyopaikkaomavaraisuus: 65.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 247,
    Ika20_64v_tyollisyysaste: 71.700000000000003,
    Asuinkunnassaan_tyossakayvia: 42.5,
    Tyottomia: 13.0,
    Elakelaisia: 46.700000000000003,
    Alueella_olevia_tyopaikkoja: 161,
    Alkutuotannon_tyopaikkoja: 21.699999999999999,
    Jalostuksen_tyopaikkoja: 16.100000000000001,
    Palvelujen_tyopaikkoja: 59.600000000000001,
  },
  {
    Kunta: "Lumijoki",
    Vakiluku: 2033,
    Vakiluvun_muutos: 2.2999999999999998,
    Alle15v: 23.800000000000001,
    Ika15_64v: 56.5,
    Yli64v: 19.800000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 4.2000000000000002,
    Taajamaa: 65.299999999999997,
    Syntyneiden_enemmyys: -5,
    Muuttovoitto: -9,
    Perheita: 501,
    Asuntokuntia: 776,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 98.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.100000000000001,
    Taloudellinen_huoltosuhde: 154.90000000000001,
    Tyopaikkaomavaraisuus: 61.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 780,
    Ika20_64v_tyollisyysaste: 79.299999999999997,
    Asuinkunnassaan_tyossakayvia: 35.100000000000001,
    Tyottomia: 7.4000000000000004,
    Elakelaisia: 22.100000000000001,
    Alueella_olevia_tyopaikkoja: 482,
    Alkutuotannon_tyopaikkoja: 19.5,
    Jalostuksen_tyopaikkoja: 16.0,
    Palvelujen_tyopaikkoja: 61.600000000000001,
  },
  {
    Kunta: "Lumparland",
    Vakiluku: 366,
    Vakiluvun_muutos: 1.7,
    Alle15v: 12.800000000000001,
    Ika15_64v: 57.700000000000003,
    Yli64v: 29.5,
    Ruotsinkielisia: 84.700000000000003,
    Ulkomaan_kansalaisia: 11.5,
    Taajamaa: 0.0,
    Syntyneiden_enemmyys: 0,
    Muuttovoitto: 2,
    Perheita: 110,
    Asuntokuntia: 165,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 29.600000000000001,
    Taloudellinen_huoltosuhde: 98.900000000000006,
    Tyopaikkaomavaraisuus: 59.100000000000001,
    Alueella_asuva_tyollinen_tyovoima: 181,
    Ika20_64v_tyollisyysaste: 90.299999999999997,
    Asuinkunnassaan_tyossakayvia: 26.5,
    Tyottomia: 2.7000000000000002,
    Elakelaisia: 26.399999999999999,
    Alueella_olevia_tyopaikkoja: 107,
    Alkutuotannon_tyopaikkoja: 11.199999999999999,
    Jalostuksen_tyopaikkoja: 5.5999999999999996,
    Palvelujen_tyopaikkoja: 73.799999999999997,
  },
  {
    Kunta: "Luoto",
    Vakiluku: 5843,
    Vakiluvun_muutos: 1.8999999999999999,
    Alle15v: 29.399999999999999,
    Ika15_64v: 56.299999999999997,
    Yli64v: 14.300000000000001,
    Ruotsinkielisia: 91.5,
    Ulkomaan_kansalaisia: 3.1000000000000001,
    Taajamaa: 90.200000000000003,
    Syntyneiden_enemmyys: 81,
    Muuttovoitto: -9,
    Perheita: 1480,
    Asuntokuntia: 1863,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.199999999999999,
    Taloudellinen_huoltosuhde: 127.09999999999999,
    Tyopaikkaomavaraisuus: 48.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 2524,
    Ika20_64v_tyollisyysaste: 86.0,
    Asuinkunnassaan_tyossakayvia: 29.699999999999999,
    Tyottomia: 1.8,
    Elakelaisia: 15.800000000000001,
    Alueella_olevia_tyopaikkoja: 1220,
    Alkutuotannon_tyopaikkoja: 2.5,
    Jalostuksen_tyopaikkoja: 44.0,
    Palvelujen_tyopaikkoja: 52.0,
  },
  {
    Kunta: "Luumäki",
    Vakiluku: 4396,
    Vakiluvun_muutos: -0.59999999999999998,
    Alle15v: 11.199999999999999,
    Ika15_64v: 52.399999999999999,
    Yli64v: 36.399999999999999,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 3.2000000000000002,
    Taajamaa: 62.600000000000001,
    Syntyneiden_enemmyys: -34,
    Muuttovoitto: -32,
    Perheita: 1210,
    Asuntokuntia: 2357,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 87.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.0,
    Taloudellinen_huoltosuhde: 166.5,
    Tyopaikkaomavaraisuus: 70.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 1659,
    Ika20_64v_tyollisyysaste: 74.799999999999997,
    Asuinkunnassaan_tyossakayvia: 51.100000000000001,
    Tyottomia: 11.699999999999999,
    Elakelaisia: 38.799999999999997,
    Alueella_olevia_tyopaikkoja: 1172,
    Alkutuotannon_tyopaikkoja: 16.899999999999999,
    Jalostuksen_tyopaikkoja: 19.199999999999999,
    Palvelujen_tyopaikkoja: 62.799999999999997,
  },
  {
    Kunta: "Maalahti",
    Vakiluku: 5456,
    Vakiluvun_muutos: -0.40000000000000002,
    Alle15v: 15.800000000000001,
    Ika15_64v: 54.700000000000003,
    Yli64v: 29.5,
    Ruotsinkielisia: 84.799999999999997,
    Ulkomaan_kansalaisia: 4.7999999999999998,
    Taajamaa: 72.0,
    Syntyneiden_enemmyys: -15,
    Muuttovoitto: -44,
    Perheita: 1563,
    Asuntokuntia: 2546,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 29.899999999999999,
    Taloudellinen_huoltosuhde: 121.3,
    Tyopaikkaomavaraisuus: 71.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 2476,
    Ika20_64v_tyollisyysaste: 84.900000000000006,
    Asuinkunnassaan_tyossakayvia: 48.0,
    Tyottomia: 4.0999999999999996,
    Elakelaisia: 30.399999999999999,
    Alueella_olevia_tyopaikkoja: 1779,
    Alkutuotannon_tyopaikkoja: 9.5,
    Jalostuksen_tyopaikkoja: 32.299999999999997,
    Palvelujen_tyopaikkoja: 56.899999999999999,
  },
  {
    Kunta: "Maarianhamina - Mariehamn",
    Vakiluku: 11812,
    Vakiluvun_muutos: 0.5,
    Alle15v: 13.800000000000001,
    Ika15_64v: 59.899999999999999,
    Yli64v: 26.300000000000001,
    Ruotsinkielisia: 81.5,
    Ulkomaan_kansalaisia: 15.300000000000001,
    Taajamaa: 99.5,
    Syntyneiden_enemmyys: -35,
    Muuttovoitto: -20,
    Perheita: 2982,
    Asuntokuntia: 6233,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 41.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 44.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 34.200000000000003,
    Taloudellinen_huoltosuhde: 118.0,
    Tyopaikkaomavaraisuus: 175.19999999999999,
    Alueella_asuva_tyollinen_tyovoima: 5393,
    Ika20_64v_tyollisyysaste: 78.700000000000003,
    Asuinkunnassaan_tyossakayvia: 75.099999999999994,
    Tyottomia: 5.9000000000000004,
    Elakelaisia: 26.800000000000001,
    Alueella_olevia_tyopaikkoja: 9447,
    Alkutuotannon_tyopaikkoja: 0.0,
    Jalostuksen_tyopaikkoja: 8.9000000000000004,
    Palvelujen_tyopaikkoja: 89.799999999999997,
  },
  {
    Kunta: "Marttila",
    Vakiluku: 1930,
    Vakiluvun_muutos: -2.3999999999999999,
    Alle15v: 15.800000000000001,
    Ika15_64v: 55.200000000000003,
    Yli64v: 29.0,
    Ruotsinkielisia: 1.0,
    Ulkomaan_kansalaisia: 2.8999999999999999,
    Taajamaa: 46.0,
    Syntyneiden_enemmyys: -14,
    Muuttovoitto: -44,
    Perheita: 525,
    Asuntokuntia: 960,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.699999999999999,
    Taloudellinen_huoltosuhde: 143.30000000000001,
    Tyopaikkaomavaraisuus: 58.5,
    Alueella_asuva_tyollinen_tyovoima: 813,
    Ika20_64v_tyollisyysaste: 77.799999999999997,
    Asuinkunnassaan_tyossakayvia: 36.700000000000003,
    Tyottomia: 7.0999999999999996,
    Elakelaisia: 30.899999999999999,
    Alueella_olevia_tyopaikkoja: 476,
    Alkutuotannon_tyopaikkoja: 16.600000000000001,
    Jalostuksen_tyopaikkoja: 23.899999999999999,
    Palvelujen_tyopaikkoja: 57.799999999999997,
  },
  {
    Kunta: "Masku",
    Vakiluku: 9619,
    Vakiluvun_muutos: -0.20000000000000001,
    Alle15v: 18.699999999999999,
    Ika15_64v: 61.700000000000003,
    Yli64v: 19.600000000000001,
    Ruotsinkielisia: 1.2,
    Ulkomaan_kansalaisia: 1.8,
    Taajamaa: 82.0,
    Syntyneiden_enemmyys: -5,
    Muuttovoitto: -36,
    Perheita: 2943,
    Asuntokuntia: 3999,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 7.7000000000000002,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 78.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 34.5,
    Taloudellinen_huoltosuhde: 109.0,
    Tyopaikkaomavaraisuus: 53.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 4614,
    Ika20_64v_tyollisyysaste: 84.700000000000003,
    Asuinkunnassaan_tyossakayvia: 21.100000000000001,
    Tyottomia: 5.2000000000000002,
    Elakelaisia: 21.5,
    Alueella_olevia_tyopaikkoja: 2460,
    Alkutuotannon_tyopaikkoja: 3.6000000000000001,
    Jalostuksen_tyopaikkoja: 26.899999999999999,
    Palvelujen_tyopaikkoja: 68.0,
  },
  {
    Kunta: "Merijärvi",
    Vakiluku: 1055,
    Vakiluvun_muutos: -1.1000000000000001,
    Alle15v: 25.100000000000001,
    Ika15_64v: 48.700000000000003,
    Yli64v: 26.199999999999999,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 0.20000000000000001,
    Taajamaa: 37.299999999999997,
    Syntyneiden_enemmyys: 6,
    Muuttovoitto: -18,
    Perheita: 248,
    Asuntokuntia: 428,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 13.699999999999999,
    Taloudellinen_huoltosuhde: 175.69999999999999,
    Tyopaikkaomavaraisuus: 69.5,
    Alueella_asuva_tyollinen_tyovoima: 387,
    Ika20_64v_tyollisyysaste: 79.099999999999994,
    Asuinkunnassaan_tyossakayvia: 45.5,
    Tyottomia: 7.2000000000000002,
    Elakelaisia: 28.300000000000001,
    Alueella_olevia_tyopaikkoja: 269,
    Alkutuotannon_tyopaikkoja: 24.5,
    Jalostuksen_tyopaikkoja: 14.1,
    Palvelujen_tyopaikkoja: 60.200000000000003,
  },
  {
    Kunta: "Merikarvia",
    Vakiluku: 2966,
    Vakiluvun_muutos: 0.0,
    Alle15v: 14.800000000000001,
    Ika15_64v: 48.799999999999997,
    Yli64v: 36.299999999999997,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 2.7999999999999998,
    Taajamaa: 56.600000000000001,
    Syntyneiden_enemmyys: -38,
    Muuttovoitto: 5,
    Perheita: 801,
    Asuntokuntia: 1457,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 87.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.699999999999999,
    Taloudellinen_huoltosuhde: 187.80000000000001,
    Tyopaikkaomavaraisuus: 89.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 1031,
    Ika20_64v_tyollisyysaste: 73.700000000000003,
    Asuinkunnassaan_tyossakayvia: 67.5,
    Tyottomia: 10.800000000000001,
    Elakelaisia: 40.100000000000001,
    Alueella_olevia_tyopaikkoja: 927,
    Alkutuotannon_tyopaikkoja: 10.699999999999999,
    Jalostuksen_tyopaikkoja: 32.899999999999999,
    Palvelujen_tyopaikkoja: 54.799999999999997,
  },
  {
    Kunta: "Miehikkälä",
    Vakiluku: 1752,
    Vakiluvun_muutos: -2.2000000000000002,
    Alle15v: 9.0999999999999996,
    Ika15_64v: 51.799999999999997,
    Yli64v: 39.100000000000001,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 4.2999999999999998,
    Taajamaa: 29.899999999999999,
    Syntyneiden_enemmyys: -27,
    Muuttovoitto: -38,
    Perheita: 479,
    Asuntokuntia: 922,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 62.399999999999999,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.0,
    Taloudellinen_huoltosuhde: 182.90000000000001,
    Tyopaikkaomavaraisuus: 71.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 633,
    Ika20_64v_tyollisyysaste: 71.099999999999994,
    Asuinkunnassaan_tyossakayvia: 47.200000000000003,
    Tyottomia: 10.300000000000001,
    Elakelaisia: 44.100000000000001,
    Alueella_olevia_tyopaikkoja: 450,
    Alkutuotannon_tyopaikkoja: 22.0,
    Jalostuksen_tyopaikkoja: 6.9000000000000004,
    Palvelujen_tyopaikkoja: 69.599999999999994,
  },
  {
    Kunta: "Mikkeli",
    Vakiluku: 51919,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 13.300000000000001,
    Ika15_64v: 58.200000000000003,
    Yli64v: 28.5,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.7000000000000002,
    Taajamaa: 81.299999999999997,
    Syntyneiden_enemmyys: -385,
    Muuttovoitto: -152,
    Perheita: 13630,
    Asuntokuntia: 27730,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 54.399999999999999,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 33.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 76.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 31.899999999999999,
    Taloudellinen_huoltosuhde: 144.5,
    Tyopaikkaomavaraisuus: 103.3,
    Alueella_asuva_tyollinen_tyovoima: 21256,
    Ika20_64v_tyollisyysaste: 74.200000000000003,
    Asuinkunnassaan_tyossakayvia: 88.5,
    Tyottomia: 10.1,
    Elakelaisia: 31.300000000000001,
    Alueella_olevia_tyopaikkoja: 21966,
    Alkutuotannon_tyopaikkoja: 2.8999999999999999,
    Jalostuksen_tyopaikkoja: 19.0,
    Palvelujen_tyopaikkoja: 77.099999999999994,
  },
  {
    Kunta: "Muhos",
    Vakiluku: 8827,
    Vakiluvun_muutos: -0.59999999999999998,
    Alle15v: 22.100000000000001,
    Ika15_64v: 58.0,
    Yli64v: 19.899999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.1000000000000001,
    Taajamaa: 80.0,
    Syntyneiden_enemmyys: -8,
    Muuttovoitto: -59,
    Perheita: 2282,
    Asuntokuntia: 3707,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.899999999999999,
    Taloudellinen_huoltosuhde: 152.5,
    Tyopaikkaomavaraisuus: 73.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 3518,
    Ika20_64v_tyollisyysaste: 75.900000000000006,
    Asuinkunnassaan_tyossakayvia: 46.100000000000001,
    Tyottomia: 9.9000000000000004,
    Elakelaisia: 23.699999999999999,
    Alueella_olevia_tyopaikkoja: 2571,
    Alkutuotannon_tyopaikkoja: 7.0,
    Jalostuksen_tyopaikkoja: 12.0,
    Palvelujen_tyopaikkoja: 79.900000000000006,
  },
  {
    Kunta: "Multia",
    Vakiluku: 1430,
    Vakiluvun_muutos: -3.2000000000000002,
    Alle15v: 12.300000000000001,
    Ika15_64v: 48.299999999999997,
    Yli64v: 39.399999999999999,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 49.799999999999997,
    Syntyneiden_enemmyys: -25,
    Muuttovoitto: -31,
    Perheita: 380,
    Asuntokuntia: 736,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.800000000000001,
    Taloudellinen_huoltosuhde: 190.69999999999999,
    Tyopaikkaomavaraisuus: 105.5,
    Alueella_asuva_tyollinen_tyovoima: 508,
    Ika20_64v_tyollisyysaste: 71.700000000000003,
    Asuinkunnassaan_tyossakayvia: 55.100000000000001,
    Tyottomia: 11.300000000000001,
    Elakelaisia: 40.799999999999997,
    Alueella_olevia_tyopaikkoja: 536,
    Alkutuotannon_tyopaikkoja: 33.600000000000001,
    Jalostuksen_tyopaikkoja: 20.100000000000001,
    Palvelujen_tyopaikkoja: 44.600000000000001,
  },
  {
    Kunta: "Muonio",
    Vakiluku: 2325,
    Vakiluvun_muutos: 1.8999999999999999,
    Alle15v: 14.699999999999999,
    Ika15_64v: 57.5,
    Yli64v: 27.899999999999999,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 3.8999999999999999,
    Taajamaa: 52.299999999999997,
    Syntyneiden_enemmyys: -19,
    Muuttovoitto: 54,
    Perheita: 614,
    Asuntokuntia: 1066,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 76.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.5,
    Taloudellinen_huoltosuhde: 130.90000000000001,
    Tyopaikkaomavaraisuus: 106.3,
    Alueella_asuva_tyollinen_tyovoima: 988,
    Ika20_64v_tyollisyysaste: 78.799999999999997,
    Asuinkunnassaan_tyossakayvia: 80.599999999999994,
    Tyottomia: 7.5999999999999996,
    Elakelaisia: 30.800000000000001,
    Alueella_olevia_tyopaikkoja: 1050,
    Alkutuotannon_tyopaikkoja: 3.2999999999999998,
    Jalostuksen_tyopaikkoja: 8.1999999999999993,
    Palvelujen_tyopaikkoja: 87.099999999999994,
  },
  {
    Kunta: "Mustasaari",
    Vakiluku: 19763,
    Vakiluvun_muutos: 0.5,
    Alle15v: 18.899999999999999,
    Ika15_64v: 58.200000000000003,
    Yli64v: 23.0,
    Ruotsinkielisia: 68.200000000000003,
    Ulkomaan_kansalaisia: 2.6000000000000001,
    Taajamaa: 81.299999999999997,
    Syntyneiden_enemmyys: -7,
    Muuttovoitto: 33,
    Perheita: 5881,
    Asuntokuntia: 8432,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 88.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.6,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 78.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 39.100000000000001,
    Taloudellinen_huoltosuhde: 111.40000000000001,
    Tyopaikkaomavaraisuus: 56.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 9303,
    Ika20_64v_tyollisyysaste: 87.700000000000003,
    Asuinkunnassaan_tyossakayvia: 31.100000000000001,
    Tyottomia: 3.2000000000000002,
    Elakelaisia: 24.0,
    Alueella_olevia_tyopaikkoja: 5284,
    Alkutuotannon_tyopaikkoja: 5.2999999999999998,
    Jalostuksen_tyopaikkoja: 28.100000000000001,
    Palvelujen_tyopaikkoja: 64.599999999999994,
  },
  {
    Kunta: "Muurame",
    Vakiluku: 10551,
    Vakiluvun_muutos: 0.59999999999999998,
    Alle15v: 20.5,
    Ika15_64v: 59.5,
    Yli64v: 20.100000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.2,
    Taajamaa: 89.599999999999994,
    Syntyneiden_enemmyys: 13,
    Muuttovoitto: 44,
    Perheita: 3042,
    Asuntokuntia: 4463,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 77.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 80.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 39.5,
    Taloudellinen_huoltosuhde: 126.90000000000001,
    Tyopaikkaomavaraisuus: 61.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 4622,
    Ika20_64v_tyollisyysaste: 81.299999999999997,
    Asuinkunnassaan_tyossakayvia: 28.600000000000001,
    Tyottomia: 7.7000000000000002,
    Elakelaisia: 21.899999999999999,
    Alueella_olevia_tyopaikkoja: 2854,
    Alkutuotannon_tyopaikkoja: 1.2,
    Jalostuksen_tyopaikkoja: 40.899999999999999,
    Palvelujen_tyopaikkoja: 56.299999999999997,
  },
  {
    Kunta: "Mynämäki",
    Vakiluku: 7515,
    Vakiluvun_muutos: -0.29999999999999999,
    Alle15v: 14.800000000000001,
    Ika15_64v: 56.799999999999997,
    Yli64v: 28.399999999999999,
    Ruotsinkielisia: 0.90000000000000002,
    Ulkomaan_kansalaisia: 3.0,
    Taajamaa: 66.200000000000003,
    Syntyneiden_enemmyys: -27,
    Muuttovoitto: -34,
    Perheita: 2194,
    Asuntokuntia: 3580,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 15.1,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.199999999999999,
    Taloudellinen_huoltosuhde: 131.09999999999999,
    Tyopaikkaomavaraisuus: 58.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 3262,
    Ika20_64v_tyollisyysaste: 80.0,
    Asuinkunnassaan_tyossakayvia: 38.5,
    Tyottomia: 6.7999999999999998,
    Elakelaisia: 31.399999999999999,
    Alueella_olevia_tyopaikkoja: 1918,
    Alkutuotannon_tyopaikkoja: 15.199999999999999,
    Jalostuksen_tyopaikkoja: 25.600000000000001,
    Palvelujen_tyopaikkoja: 57.399999999999999,
  },
  {
    Kunta: "Myrskylä",
    Vakiluku: 1715,
    Vakiluvun_muutos: -2.7999999999999998,
    Alle15v: 14.0,
    Ika15_64v: 54.899999999999999,
    Yli64v: 31.100000000000001,
    Ruotsinkielisia: 9.3000000000000007,
    Ulkomaan_kansalaisia: 3.6000000000000001,
    Taajamaa: 47.799999999999997,
    Syntyneiden_enemmyys: -19,
    Muuttovoitto: -32,
    Perheita: 486,
    Asuntokuntia: 830,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.100000000000001,
    Taloudellinen_huoltosuhde: 150.19999999999999,
    Tyopaikkaomavaraisuus: 66.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 705,
    Ika20_64v_tyollisyysaste: 76.0,
    Asuinkunnassaan_tyossakayvia: 42.700000000000003,
    Tyottomia: 11.4,
    Elakelaisia: 32.799999999999997,
    Alueella_olevia_tyopaikkoja: 470,
    Alkutuotannon_tyopaikkoja: 17.899999999999999,
    Jalostuksen_tyopaikkoja: 25.699999999999999,
    Palvelujen_tyopaikkoja: 53.600000000000001,
  },
  {
    Kunta: "Mäntsälä",
    Vakiluku: 20957,
    Vakiluvun_muutos: 0.20000000000000001,
    Alle15v: 17.899999999999999,
    Ika15_64v: 61.299999999999997,
    Yli64v: 20.800000000000001,
    Ruotsinkielisia: 0.80000000000000004,
    Ulkomaan_kansalaisia: 4.0,
    Taajamaa: 74.099999999999994,
    Syntyneiden_enemmyys: -45,
    Muuttovoitto: -68,
    Perheita: 5839,
    Asuntokuntia: 9394,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 77.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.5,
    Taloudellinen_huoltosuhde: 115.7,
    Tyopaikkaomavaraisuus: 65.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 9695,
    Ika20_64v_tyollisyysaste: 81.700000000000003,
    Asuinkunnassaan_tyossakayvia: 36.799999999999997,
    Tyottomia: 6.7000000000000002,
    Elakelaisia: 22.800000000000001,
    Alueella_olevia_tyopaikkoja: 6372,
    Alkutuotannon_tyopaikkoja: 3.6000000000000001,
    Jalostuksen_tyopaikkoja: 20.899999999999999,
    Palvelujen_tyopaikkoja: 73.900000000000006,
  },
  {
    Kunta: "Mänttä-Vilppula",
    Vakiluku: 9271,
    Vakiluvun_muutos: -1.0,
    Alle15v: 10.9,
    Ika15_64v: 51.0,
    Yli64v: 38.100000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.2000000000000002,
    Taajamaa: 83.0,
    Syntyneiden_enemmyys: -131,
    Muuttovoitto: -54,
    Perheita: 2526,
    Asuntokuntia: 5084,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 67.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.100000000000001,
    Taloudellinen_huoltosuhde: 179.69999999999999,
    Tyopaikkaomavaraisuus: 107.7,
    Alueella_asuva_tyollinen_tyovoima: 3347,
    Ika20_64v_tyollisyysaste: 72.5,
    Asuinkunnassaan_tyossakayvia: 76.200000000000003,
    Tyottomia: 9.0999999999999996,
    Elakelaisia: 41.5,
    Alueella_olevia_tyopaikkoja: 3604,
    Alkutuotannon_tyopaikkoja: 3.1000000000000001,
    Jalostuksen_tyopaikkoja: 37.299999999999997,
    Palvelujen_tyopaikkoja: 58.299999999999997,
  },
  {
    Kunta: "Mäntyharju",
    Vakiluku: 5522,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 10.6,
    Ika15_64v: 50.200000000000003,
    Yli64v: 39.200000000000003,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.7000000000000002,
    Taajamaa: 63.100000000000001,
    Syntyneiden_enemmyys: -86,
    Muuttovoitto: -29,
    Perheita: 1445,
    Asuntokuntia: 2994,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 81.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.800000000000001,
    Taloudellinen_huoltosuhde: 185.19999999999999,
    Tyopaikkaomavaraisuus: 98.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 1951,
    Ika20_64v_tyollisyysaste: 72.700000000000003,
    Asuinkunnassaan_tyossakayvia: 70.599999999999994,
    Tyottomia: 9.5999999999999996,
    Elakelaisia: 43.200000000000003,
    Alueella_olevia_tyopaikkoja: 1917,
    Alkutuotannon_tyopaikkoja: 9.6999999999999993,
    Jalostuksen_tyopaikkoja: 36.299999999999997,
    Palvelujen_tyopaikkoja: 52.600000000000001,
  },
  {
    Kunta: "Naantali",
    Vakiluku: 19999,
    Vakiluvun_muutos: 0.80000000000000004,
    Alle15v: 14.4,
    Ika15_64v: 57.700000000000003,
    Yli64v: 27.899999999999999,
    Ruotsinkielisia: 1.3999999999999999,
    Ulkomaan_kansalaisia: 2.7000000000000002,
    Taajamaa: 86.599999999999994,
    Syntyneiden_enemmyys: -91,
    Muuttovoitto: 127,
    Perheita: 5819,
    Asuntokuntia: 9836,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 60.899999999999999,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 77.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 37.5,
    Taloudellinen_huoltosuhde: 129.0,
    Tyopaikkaomavaraisuus: 62.5,
    Alueella_asuva_tyollinen_tyovoima: 8668,
    Ika20_64v_tyollisyysaste: 80.0,
    Asuinkunnassaan_tyossakayvia: 32.799999999999997,
    Tyottomia: 6.7000000000000002,
    Elakelaisia: 30.399999999999999,
    Alueella_olevia_tyopaikkoja: 5417,
    Alkutuotannon_tyopaikkoja: 2.0,
    Jalostuksen_tyopaikkoja: 30.100000000000001,
    Palvelujen_tyopaikkoja: 65.599999999999994,
  },
  {
    Kunta: "Nakkila",
    Vakiluku: 4966,
    Vakiluvun_muutos: -2.1000000000000001,
    Alle15v: 13.699999999999999,
    Ika15_64v: 55.899999999999999,
    Yli64v: 30.399999999999999,
    Ruotsinkielisia: 0.59999999999999998,
    Ulkomaan_kansalaisia: 1.2,
    Taajamaa: 75.200000000000003,
    Syntyneiden_enemmyys: -57,
    Muuttovoitto: -52,
    Perheita: 1444,
    Asuntokuntia: 2500,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 87.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 15.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.899999999999999,
    Taloudellinen_huoltosuhde: 149.0,
    Tyopaikkaomavaraisuus: 69.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 2037,
    Ika20_64v_tyollisyysaste: 76.900000000000006,
    Asuinkunnassaan_tyossakayvia: 33.899999999999999,
    Tyottomia: 7.7000000000000002,
    Elakelaisia: 33.100000000000001,
    Alueella_olevia_tyopaikkoja: 1408,
    Alkutuotannon_tyopaikkoja: 5.7999999999999998,
    Jalostuksen_tyopaikkoja: 40.100000000000001,
    Palvelujen_tyopaikkoja: 52.799999999999997,
  },
  {
    Kunta: "Nivala",
    Vakiluku: 10454,
    Vakiluvun_muutos: 0.29999999999999999,
    Alle15v: 21.300000000000001,
    Ika15_64v: 54.700000000000003,
    Yli64v: 24.0,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.2,
    Taajamaa: 65.5,
    Syntyneiden_enemmyys: -6,
    Muuttovoitto: -9,
    Perheita: 2614,
    Asuntokuntia: 4542,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.5,
    Taloudellinen_huoltosuhde: 156.5,
    Tyopaikkaomavaraisuus: 93.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 4062,
    Ika20_64v_tyollisyysaste: 78.400000000000006,
    Asuinkunnassaan_tyossakayvia: 67.599999999999994,
    Tyottomia: 8.1999999999999993,
    Elakelaisia: 27.399999999999999,
    Alueella_olevia_tyopaikkoja: 3815,
    Alkutuotannon_tyopaikkoja: 11.800000000000001,
    Jalostuksen_tyopaikkoja: 34.600000000000001,
    Palvelujen_tyopaikkoja: 52.5,
  },
  {
    Kunta: "Nokia",
    Vakiluku: 35647,
    Vakiluvun_muutos: 0.90000000000000002,
    Alle15v: 17.0,
    Ika15_64v: 61.700000000000003,
    Yli64v: 21.300000000000001,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 91.799999999999997,
    Syntyneiden_enemmyys: -87,
    Muuttovoitto: 315,
    Perheita: 9719,
    Asuntokuntia: 17223,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 57.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 27.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 76.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 31.399999999999999,
    Taloudellinen_huoltosuhde: 119.8,
    Tyopaikkaomavaraisuus: 78.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 16081,
    Ika20_64v_tyollisyysaste: 79.900000000000006,
    Asuinkunnassaan_tyossakayvia: 39.700000000000003,
    Tyottomia: 7.4000000000000004,
    Elakelaisia: 23.899999999999999,
    Alueella_olevia_tyopaikkoja: 12564,
    Alkutuotannon_tyopaikkoja: 0.90000000000000002,
    Jalostuksen_tyopaikkoja: 34.200000000000003,
    Palvelujen_tyopaikkoja: 63.799999999999997,
  },
  {
    Kunta: "Nousiainen",
    Vakiluku: 4695,
    Vakiluvun_muutos: 1.1000000000000001,
    Alle15v: 18.300000000000001,
    Ika15_64v: 60.399999999999999,
    Yli64v: 21.300000000000001,
    Ruotsinkielisia: 0.80000000000000004,
    Ulkomaan_kansalaisia: 2.8999999999999999,
    Taajamaa: 68.900000000000006,
    Syntyneiden_enemmyys: -19,
    Muuttovoitto: 13,
    Perheita: 1391,
    Asuntokuntia: 1988,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 90.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 10.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 76.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 27.5,
    Taloudellinen_huoltosuhde: 116.8,
    Tyopaikkaomavaraisuus: 43.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 2142,
    Ika20_64v_tyollisyysaste: 83.0,
    Asuinkunnassaan_tyossakayvia: 22.699999999999999,
    Tyottomia: 4.7000000000000002,
    Elakelaisia: 24.100000000000001,
    Alueella_olevia_tyopaikkoja: 927,
    Alkutuotannon_tyopaikkoja: 10.199999999999999,
    Jalostuksen_tyopaikkoja: 17.699999999999999,
    Palvelujen_tyopaikkoja: 69.400000000000006,
  },
  {
    Kunta: "Nurmes",
    Vakiluku: 9130,
    Vakiluvun_muutos: -1.2,
    Alle15v: 11.300000000000001,
    Ika15_64v: 50.799999999999997,
    Yli64v: 37.899999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.7000000000000002,
    Taajamaa: 60.700000000000003,
    Syntyneiden_enemmyys: -103,
    Muuttovoitto: -113,
    Perheita: 2400,
    Asuntokuntia: 4969,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 76.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.699999999999999,
    Taloudellinen_huoltosuhde: 189.59999999999999,
    Tyopaikkaomavaraisuus: 100.3,
    Alueella_asuva_tyollinen_tyovoima: 3192,
    Ika20_64v_tyollisyysaste: 70.0,
    Asuinkunnassaan_tyossakayvia: 85.299999999999997,
    Tyottomia: 13.1,
    Elakelaisia: 41.5,
    Alueella_olevia_tyopaikkoja: 3200,
    Alkutuotannon_tyopaikkoja: 14.800000000000001,
    Jalostuksen_tyopaikkoja: 22.600000000000001,
    Palvelujen_tyopaikkoja: 61.700000000000003,
  },
  {
    Kunta: "Nurmijärvi",
    Vakiluku: 44785,
    Vakiluvun_muutos: 0.69999999999999996,
    Alle15v: 18.800000000000001,
    Ika15_64v: 63.200000000000003,
    Yli64v: 18.0,
    Ruotsinkielisia: 1.3,
    Ulkomaan_kansalaisia: 5.7000000000000002,
    Taajamaa: 89.299999999999997,
    Syntyneiden_enemmyys: 112,
    Muuttovoitto: 58,
    Perheita: 12411,
    Asuntokuntia: 19736,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 70.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 32.100000000000001,
    Taloudellinen_huoltosuhde: 107.40000000000001,
    Tyopaikkaomavaraisuus: 57.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 21431,
    Ika20_64v_tyollisyysaste: 82.200000000000003,
    Asuinkunnassaan_tyossakayvia: 33.100000000000001,
    Tyottomia: 6.9000000000000004,
    Elakelaisia: 19.399999999999999,
    Alueella_olevia_tyopaikkoja: 12367,
    Alkutuotannon_tyopaikkoja: 1.3999999999999999,
    Jalostuksen_tyopaikkoja: 28.199999999999999,
    Palvelujen_tyopaikkoja: 68.299999999999997,
  },
  {
    Kunta: "Närpiö",
    Vakiluku: 9621,
    Vakiluvun_muutos: 0.40000000000000002,
    Alle15v: 16.0,
    Ika15_64v: 56.100000000000001,
    Yli64v: 27.899999999999999,
    Ruotsinkielisia: 74.0,
    Ulkomaan_kansalaisia: 16.800000000000001,
    Taajamaa: 59.600000000000001,
    Syntyneiden_enemmyys: -50,
    Muuttovoitto: -50,
    Perheita: 2758,
    Asuntokuntia: 4251,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 82.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 64.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.100000000000001,
    Taloudellinen_huoltosuhde: 127.7,
    Tyopaikkaomavaraisuus: 107.2,
    Alueella_asuva_tyollinen_tyovoima: 4209,
    Ika20_64v_tyollisyysaste: 81.900000000000006,
    Asuinkunnassaan_tyossakayvia: 84.900000000000006,
    Tyottomia: 6.2999999999999998,
    Elakelaisia: 29.899999999999999,
    Alueella_olevia_tyopaikkoja: 4513,
    Alkutuotannon_tyopaikkoja: 23.0,
    Jalostuksen_tyopaikkoja: 24.199999999999999,
    Palvelujen_tyopaikkoja: 51.899999999999999,
  },
  {
    Kunta: "Orimattila",
    Vakiluku: 15669,
    Vakiluvun_muutos: -0.40000000000000002,
    Alle15v: 15.5,
    Ika15_64v: 57.700000000000003,
    Yli64v: 26.800000000000001,
    Ruotsinkielisia: 0.59999999999999998,
    Ulkomaan_kansalaisia: 2.6000000000000001,
    Taajamaa: 67.900000000000006,
    Syntyneiden_enemmyys: -79,
    Muuttovoitto: -42,
    Perheita: 4304,
    Asuntokuntia: 7703,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 78.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.100000000000001,
    Taloudellinen_huoltosuhde: 142.0,
    Tyopaikkaomavaraisuus: 71.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 6501,
    Ika20_64v_tyollisyysaste: 76.700000000000003,
    Asuinkunnassaan_tyossakayvia: 45.399999999999999,
    Tyottomia: 10.199999999999999,
    Elakelaisia: 29.600000000000001,
    Alueella_olevia_tyopaikkoja: 4663,
    Alkutuotannon_tyopaikkoja: 8.3000000000000007,
    Jalostuksen_tyopaikkoja: 32.399999999999999,
    Palvelujen_tyopaikkoja: 57.799999999999997,
  },
  {
    Kunta: "Oripää",
    Vakiluku: 1315,
    Vakiluvun_muutos: -0.20000000000000001,
    Alle15v: 15.9,
    Ika15_64v: 56.200000000000003,
    Yli64v: 27.899999999999999,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 8.0,
    Taajamaa: 52.700000000000003,
    Syntyneiden_enemmyys: -11,
    Muuttovoitto: -16,
    Perheita: 352,
    Asuntokuntia: 613,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 63.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.5,
    Taloudellinen_huoltosuhde: 146.59999999999999,
    Tyopaikkaomavaraisuus: 85.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 534,
    Ika20_64v_tyollisyysaste: 77.200000000000003,
    Asuinkunnassaan_tyossakayvia: 46.299999999999997,
    Tyottomia: 9.0,
    Elakelaisia: 29.899999999999999,
    Alueella_olevia_tyopaikkoja: 455,
    Alkutuotannon_tyopaikkoja: 26.800000000000001,
    Jalostuksen_tyopaikkoja: 22.199999999999999,
    Palvelujen_tyopaikkoja: 49.5,
  },
  {
    Kunta: "Orivesi",
    Vakiluku: 8839,
    Vakiluvun_muutos: -1.1000000000000001,
    Alle15v: 13.699999999999999,
    Ika15_64v: 54.299999999999997,
    Yli64v: 32.0,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.6000000000000001,
    Taajamaa: 72.200000000000003,
    Syntyneiden_enemmyys: -105,
    Muuttovoitto: -21,
    Perheita: 2446,
    Asuntokuntia: 4436,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 76.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.5,
    Taloudellinen_huoltosuhde: 156.69999999999999,
    Tyopaikkaomavaraisuus: 69.0,
    Alueella_asuva_tyollinen_tyovoima: 3481,
    Ika20_64v_tyollisyysaste: 76.5,
    Asuinkunnassaan_tyossakayvia: 47.700000000000003,
    Tyottomia: 9.3000000000000007,
    Elakelaisia: 35.100000000000001,
    Alueella_olevia_tyopaikkoja: 2403,
    Alkutuotannon_tyopaikkoja: 9.9000000000000004,
    Jalostuksen_tyopaikkoja: 17.600000000000001,
    Palvelujen_tyopaikkoja: 70.799999999999997,
  },
  {
    Kunta: "Oulainen",
    Vakiluku: 6978,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 16.100000000000001,
    Ika15_64v: 54.200000000000003,
    Yli64v: 29.699999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.6000000000000001,
    Taajamaa: 72.299999999999997,
    Syntyneiden_enemmyys: -32,
    Muuttovoitto: -61,
    Perheita: 1798,
    Asuntokuntia: 3416,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 84.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.300000000000001,
    Taloudellinen_huoltosuhde: 166.69999999999999,
    Tyopaikkaomavaraisuus: 103.59999999999999,
    Alueella_asuva_tyollinen_tyovoima: 2634,
    Ika20_64v_tyollisyysaste: 75.099999999999994,
    Asuinkunnassaan_tyossakayvia: 69.099999999999994,
    Tyottomia: 8.8000000000000007,
    Elakelaisia: 32.5,
    Alueella_olevia_tyopaikkoja: 2728,
    Alkutuotannon_tyopaikkoja: 5.0,
    Jalostuksen_tyopaikkoja: 25.699999999999999,
    Palvelujen_tyopaikkoja: 68.700000000000003,
  },
  {
    Kunta: "Oulu",
    Vakiluku: 214633,
    Vakiluvun_muutos: 1.3,
    Alle15v: 16.100000000000001,
    Ika15_64v: 66.599999999999994,
    Yli64v: 17.300000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 4.4000000000000004,
    Taajamaa: 96.900000000000006,
    Syntyneiden_enemmyys: 385,
    Muuttovoitto: 545,
    Perheita: 53847,
    Asuntokuntia: 109987,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 44.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 43.299999999999997,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 80.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 38.200000000000003,
    Taloudellinen_huoltosuhde: 127.09999999999999,
    Tyopaikkaomavaraisuus: 104.5,
    Alueella_asuva_tyollinen_tyovoima: 93276,
    Ika20_64v_tyollisyysaste: 71.099999999999994,
    Asuinkunnassaan_tyossakayvia: 86.400000000000006,
    Tyottomia: 11.9,
    Elakelaisia: 20.100000000000001,
    Alueella_olevia_tyopaikkoja: 97459,
    Alkutuotannon_tyopaikkoja: 0.59999999999999998,
    Jalostuksen_tyopaikkoja: 19.600000000000001,
    Palvelujen_tyopaikkoja: 78.700000000000003,
  },
  {
    Kunta: "Outokumpu",
    Vakiluku: 6409,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 12.5,
    Ika15_64v: 52.799999999999997,
    Yli64v: 34.700000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 5.2000000000000002,
    Taajamaa: 70.900000000000006,
    Syntyneiden_enemmyys: -90,
    Muuttovoitto: -69,
    Perheita: 1684,
    Asuntokuntia: 3461,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 75.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 30.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.0,
    Taloudellinen_huoltosuhde: 206.90000000000001,
    Tyopaikkaomavaraisuus: 113.3,
    Alueella_asuva_tyollinen_tyovoima: 2104,
    Ika20_64v_tyollisyysaste: 65.700000000000003,
    Asuinkunnassaan_tyossakayvia: 71.099999999999994,
    Tyottomia: 16.899999999999999,
    Elakelaisia: 38.299999999999997,
    Alueella_olevia_tyopaikkoja: 2384,
    Alkutuotannon_tyopaikkoja: 3.1000000000000001,
    Jalostuksen_tyopaikkoja: 41.100000000000001,
    Palvelujen_tyopaikkoja: 54.700000000000003,
  },
  {
    Kunta: "Padasjoki",
    Vakiluku: 2726,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 9.0999999999999996,
    Ika15_64v: 47.899999999999999,
    Yli64v: 42.899999999999999,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 49.799999999999997,
    Syntyneiden_enemmyys: -41,
    Muuttovoitto: -5,
    Perheita: 754,
    Asuntokuntia: 1463,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 85.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 63.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.100000000000001,
    Taloudellinen_huoltosuhde: 200.5,
    Tyopaikkaomavaraisuus: 77.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 915,
    Ika20_64v_tyollisyysaste: 72.799999999999997,
    Asuinkunnassaan_tyossakayvia: 57.5,
    Tyottomia: 11.6,
    Elakelaisia: 46.600000000000001,
    Alueella_olevia_tyopaikkoja: 712,
    Alkutuotannon_tyopaikkoja: 12.6,
    Jalostuksen_tyopaikkoja: 25.0,
    Palvelujen_tyopaikkoja: 59.600000000000001,
  },
  {
    Kunta: "Paimio",
    Vakiluku: 11236,
    Vakiluvun_muutos: 0.90000000000000002,
    Alle15v: 18.600000000000001,
    Ika15_64v: 58.399999999999999,
    Yli64v: 23.0,
    Ruotsinkielisia: 0.80000000000000004,
    Ulkomaan_kansalaisia: 3.7999999999999998,
    Taajamaa: 80.299999999999997,
    Syntyneiden_enemmyys: -6,
    Muuttovoitto: -15,
    Perheita: 3129,
    Asuntokuntia: 5163,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 71.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 76.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 33.299999999999997,
    Taloudellinen_huoltosuhde: 123.40000000000001,
    Tyopaikkaomavaraisuus: 63.899999999999999,
    Alueella_asuva_tyollinen_tyovoima: 4986,
    Ika20_64v_tyollisyysaste: 82.200000000000003,
    Asuinkunnassaan_tyossakayvia: 34.600000000000001,
    Tyottomia: 4.9000000000000004,
    Elakelaisia: 25.399999999999999,
    Alueella_olevia_tyopaikkoja: 3186,
    Alkutuotannon_tyopaikkoja: 4.2999999999999998,
    Jalostuksen_tyopaikkoja: 24.0,
    Palvelujen_tyopaikkoja: 70.400000000000006,
  },
  {
    Kunta: "Paltamo",
    Vakiluku: 3037,
    Vakiluvun_muutos: -2.0,
    Alle15v: 11.6,
    Ika15_64v: 51.700000000000003,
    Yli64v: 36.700000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.3999999999999999,
    Taajamaa: 58.399999999999999,
    Syntyneiden_enemmyys: -57,
    Muuttovoitto: -29,
    Perheita: 813,
    Asuntokuntia: 1607,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.5,
    Taloudellinen_huoltosuhde: 187.59999999999999,
    Tyopaikkaomavaraisuus: 78.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1078,
    Ika20_64v_tyollisyysaste: 69.5,
    Asuinkunnassaan_tyossakayvia: 48.799999999999997,
    Tyottomia: 12.0,
    Elakelaisia: 41.0,
    Alueella_olevia_tyopaikkoja: 848,
    Alkutuotannon_tyopaikkoja: 7.7000000000000002,
    Jalostuksen_tyopaikkoja: 12.4,
    Palvelujen_tyopaikkoja: 78.900000000000006,
  },
  {
    Kunta: "Parainen",
    Vakiluku: 14999,
    Vakiluvun_muutos: 0.10000000000000001,
    Alle15v: 14.5,
    Ika15_64v: 56.0,
    Yli64v: 29.399999999999999,
    Ruotsinkielisia: 54.100000000000001,
    Ulkomaan_kansalaisia: 3.7000000000000002,
    Taajamaa: 67.200000000000003,
    Syntyneiden_enemmyys: -55,
    Muuttovoitto: -31,
    Perheita: 4328,
    Asuntokuntia: 7194,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 77.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 35.600000000000001,
    Taloudellinen_huoltosuhde: 133.80000000000001,
    Tyopaikkaomavaraisuus: 79.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 6412,
    Ika20_64v_tyollisyysaste: 80.900000000000006,
    Asuinkunnassaan_tyossakayvia: 57.399999999999999,
    Tyottomia: 6.0,
    Elakelaisia: 31.600000000000001,
    Alueella_olevia_tyopaikkoja: 5088,
    Alkutuotannon_tyopaikkoja: 3.8999999999999999,
    Jalostuksen_tyopaikkoja: 29.5,
    Palvelujen_tyopaikkoja: 64.700000000000003,
  },
  {
    Kunta: "Parikkala",
    Vakiluku: 4366,
    Vakiluvun_muutos: -1.6000000000000001,
    Alle15v: 9.9000000000000004,
    Ika15_64v: 47.200000000000003,
    Yli64v: 42.899999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.0,
    Taajamaa: 45.299999999999997,
    Syntyneiden_enemmyys: -90,
    Muuttovoitto: -5,
    Perheita: 1212,
    Asuntokuntia: 2433,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 84.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.800000000000001,
    Taloudellinen_huoltosuhde: 202.69999999999999,
    Tyopaikkaomavaraisuus: 78.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 1466,
    Ika20_64v_tyollisyysaste: 71.599999999999994,
    Asuinkunnassaan_tyossakayvia: 61.100000000000001,
    Tyottomia: 11.5,
    Elakelaisia: 47.899999999999999,
    Alueella_olevia_tyopaikkoja: 1157,
    Alkutuotannon_tyopaikkoja: 16.699999999999999,
    Jalostuksen_tyopaikkoja: 18.0,
    Palvelujen_tyopaikkoja: 63.200000000000003,
  },
  {
    Kunta: "Parkano",
    Vakiluku: 6123,
    Vakiluvun_muutos: -1.8999999999999999,
    Alle15v: 12.800000000000001,
    Ika15_64v: 51.899999999999999,
    Yli64v: 35.299999999999997,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.5,
    Taajamaa: 69.0,
    Syntyneiden_enemmyys: -71,
    Muuttovoitto: -80,
    Perheita: 1680,
    Asuntokuntia: 3163,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 79.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.5,
    Taloudellinen_huoltosuhde: 178.59999999999999,
    Tyopaikkaomavaraisuus: 106.40000000000001,
    Alueella_asuva_tyollinen_tyovoima: 2240,
    Ika20_64v_tyollisyysaste: 72.5,
    Asuinkunnassaan_tyossakayvia: 74.599999999999994,
    Tyottomia: 9.6999999999999993,
    Elakelaisia: 39.100000000000001,
    Alueella_olevia_tyopaikkoja: 2383,
    Alkutuotannon_tyopaikkoja: 6.5,
    Jalostuksen_tyopaikkoja: 32.899999999999999,
    Palvelujen_tyopaikkoja: 59.799999999999997,
  },
  {
    Kunta: "Pedersören kunta",
    Vakiluku: 11225,
    Vakiluvun_muutos: 0.20000000000000001,
    Alle15v: 22.800000000000001,
    Ika15_64v: 58.200000000000003,
    Yli64v: 19.100000000000001,
    Ruotsinkielisia: 88.400000000000006,
    Ulkomaan_kansalaisia: 3.2000000000000002,
    Taajamaa: 74.099999999999994,
    Syntyneiden_enemmyys: 71,
    Muuttovoitto: -86,
    Perheita: 3142,
    Asuntokuntia: 4088,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 11.6,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.699999999999999,
    Taloudellinen_huoltosuhde: 115.7,
    Tyopaikkaomavaraisuus: 86.5,
    Alueella_asuva_tyollinen_tyovoima: 5194,
    Ika20_64v_tyollisyysaste: 86.700000000000003,
    Asuinkunnassaan_tyossakayvia: 47.100000000000001,
    Tyottomia: 2.7000000000000002,
    Elakelaisia: 20.5,
    Alueella_olevia_tyopaikkoja: 4493,
    Alkutuotannon_tyopaikkoja: 8.4000000000000004,
    Jalostuksen_tyopaikkoja: 51.799999999999997,
    Palvelujen_tyopaikkoja: 38.899999999999999,
  },
  {
    Kunta: "Pelkosenniemi",
    Vakiluku: 912,
    Vakiluvun_muutos: -3.7000000000000002,
    Alle15v: 8.3000000000000007,
    Ika15_64v: 52.700000000000003,
    Yli64v: 38.899999999999999,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 1.5,
    Taajamaa: 34.700000000000003,
    Syntyneiden_enemmyys: 0.0,
    Muuttovoitto: -24,
    Perheita: 248,
    Asuntokuntia: 469,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.600000000000001,
    Taloudellinen_huoltosuhde: 160.19999999999999,
    Tyopaikkaomavaraisuus: 115.90000000000001,
    Alueella_asuva_tyollinen_tyovoima: 364,
    Ika20_64v_tyollisyysaste: 72.5,
    Asuinkunnassaan_tyossakayvia: 67.299999999999997,
    Tyottomia: 8.3000000000000007,
    Elakelaisia: 43.200000000000003,
    Alueella_olevia_tyopaikkoja: 422,
    Alkutuotannon_tyopaikkoja: 2.6000000000000001,
    Jalostuksen_tyopaikkoja: 8.5,
    Palvelujen_tyopaikkoja: 87.700000000000003,
  },
  {
    Kunta: "Pello",
    Vakiluku: 3253,
    Vakiluvun_muutos: -0.29999999999999999,
    Alle15v: 9.6999999999999993,
    Ika15_64v: 46.700000000000003,
    Yli64v: 43.700000000000003,
    Ruotsinkielisia: 0.69999999999999996,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 53.700000000000003,
    Syntyneiden_enemmyys: -45,
    Muuttovoitto: 4,
    Perheita: 943,
    Asuntokuntia: 1678,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.699999999999999,
    Taloudellinen_huoltosuhde: 200.90000000000001,
    Tyopaikkaomavaraisuus: 99.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 1084,
    Ika20_64v_tyollisyysaste: 70.400000000000006,
    Asuinkunnassaan_tyossakayvia: 79.299999999999997,
    Tyottomia: 11.0,
    Elakelaisia: 46.899999999999999,
    Alueella_olevia_tyopaikkoja: 1078,
    Alkutuotannon_tyopaikkoja: 10.4,
    Jalostuksen_tyopaikkoja: 17.899999999999999,
    Palvelujen_tyopaikkoja: 69.099999999999994,
  },
  {
    Kunta: "Perho",
    Vakiluku: 2578,
    Vakiluvun_muutos: -2.7999999999999998,
    Alle15v: 24.0,
    Ika15_64v: 49.799999999999997,
    Yli64v: 26.199999999999999,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 0.80000000000000004,
    Taajamaa: 41.299999999999997,
    Syntyneiden_enemmyys: -14,
    Muuttovoitto: -66,
    Perheita: 640,
    Asuntokuntia: 1002,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 62.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 14.300000000000001,
    Taloudellinen_huoltosuhde: 196.80000000000001,
    Tyopaikkaomavaraisuus: 96.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 894,
    Ika20_64v_tyollisyysaste: 75.099999999999994,
    Asuinkunnassaan_tyossakayvia: 75.099999999999994,
    Tyottomia: 9.6999999999999993,
    Elakelaisia: 28.699999999999999,
    Alueella_olevia_tyopaikkoja: 864,
    Alkutuotannon_tyopaikkoja: 15.9,
    Jalostuksen_tyopaikkoja: 29.600000000000001,
    Palvelujen_tyopaikkoja: 53.399999999999999,
  },
  {
    Kunta: "Pertunmaa",
    Vakiluku: 1577,
    Vakiluvun_muutos: -1.3999999999999999,
    Alle15v: 9.0,
    Ika15_64v: 49.899999999999999,
    Yli64v: 41.100000000000001,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 2.7999999999999998,
    Taajamaa: 42.200000000000003,
    Syntyneiden_enemmyys: -12,
    Muuttovoitto: -27,
    Perheita: 421,
    Asuntokuntia: 895,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 64.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.899999999999999,
    Taloudellinen_huoltosuhde: 192.5,
    Tyopaikkaomavaraisuus: 95.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 547,
    Ika20_64v_tyollisyysaste: 71.0,
    Asuinkunnassaan_tyossakayvia: 63.299999999999997,
    Tyottomia: 10.9,
    Elakelaisia: 45.299999999999997,
    Alueella_olevia_tyopaikkoja: 522,
    Alkutuotannon_tyopaikkoja: 19.0,
    Jalostuksen_tyopaikkoja: 20.300000000000001,
    Palvelujen_tyopaikkoja: 58.0,
  },
  {
    Kunta: "Petäjävesi",
    Vakiluku: 3596,
    Vakiluvun_muutos: -1.5,
    Alle15v: 16.699999999999999,
    Ika15_64v: 57.0,
    Yli64v: 26.199999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.2,
    Taajamaa: 57.0,
    Syntyneiden_enemmyys: -12,
    Muuttovoitto: -45,
    Perheita: 975,
    Asuntokuntia: 1695,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 27.899999999999999,
    Taloudellinen_huoltosuhde: 147.19999999999999,
    Tyopaikkaomavaraisuus: 53.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 1477,
    Ika20_64v_tyollisyysaste: 76.700000000000003,
    Asuinkunnassaan_tyossakayvia: 35.700000000000003,
    Tyottomia: 9.6999999999999993,
    Elakelaisia: 28.600000000000001,
    Alueella_olevia_tyopaikkoja: 794,
    Alkutuotannon_tyopaikkoja: 12.199999999999999,
    Jalostuksen_tyopaikkoja: 16.899999999999999,
    Palvelujen_tyopaikkoja: 68.5,
  },
  {
    Kunta: "Pieksämäki",
    Vakiluku: 17050,
    Vakiluvun_muutos: -0.20000000000000001,
    Alle15v: 11.1,
    Ika15_64v: 53.5,
    Yli64v: 35.399999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 3.7999999999999998,
    Taajamaa: 75.0,
    Syntyneiden_enemmyys: -178,
    Muuttovoitto: -94,
    Perheita: 4539,
    Asuntokuntia: 9409,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 63.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 30.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.600000000000001,
    Taloudellinen_huoltosuhde: 170.80000000000001,
    Tyopaikkaomavaraisuus: 102.40000000000001,
    Alueella_asuva_tyollinen_tyovoima: 6305,
    Ika20_64v_tyollisyysaste: 71.5,
    Asuinkunnassaan_tyossakayvia: 83.900000000000006,
    Tyottomia: 9.0,
    Elakelaisia: 40.0,
    Alueella_olevia_tyopaikkoja: 6454,
    Alkutuotannon_tyopaikkoja: 4.9000000000000004,
    Jalostuksen_tyopaikkoja: 19.899999999999999,
    Palvelujen_tyopaikkoja: 74.0,
  },
  {
    Kunta: "Pielavesi",
    Vakiluku: 4073,
    Vakiluvun_muutos: -1.6000000000000001,
    Alle15v: 11.699999999999999,
    Ika15_64v: 48.200000000000003,
    Yli64v: 40.100000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.1000000000000001,
    Taajamaa: 42.799999999999997,
    Syntyneiden_enemmyys: -67,
    Muuttovoitto: -4,
    Perheita: 1083,
    Asuntokuntia: 2118,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 82.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.300000000000001,
    Taloudellinen_huoltosuhde: 206.69999999999999,
    Tyopaikkaomavaraisuus: 84.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 1350,
    Ika20_64v_tyollisyysaste: 72.0,
    Asuinkunnassaan_tyossakayvia: 64.700000000000003,
    Tyottomia: 9.1999999999999993,
    Elakelaisia: 44.0,
    Alueella_olevia_tyopaikkoja: 1146,
    Alkutuotannon_tyopaikkoja: 22.800000000000001,
    Jalostuksen_tyopaikkoja: 10.300000000000001,
    Palvelujen_tyopaikkoja: 64.799999999999997,
  },
  {
    Kunta: "Pietarsaari",
    Vakiluku: 19475,
    Vakiluvun_muutos: 1.3999999999999999,
    Alle15v: 14.800000000000001,
    Ika15_64v: 59.200000000000003,
    Yli64v: 26.0,
    Ruotsinkielisia: 54.100000000000001,
    Ulkomaan_kansalaisia: 11.9,
    Taajamaa: 98.700000000000003,
    Syntyneiden_enemmyys: -86,
    Muuttovoitto: -130,
    Perheita: 5252,
    Asuntokuntia: 9331,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 57.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 28.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 29.899999999999999,
    Taloudellinen_huoltosuhde: 135.40000000000001,
    Tyopaikkaomavaraisuus: 136.80000000000001,
    Alueella_asuva_tyollinen_tyovoima: 8158,
    Ika20_64v_tyollisyysaste: 76.900000000000006,
    Asuinkunnassaan_tyossakayvia: 73.200000000000003,
    Tyottomia: 6.9000000000000004,
    Elakelaisia: 28.800000000000001,
    Alueella_olevia_tyopaikkoja: 11158,
    Alkutuotannon_tyopaikkoja: 1.0,
    Jalostuksen_tyopaikkoja: 38.700000000000003,
    Palvelujen_tyopaikkoja: 59.700000000000003,
  },
  {
    Kunta: "Pihtipudas",
    Vakiluku: 3739,
    Vakiluvun_muutos: -1.2,
    Alle15v: 13.300000000000001,
    Ika15_64v: 51.799999999999997,
    Yli64v: 34.899999999999999,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 1.0,
    Taajamaa: 47.899999999999999,
    Syntyneiden_enemmyys: -42,
    Muuttovoitto: -22,
    Perheita: 972,
    Asuntokuntia: 1941,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 93.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 16.800000000000001,
    Taloudellinen_huoltosuhde: 175.5,
    Tyopaikkaomavaraisuus: 92.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 1374,
    Ika20_64v_tyollisyysaste: 73.0,
    Asuinkunnassaan_tyossakayvia: 73.5,
    Tyottomia: 11.6,
    Elakelaisia: 38.100000000000001,
    Alueella_olevia_tyopaikkoja: 1268,
    Alkutuotannon_tyopaikkoja: 17.699999999999999,
    Jalostuksen_tyopaikkoja: 17.399999999999999,
    Palvelujen_tyopaikkoja: 63.899999999999999,
  },
  {
    Kunta: "Pirkkala",
    Vakiluku: 20763,
    Vakiluvun_muutos: 1.8,
    Alle15v: 18.800000000000001,
    Ika15_64v: 62.899999999999999,
    Yli64v: 18.300000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 2.5,
    Taajamaa: 97.799999999999997,
    Syntyneiden_enemmyys: 19,
    Muuttovoitto: 271,
    Perheita: 5893,
    Asuntokuntia: 9466,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 54.600000000000001,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 80.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 43.5,
    Taloudellinen_huoltosuhde: 107.3,
    Tyopaikkaomavaraisuus: 101.2,
    Alueella_asuva_tyollinen_tyovoima: 9844,
    Ika20_64v_tyollisyysaste: 83.299999999999997,
    Asuinkunnassaan_tyossakayvia: 27.0,
    Tyottomia: 5.9000000000000004,
    Elakelaisia: 20.100000000000001,
    Alueella_olevia_tyopaikkoja: 9966,
    Alkutuotannon_tyopaikkoja: 0.20000000000000001,
    Jalostuksen_tyopaikkoja: 27.399999999999999,
    Palvelujen_tyopaikkoja: 71.5,
  },
  {
    Kunta: "Polvijärvi",
    Vakiluku: 4064,
    Vakiluvun_muutos: -0.5,
    Alle15v: 13.199999999999999,
    Ika15_64v: 50.100000000000001,
    Yli64v: 36.700000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.1000000000000001,
    Taajamaa: 29.100000000000001,
    Syntyneiden_enemmyys: -38,
    Muuttovoitto: 10,
    Perheita: 1113,
    Asuntokuntia: 2066,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 93.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.800000000000001,
    Taloudellinen_huoltosuhde: 192.59999999999999,
    Tyopaikkaomavaraisuus: 72.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1396,
    Ika20_64v_tyollisyysaste: 70.099999999999994,
    Asuinkunnassaan_tyossakayvia: 51.200000000000003,
    Tyottomia: 13.1,
    Elakelaisia: 40.399999999999999,
    Alueella_olevia_tyopaikkoja: 1008,
    Alkutuotannon_tyopaikkoja: 18.199999999999999,
    Jalostuksen_tyopaikkoja: 20.600000000000001,
    Palvelujen_tyopaikkoja: 58.899999999999999,
  },
  {
    Kunta: "Pomarkku",
    Vakiluku: 1943,
    Vakiluvun_muutos: -1.8999999999999999,
    Alle15v: 13.1,
    Ika15_64v: 52.600000000000001,
    Yli64v: 34.299999999999997,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.3999999999999999,
    Taajamaa: 62.600000000000001,
    Syntyneiden_enemmyys: -27,
    Muuttovoitto: -9,
    Perheita: 550,
    Asuntokuntia: 971,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 93.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 64.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.899999999999999,
    Taloudellinen_huoltosuhde: 175.0,
    Tyopaikkaomavaraisuus: 73.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 720,
    Ika20_64v_tyollisyysaste: 73.5,
    Asuinkunnassaan_tyossakayvia: 41.799999999999997,
    Tyottomia: 8.4000000000000004,
    Elakelaisia: 38.899999999999999,
    Alueella_olevia_tyopaikkoja: 528,
    Alkutuotannon_tyopaikkoja: 9.8000000000000007,
    Jalostuksen_tyopaikkoja: 36.399999999999999,
    Palvelujen_tyopaikkoja: 51.899999999999999,
  },
  {
    Kunta: "Pori",
    Vakiluku: 83106,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 13.300000000000001,
    Ika15_64v: 59.700000000000003,
    Yli64v: 27.0,
    Ruotsinkielisia: 0.59999999999999998,
    Ulkomaan_kansalaisia: 4.0,
    Taajamaa: 94.0,
    Syntyneiden_enemmyys: -619,
    Muuttovoitto: -178,
    Perheita: 21642,
    Asuntokuntia: 44907,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 53.899999999999999,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 35.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 29.300000000000001,
    Taloudellinen_huoltosuhde: 146.09999999999999,
    Tyopaikkaomavaraisuus: 102.7,
    Alueella_asuva_tyollinen_tyovoima: 33806,
    Ika20_64v_tyollisyysaste: 72.200000000000003,
    Asuinkunnassaan_tyossakayvia: 79.400000000000006,
    Tyottomia: 11.9,
    Elakelaisia: 30.300000000000001,
    Alueella_olevia_tyopaikkoja: 34715,
    Alkutuotannon_tyopaikkoja: 1.3999999999999999,
    Jalostuksen_tyopaikkoja: 20.300000000000001,
    Palvelujen_tyopaikkoja: 77.299999999999997,
  },
  {
    Kunta: "Pornainen",
    Vakiluku: 4973,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 17.899999999999999,
    Ika15_64v: 63.200000000000003,
    Yli64v: 18.899999999999999,
    Ruotsinkielisia: 2.2999999999999998,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 66.0,
    Syntyneiden_enemmyys: 8,
    Muuttovoitto: -45,
    Perheita: 1458,
    Asuntokuntia: 2024,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 93.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 8.6999999999999993,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.600000000000001,
    Taloudellinen_huoltosuhde: 102.09999999999999,
    Tyopaikkaomavaraisuus: 41.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 2479,
    Ika20_64v_tyollisyysaste: 85.0,
    Asuinkunnassaan_tyossakayvia: 25.399999999999999,
    Tyottomia: 5.5999999999999996,
    Elakelaisia: 19.699999999999999,
    Alueella_olevia_tyopaikkoja: 1036,
    Alkutuotannon_tyopaikkoja: 8.0999999999999996,
    Jalostuksen_tyopaikkoja: 16.5,
    Palvelujen_tyopaikkoja: 72.099999999999994,
  },
  {
    Kunta: "Porvoo",
    Vakiluku: 51289,
    Vakiluvun_muutos: 0.10000000000000001,
    Alle15v: 16.0,
    Ika15_64v: 61.0,
    Yli64v: 22.899999999999999,
    Ruotsinkielisia: 27.800000000000001,
    Ulkomaan_kansalaisia: 5.7000000000000002,
    Taajamaa: 85.700000000000003,
    Syntyneiden_enemmyys: -152,
    Muuttovoitto: -69,
    Perheita: 14069,
    Asuntokuntia: 24618,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 56.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 29.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 34.700000000000003,
    Taloudellinen_huoltosuhde: 122.09999999999999,
    Tyopaikkaomavaraisuus: 91.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 23070,
    Ika20_64v_tyollisyysaste: 78.799999999999997,
    Asuinkunnassaan_tyossakayvia: 61.100000000000001,
    Tyottomia: 9.0,
    Elakelaisia: 24.800000000000001,
    Alueella_olevia_tyopaikkoja: 21122,
    Alkutuotannon_tyopaikkoja: 1.0,
    Jalostuksen_tyopaikkoja: 29.899999999999999,
    Palvelujen_tyopaikkoja: 67.799999999999997,
  },
  {
    Kunta: "Posio",
    Vakiluku: 2923,
    Vakiluvun_muutos: -2.5,
    Alle15v: 7.5999999999999996,
    Ika15_64v: 49.0,
    Yli64v: 43.399999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 41.100000000000001,
    Syntyneiden_enemmyys: -52,
    Muuttovoitto: -41,
    Perheita: 817,
    Asuntokuntia: 1498,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 18.5,
    Taloudellinen_huoltosuhde: 205.40000000000001,
    Tyopaikkaomavaraisuus: 87.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 982,
    Ika20_64v_tyollisyysaste: 66.700000000000003,
    Asuinkunnassaan_tyossakayvia: 76.200000000000003,
    Tyottomia: 15.6,
    Elakelaisia: 47.899999999999999,
    Alueella_olevia_tyopaikkoja: 863,
    Alkutuotannon_tyopaikkoja: 17.399999999999999,
    Jalostuksen_tyopaikkoja: 12.5,
    Palvelujen_tyopaikkoja: 68.799999999999997,
  },
  {
    Kunta: "Pudasjärvi",
    Vakiluku: 7479,
    Vakiluvun_muutos: -1.6000000000000001,
    Alle15v: 14.5,
    Ika15_64v: 50.5,
    Yli64v: 34.899999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 51.100000000000001,
    Syntyneiden_enemmyys: -84,
    Muuttovoitto: -88,
    Perheita: 1876,
    Asuntokuntia: 3670,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 87.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 25.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.199999999999999,
    Taloudellinen_huoltosuhde: 215.59999999999999,
    Tyopaikkaomavaraisuus: 102.2,
    Alueella_asuva_tyollinen_tyovoima: 2409,
    Ika20_64v_tyollisyysaste: 66.099999999999994,
    Asuinkunnassaan_tyossakayvia: 78.400000000000006,
    Tyottomia: 16.199999999999999,
    Elakelaisia: 39.700000000000003,
    Alueella_olevia_tyopaikkoja: 2463,
    Alkutuotannon_tyopaikkoja: 10.9,
    Jalostuksen_tyopaikkoja: 20.5,
    Palvelujen_tyopaikkoja: 67.400000000000006,
  },
  {
    Kunta: "Pukkila",
    Vakiluku: 1781,
    Vakiluvun_muutos: -1.3999999999999999,
    Alle15v: 14.0,
    Ika15_64v: 61.600000000000001,
    Yli64v: 24.399999999999999,
    Ruotsinkielisia: 0.80000000000000004,
    Ulkomaan_kansalaisia: 3.0,
    Taajamaa: 40.200000000000003,
    Syntyneiden_enemmyys: -14,
    Muuttovoitto: -20,
    Perheita: 493,
    Asuntokuntia: 857,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.5,
    Taloudellinen_huoltosuhde: 121.2,
    Tyopaikkaomavaraisuus: 60.0,
    Alueella_asuva_tyollinen_tyovoima: 817,
    Ika20_64v_tyollisyysaste: 78.200000000000003,
    Asuinkunnassaan_tyossakayvia: 38.100000000000001,
    Tyottomia: 9.1999999999999993,
    Elakelaisia: 27.399999999999999,
    Alueella_olevia_tyopaikkoja: 490,
    Alkutuotannon_tyopaikkoja: 14.9,
    Jalostuksen_tyopaikkoja: 22.399999999999999,
    Palvelujen_tyopaikkoja: 61.200000000000003,
  },
  {
    Kunta: "Punkalaidun",
    Vakiluku: 2650,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 11.300000000000001,
    Ika15_64v: 51.0,
    Yli64v: 37.700000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.2000000000000002,
    Taajamaa: 41.100000000000001,
    Syntyneiden_enemmyys: -41,
    Muuttovoitto: 4,
    Perheita: 703,
    Asuntokuntia: 1390,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.300000000000001,
    Taloudellinen_huoltosuhde: 181.59999999999999,
    Tyopaikkaomavaraisuus: 77.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 950,
    Ika20_64v_tyollisyysaste: 74.299999999999997,
    Asuinkunnassaan_tyossakayvia: 55.600000000000001,
    Tyottomia: 6.4000000000000004,
    Elakelaisia: 41.200000000000003,
    Alueella_olevia_tyopaikkoja: 734,
    Alkutuotannon_tyopaikkoja: 29.0,
    Jalostuksen_tyopaikkoja: 22.100000000000001,
    Palvelujen_tyopaikkoja: 46.700000000000003,
  },
  {
    Kunta: "Puolanka",
    Vakiluku: 2359,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 8.9000000000000004,
    Ika15_64v: 48.100000000000001,
    Yli64v: 43.0,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 56.899999999999999,
    Syntyneiden_enemmyys: -51,
    Muuttovoitto: 16,
    Perheita: 648,
    Asuntokuntia: 1296,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 90.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 18.800000000000001,
    Taloudellinen_huoltosuhde: 250.0,
    Tyopaikkaomavaraisuus: 89.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 680,
    Ika20_64v_tyollisyysaste: 60.399999999999999,
    Asuinkunnassaan_tyossakayvia: 75.400000000000006,
    Tyottomia: 20.399999999999999,
    Elakelaisia: 49.600000000000001,
    Alueella_olevia_tyopaikkoja: 609,
    Alkutuotannon_tyopaikkoja: 21.199999999999999,
    Jalostuksen_tyopaikkoja: 9.4000000000000004,
    Palvelujen_tyopaikkoja: 67.5,
  },
  {
    Kunta: "Puumala",
    Vakiluku: 2108,
    Vakiluvun_muutos: 0.0,
    Alle15v: 6.2999999999999998,
    Ika15_64v: 46.799999999999997,
    Yli64v: 46.899999999999999,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 50.600000000000001,
    Syntyneiden_enemmyys: -27,
    Muuttovoitto: 21,
    Perheita: 579,
    Asuntokuntia: 1140,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 86.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.399999999999999,
    Taloudellinen_huoltosuhde: 179.09999999999999,
    Tyopaikkaomavaraisuus: 79.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 755,
    Ika20_64v_tyollisyysaste: 75.099999999999994,
    Asuinkunnassaan_tyossakayvia: 65.400000000000006,
    Tyottomia: 7.7000000000000002,
    Elakelaisia: 48.200000000000003,
    Alueella_olevia_tyopaikkoja: 597,
    Alkutuotannon_tyopaikkoja: 20.600000000000001,
    Jalostuksen_tyopaikkoja: 17.600000000000001,
    Palvelujen_tyopaikkoja: 59.5,
  },
  {
    Kunta: "Pyhtää",
    Vakiluku: 5065,
    Vakiluvun_muutos: -1.0,
    Alle15v: 15.6,
    Ika15_64v: 56.799999999999997,
    Yli64v: 27.600000000000001,
    Ruotsinkielisia: 6.7999999999999998,
    Ulkomaan_kansalaisia: 2.7999999999999998,
    Taajamaa: 74.900000000000006,
    Syntyneiden_enemmyys: -24,
    Muuttovoitto: -41,
    Perheita: 1472,
    Asuntokuntia: 2362,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 93.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 29.199999999999999,
    Taloudellinen_huoltosuhde: 140.69999999999999,
    Tyopaikkaomavaraisuus: 47.399999999999999,
    Alueella_asuva_tyollinen_tyovoima: 2126,
    Ika20_64v_tyollisyysaste: 77.599999999999994,
    Asuinkunnassaan_tyossakayvia: 26.199999999999999,
    Tyottomia: 9.9000000000000004,
    Elakelaisia: 31.199999999999999,
    Alueella_olevia_tyopaikkoja: 1007,
    Alkutuotannon_tyopaikkoja: 4.9000000000000004,
    Jalostuksen_tyopaikkoja: 25.199999999999999,
    Palvelujen_tyopaikkoja: 66.099999999999994,
  },
  {
    Kunta: "Pyhäjoki",
    Vakiluku: 2980,
    Vakiluvun_muutos: -0.40000000000000002,
    Alle15v: 16.199999999999999,
    Ika15_64v: 53.399999999999999,
    Yli64v: 30.399999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.6000000000000001,
    Taajamaa: 69.599999999999994,
    Syntyneiden_enemmyys: -25,
    Muuttovoitto: 3,
    Perheita: 833,
    Asuntokuntia: 1367,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.300000000000001,
    Taloudellinen_huoltosuhde: 168.5,
    Tyopaikkaomavaraisuus: 70.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 1114,
    Ika20_64v_tyollisyysaste: 74.799999999999997,
    Asuinkunnassaan_tyossakayvia: 44.100000000000001,
    Tyottomia: 11.0,
    Elakelaisia: 33.299999999999997,
    Alueella_olevia_tyopaikkoja: 783,
    Alkutuotannon_tyopaikkoja: 8.6999999999999993,
    Jalostuksen_tyopaikkoja: 37.5,
    Palvelujen_tyopaikkoja: 52.200000000000003,
  },
  {
    Kunta: "Pyhäjärvi",
    Vakiluku: 4756,
    Vakiluvun_muutos: -1.6000000000000001,
    Alle15v: 13.699999999999999,
    Ika15_64v: 48.700000000000003,
    Yli64v: 37.600000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.8999999999999999,
    Taajamaa: 54.299999999999997,
    Syntyneiden_enemmyys: -74,
    Muuttovoitto: -43,
    Perheita: 1268,
    Asuntokuntia: 2471,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 82.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.600000000000001,
    Taloudellinen_huoltosuhde: 207.59999999999999,
    Tyopaikkaomavaraisuus: 91.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 1572,
    Ika20_64v_tyollisyysaste: 68.700000000000003,
    Asuinkunnassaan_tyossakayvia: 74.700000000000003,
    Tyottomia: 12.9,
    Elakelaisia: 41.700000000000003,
    Alueella_olevia_tyopaikkoja: 1445,
    Alkutuotannon_tyopaikkoja: 12.9,
    Jalostuksen_tyopaikkoja: 15.199999999999999,
    Palvelujen_tyopaikkoja: 70.700000000000003,
  },
  {
    Kunta: "Pyhäntä",
    Vakiluku: 1646,
    Vakiluvun_muutos: 0.69999999999999996,
    Alle15v: 21.5,
    Ika15_64v: 53.299999999999997,
    Yli64v: 25.199999999999999,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 6.7999999999999998,
    Taajamaa: 56.799999999999997,
    Syntyneiden_enemmyys: 1,
    Muuttovoitto: -13,
    Perheita: 418,
    Asuntokuntia: 679,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.899999999999999,
    Taloudellinen_huoltosuhde: 174.30000000000001,
    Tyopaikkaomavaraisuus: 134.59999999999999,
    Alueella_asuva_tyollinen_tyovoima: 596,
    Ika20_64v_tyollisyysaste: 74.0,
    Asuinkunnassaan_tyossakayvia: 75.700000000000003,
    Tyottomia: 7.2999999999999998,
    Elakelaisia: 28.800000000000001,
    Alueella_olevia_tyopaikkoja: 802,
    Alkutuotannon_tyopaikkoja: 12.800000000000001,
    Jalostuksen_tyopaikkoja: 65.099999999999994,
    Palvelujen_tyopaikkoja: 21.600000000000001,
  },
  {
    Kunta: "Pyhäranta",
    Vakiluku: 1930,
    Vakiluvun_muutos: -1.7,
    Alle15v: 14.699999999999999,
    Ika15_64v: 54.700000000000003,
    Yli64v: 30.600000000000001,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 2.0,
    Taajamaa: 42.0,
    Syntyneiden_enemmyys: -20,
    Muuttovoitto: -14,
    Perheita: 565,
    Asuntokuntia: 935,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 8.4000000000000004,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.199999999999999,
    Taloudellinen_huoltosuhde: 139.69999999999999,
    Tyopaikkaomavaraisuus: 47.5,
    Alueella_asuva_tyollinen_tyovoima: 819,
    Ika20_64v_tyollisyysaste: 78.900000000000006,
    Asuinkunnassaan_tyossakayvia: 24.100000000000001,
    Tyottomia: 9.0,
    Elakelaisia: 32.799999999999997,
    Alueella_olevia_tyopaikkoja: 389,
    Alkutuotannon_tyopaikkoja: 7.2000000000000002,
    Jalostuksen_tyopaikkoja: 38.0,
    Palvelujen_tyopaikkoja: 52.700000000000003,
  },
  {
    Kunta: "Pälkäne",
    Vakiluku: 6337,
    Vakiluvun_muutos: -0.20000000000000001,
    Alle15v: 13.6,
    Ika15_64v: 55.600000000000001,
    Yli64v: 30.800000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 3.2999999999999998,
    Taajamaa: 56.100000000000001,
    Syntyneiden_enemmyys: -56,
    Muuttovoitto: -9,
    Perheita: 1810,
    Asuntokuntia: 3053,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 88.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.0,
    Taloudellinen_huoltosuhde: 144.0,
    Tyopaikkaomavaraisuus: 68.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 2601,
    Ika20_64v_tyollisyysaste: 78.700000000000003,
    Asuinkunnassaan_tyossakayvia: 45.799999999999997,
    Tyottomia: 6.2999999999999998,
    Elakelaisia: 33.700000000000003,
    Alueella_olevia_tyopaikkoja: 1791,
    Alkutuotannon_tyopaikkoja: 11.199999999999999,
    Jalostuksen_tyopaikkoja: 22.100000000000001,
    Palvelujen_tyopaikkoja: 64.5,
  },
  {
    Kunta: "Pöytyä",
    Vakiluku: 8130,
    Vakiluvun_muutos: -0.29999999999999999,
    Alle15v: 16.899999999999999,
    Ika15_64v: 56.299999999999997,
    Yli64v: 26.800000000000001,
    Ruotsinkielisia: 0.59999999999999998,
    Ulkomaan_kansalaisia: 4.5999999999999996,
    Taajamaa: 53.700000000000003,
    Syntyneiden_enemmyys: -20,
    Muuttovoitto: -65,
    Perheita: 2205,
    Asuntokuntia: 3782,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 15.9,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.199999999999999,
    Taloudellinen_huoltosuhde: 143.0,
    Tyopaikkaomavaraisuus: 73.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 3356,
    Ika20_64v_tyollisyysaste: 77.799999999999997,
    Asuinkunnassaan_tyossakayvia: 46.799999999999997,
    Tyottomia: 8.1999999999999993,
    Elakelaisia: 29.600000000000001,
    Alueella_olevia_tyopaikkoja: 2458,
    Alkutuotannon_tyopaikkoja: 14.800000000000001,
    Jalostuksen_tyopaikkoja: 31.5,
    Palvelujen_tyopaikkoja: 52.299999999999997,
  },
  {
    Kunta: "Raahe",
    Vakiluku: 23797,
    Vakiluvun_muutos: -1.1000000000000001,
    Alle15v: 16.5,
    Ika15_64v: 55.700000000000003,
    Yli64v: 27.699999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.7000000000000002,
    Taajamaa: 87.5,
    Syntyneiden_enemmyys: -111,
    Muuttovoitto: -321,
    Perheita: 6342,
    Asuntokuntia: 11564,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 74.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 27.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.0,
    Taloudellinen_huoltosuhde: 171.5,
    Tyopaikkaomavaraisuus: 113.8,
    Alueella_asuva_tyollinen_tyovoima: 8867,
    Ika20_64v_tyollisyysaste: 71.900000000000006,
    Asuinkunnassaan_tyossakayvia: 85.599999999999994,
    Tyottomia: 11.5,
    Elakelaisia: 31.399999999999999,
    Alueella_olevia_tyopaikkoja: 10091,
    Alkutuotannon_tyopaikkoja: 2.0,
    Jalostuksen_tyopaikkoja: 42.399999999999999,
    Palvelujen_tyopaikkoja: 54.799999999999997,
  },
  {
    Kunta: "Raasepori",
    Vakiluku: 27209,
    Vakiluvun_muutos: -0.40000000000000002,
    Alle15v: 13.9,
    Ika15_64v: 57.399999999999999,
    Yli64v: 28.699999999999999,
    Ruotsinkielisia: 63.600000000000001,
    Ulkomaan_kansalaisia: 4.5,
    Taajamaa: 77.900000000000006,
    Syntyneiden_enemmyys: -196,
    Muuttovoitto: -77,
    Perheita: 7375,
    Asuntokuntia: 13802,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 62.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 28.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 30.5,
    Taloudellinen_huoltosuhde: 136.59999999999999,
    Tyopaikkaomavaraisuus: 84.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 11539,
    Ika20_64v_tyollisyysaste: 77.599999999999994,
    Asuinkunnassaan_tyossakayvia: 70.799999999999997,
    Tyottomia: 8.8000000000000007,
    Elakelaisia: 31.199999999999999,
    Alueella_olevia_tyopaikkoja: 9777,
    Alkutuotannon_tyopaikkoja: 3.7000000000000002,
    Jalostuksen_tyopaikkoja: 21.800000000000001,
    Palvelujen_tyopaikkoja: 72.799999999999997,
  },
  {
    Kunta: "Raisio",
    Vakiluku: 25331,
    Vakiluvun_muutos: 1.6000000000000001,
    Alle15v: 15.300000000000001,
    Ika15_64v: 61.0,
    Yli64v: 23.699999999999999,
    Ruotsinkielisia: 1.3999999999999999,
    Ulkomaan_kansalaisia: 7.5999999999999996,
    Taajamaa: 99.299999999999997,
    Syntyneiden_enemmyys: -43,
    Muuttovoitto: 52,
    Perheita: 7015,
    Asuntokuntia: 12491,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 52.399999999999999,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 31.300000000000001,
    Taloudellinen_huoltosuhde: 119.59999999999999,
    Tyopaikkaomavaraisuus: 98.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 11358,
    Ika20_64v_tyollisyysaste: 78.799999999999997,
    Asuinkunnassaan_tyossakayvia: 29.800000000000001,
    Tyottomia: 7.4000000000000004,
    Elakelaisia: 26.5,
    Alueella_olevia_tyopaikkoja: 11152,
    Alkutuotannon_tyopaikkoja: 0.20000000000000001,
    Jalostuksen_tyopaikkoja: 25.5,
    Palvelujen_tyopaikkoja: 73.299999999999997,
  },
  {
    Kunta: "Rantasalmi",
    Vakiluku: 3297,
    Vakiluvun_muutos: -0.29999999999999999,
    Alle15v: 11.6,
    Ika15_64v: 51.200000000000003,
    Yli64v: 37.200000000000003,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 4.7000000000000002,
    Taajamaa: 39.100000000000001,
    Syntyneiden_enemmyys: -44,
    Muuttovoitto: -30,
    Perheita: 902,
    Asuntokuntia: 1704,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 82.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.0,
    Taloudellinen_huoltosuhde: 172.30000000000001,
    Tyopaikkaomavaraisuus: 85.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1215,
    Ika20_64v_tyollisyysaste: 72.700000000000003,
    Asuinkunnassaan_tyossakayvia: 65.0,
    Tyottomia: 9.1999999999999993,
    Elakelaisia: 41.0,
    Alueella_olevia_tyopaikkoja: 1035,
    Alkutuotannon_tyopaikkoja: 19.399999999999999,
    Jalostuksen_tyopaikkoja: 17.800000000000001,
    Palvelujen_tyopaikkoja: 61.399999999999999,
  },
  {
    Kunta: "Ranua",
    Vakiluku: 3599,
    Vakiluvun_muutos: -0.5,
    Alle15v: 16.800000000000001,
    Ika15_64v: 50.700000000000003,
    Yli64v: 32.600000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.5,
    Taajamaa: 49.5,
    Syntyneiden_enemmyys: -28,
    Muuttovoitto: -5,
    Perheita: 901,
    Asuntokuntia: 1635,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 18.0,
    Taloudellinen_huoltosuhde: 200.0,
    Tyopaikkaomavaraisuus: 95.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 1206,
    Ika20_64v_tyollisyysaste: 70.700000000000003,
    Asuinkunnassaan_tyossakayvia: 79.5,
    Tyottomia: 11.9,
    Elakelaisia: 37.0,
    Alueella_olevia_tyopaikkoja: 1151,
    Alkutuotannon_tyopaikkoja: 15.0,
    Jalostuksen_tyopaikkoja: 11.6,
    Palvelujen_tyopaikkoja: 72.200000000000003,
  },
  {
    Kunta: "Rauma",
    Vakiluku: 38832,
    Vakiluvun_muutos: 0.40000000000000002,
    Alle15v: 13.6,
    Ika15_64v: 59.200000000000003,
    Yli64v: 27.199999999999999,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 7.4000000000000004,
    Taajamaa: 93.400000000000006,
    Syntyneiden_enemmyys: -234,
    Muuttovoitto: -46,
    Perheita: 10387,
    Asuntokuntia: 20310,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 55.100000000000001,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 30.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 29.699999999999999,
    Taloudellinen_huoltosuhde: 135.80000000000001,
    Tyopaikkaomavaraisuus: 102.3,
    Alueella_asuva_tyollinen_tyovoima: 16399,
    Ika20_64v_tyollisyysaste: 75.799999999999997,
    Asuinkunnassaan_tyossakayvia: 76.599999999999994,
    Tyottomia: 9.0,
    Elakelaisia: 29.800000000000001,
    Alueella_olevia_tyopaikkoja: 16777,
    Alkutuotannon_tyopaikkoja: 1.0,
    Jalostuksen_tyopaikkoja: 34.600000000000001,
    Palvelujen_tyopaikkoja: 63.200000000000003,
  },
  {
    Kunta: "Rautalampi",
    Vakiluku: 2933,
    Vakiluvun_muutos: -1.0,
    Alle15v: 10.9,
    Ika15_64v: 52.200000000000003,
    Yli64v: 36.899999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.8999999999999999,
    Taajamaa: 48.600000000000001,
    Syntyneiden_enemmyys: -38,
    Muuttovoitto: -30,
    Perheita: 806,
    Asuntokuntia: 1572,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.300000000000001,
    Taloudellinen_huoltosuhde: 192.30000000000001,
    Tyopaikkaomavaraisuus: 81.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 1014,
    Ika20_64v_tyollisyysaste: 72.599999999999994,
    Asuinkunnassaan_tyossakayvia: 61.200000000000003,
    Tyottomia: 12.0,
    Elakelaisia: 41.399999999999999,
    Alueella_olevia_tyopaikkoja: 829,
    Alkutuotannon_tyopaikkoja: 17.899999999999999,
    Jalostuksen_tyopaikkoja: 15.9,
    Palvelujen_tyopaikkoja: 64.099999999999994,
  },
  {
    Kunta: "Rautavaara",
    Vakiluku: 1424,
    Vakiluvun_muutos: -3.6000000000000001,
    Alle15v: 8.6999999999999993,
    Ika15_64v: 48.700000000000003,
    Yli64v: 42.600000000000001,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 1.1000000000000001,
    Taajamaa: 44.5,
    Syntyneiden_enemmyys: -22,
    Muuttovoitto: -40,
    Perheita: 388,
    Asuntokuntia: 773,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 62.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 13.5,
    Taloudellinen_huoltosuhde: 223.90000000000001,
    Tyopaikkaomavaraisuus: 93.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 456,
    Ika20_64v_tyollisyysaste: 62.600000000000001,
    Asuinkunnassaan_tyossakayvia: 66.400000000000006,
    Tyottomia: 11.800000000000001,
    Elakelaisia: 48.399999999999999,
    Alueella_olevia_tyopaikkoja: 426,
    Alkutuotannon_tyopaikkoja: 11.699999999999999,
    Jalostuksen_tyopaikkoja: 12.199999999999999,
    Palvelujen_tyopaikkoja: 75.599999999999994,
  },
  {
    Kunta: "Rautjärvi",
    Vakiluku: 3032,
    Vakiluvun_muutos: -2.0,
    Alle15v: 8.9000000000000004,
    Ika15_64v: 49.0,
    Yli64v: 42.100000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.5,
    Taajamaa: 49.899999999999999,
    Syntyneiden_enemmyys: -55,
    Muuttovoitto: -31,
    Perheita: 857,
    Asuntokuntia: 1718,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 84.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.600000000000001,
    Taloudellinen_huoltosuhde: 215.30000000000001,
    Tyopaikkaomavaraisuus: 91.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 981,
    Ika20_64v_tyollisyysaste: 66.200000000000003,
    Asuinkunnassaan_tyossakayvia: 56.299999999999997,
    Tyottomia: 13.300000000000001,
    Elakelaisia: 47.5,
    Alueella_olevia_tyopaikkoja: 902,
    Alkutuotannon_tyopaikkoja: 7.2000000000000002,
    Jalostuksen_tyopaikkoja: 39.100000000000001,
    Palvelujen_tyopaikkoja: 52.100000000000001,
  },
  {
    Kunta: "Reisjärvi",
    Vakiluku: 2598,
    Vakiluvun_muutos: -1.3999999999999999,
    Alle15v: 18.399999999999999,
    Ika15_64v: 52.5,
    Yli64v: 29.100000000000001,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 0.80000000000000004,
    Taajamaa: 44.899999999999999,
    Syntyneiden_enemmyys: -12,
    Muuttovoitto: -28,
    Perheita: 670,
    Asuntokuntia: 1150,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 98.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.100000000000001,
    Taloudellinen_huoltosuhde: 166.80000000000001,
    Tyopaikkaomavaraisuus: 92.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 988,
    Ika20_64v_tyollisyysaste: 76.900000000000006,
    Asuinkunnassaan_tyossakayvia: 69.400000000000006,
    Tyottomia: 7.0999999999999996,
    Elakelaisia: 32.399999999999999,
    Alueella_olevia_tyopaikkoja: 918,
    Alkutuotannon_tyopaikkoja: 25.800000000000001,
    Jalostuksen_tyopaikkoja: 21.899999999999999,
    Palvelujen_tyopaikkoja: 51.100000000000001,
  },
  {
    Kunta: "Riihimäki",
    Vakiluku: 28483,
    Vakiluvun_muutos: 0.5,
    Alle15v: 14.300000000000001,
    Ika15_64v: 61.200000000000003,
    Yli64v: 24.399999999999999,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 4.7000000000000002,
    Taajamaa: 97.299999999999997,
    Syntyneiden_enemmyys: -109,
    Muuttovoitto: -107,
    Perheita: 7430,
    Asuntokuntia: 14920,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 44.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 35.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 29.399999999999999,
    Taloudellinen_huoltosuhde: 129.19999999999999,
    Tyopaikkaomavaraisuus: 96.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 12367,
    Ika20_64v_tyollisyysaste: 75.900000000000006,
    Asuinkunnassaan_tyossakayvia: 49.200000000000003,
    Tyottomia: 8.4000000000000004,
    Elakelaisia: 27.0,
    Alueella_olevia_tyopaikkoja: 11907,
    Alkutuotannon_tyopaikkoja: 0.40000000000000002,
    Jalostuksen_tyopaikkoja: 28.100000000000001,
    Palvelujen_tyopaikkoja: 70.599999999999994,
  },
  {
    Kunta: "Ristijärvi",
    Vakiluku: 1164,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 10.1,
    Ika15_64v: 47.5,
    Yli64v: 42.399999999999999,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 1.6000000000000001,
    Taajamaa: 41.700000000000003,
    Syntyneiden_enemmyys: -26,
    Muuttovoitto: 11,
    Perheita: 329,
    Asuntokuntia: 609,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.099999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.0,
    Taloudellinen_huoltosuhde: 180.19999999999999,
    Tyopaikkaomavaraisuus: 66.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 419,
    Ika20_64v_tyollisyysaste: 71.799999999999997,
    Asuinkunnassaan_tyossakayvia: 42.700000000000003,
    Tyottomia: 9.9000000000000004,
    Elakelaisia: 44.799999999999997,
    Alueella_olevia_tyopaikkoja: 280,
    Alkutuotannon_tyopaikkoja: 15.699999999999999,
    Jalostuksen_tyopaikkoja: 5.4000000000000004,
    Palvelujen_tyopaikkoja: 78.200000000000003,
  },
  {
    Kunta: "Rovaniemi",
    Vakiluku: 65286,
    Vakiluvun_muutos: 1.2,
    Alle15v: 15.6,
    Ika15_64v: 63.399999999999999,
    Yli64v: 21.0,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.6000000000000001,
    Taajamaa: 90.5,
    Syntyneiden_enemmyys: -42,
    Muuttovoitto: 178,
    Perheita: 16699,
    Asuntokuntia: 33938,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 49.399999999999999,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 40.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 80.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 35.200000000000003,
    Taloudellinen_huoltosuhde: 122.90000000000001,
    Tyopaikkaomavaraisuus: 98.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 28958,
    Ika20_64v_tyollisyysaste: 74.599999999999994,
    Asuinkunnassaan_tyossakayvia: 90.0,
    Tyottomia: 9.1999999999999993,
    Elakelaisia: 23.899999999999999,
    Alueella_olevia_tyopaikkoja: 28480,
    Alkutuotannon_tyopaikkoja: 1.7,
    Jalostuksen_tyopaikkoja: 13.5,
    Palvelujen_tyopaikkoja: 83.700000000000003,
  },
  {
    Kunta: "Ruokolahti",
    Vakiluku: 4758,
    Vakiluvun_muutos: -1.7,
    Alle15v: 11.1,
    Ika15_64v: 51.600000000000001,
    Yli64v: 37.299999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.5,
    Taajamaa: 60.899999999999999,
    Syntyneiden_enemmyys: -76,
    Muuttovoitto: -26,
    Perheita: 1408,
    Asuntokuntia: 2470,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 88.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.899999999999999,
    Taloudellinen_huoltosuhde: 182.30000000000001,
    Tyopaikkaomavaraisuus: 57.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 1715,
    Ika20_64v_tyollisyysaste: 72.5,
    Asuinkunnassaan_tyossakayvia: 30.300000000000001,
    Tyottomia: 11.4,
    Elakelaisia: 41.0,
    Alueella_olevia_tyopaikkoja: 982,
    Alkutuotannon_tyopaikkoja: 11.300000000000001,
    Jalostuksen_tyopaikkoja: 18.300000000000001,
    Palvelujen_tyopaikkoja: 68.200000000000003,
  },
  {
    Kunta: "Ruovesi",
    Vakiluku: 4124,
    Vakiluvun_muutos: 0.20000000000000001,
    Alle15v: 10.800000000000001,
    Ika15_64v: 49.299999999999997,
    Yli64v: 39.899999999999999,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 2.6000000000000001,
    Taajamaa: 48.899999999999999,
    Syntyneiden_enemmyys: -40,
    Muuttovoitto: 2,
    Perheita: 1136,
    Asuntokuntia: 2200,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 81.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.399999999999999,
    Taloudellinen_huoltosuhde: 176.30000000000001,
    Tyopaikkaomavaraisuus: 94.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 1489,
    Ika20_64v_tyollisyysaste: 75.599999999999994,
    Asuinkunnassaan_tyossakayvia: 65.400000000000006,
    Tyottomia: 8.4000000000000004,
    Elakelaisia: 42.799999999999997,
    Alueella_olevia_tyopaikkoja: 1408,
    Alkutuotannon_tyopaikkoja: 11.4,
    Jalostuksen_tyopaikkoja: 31.800000000000001,
    Palvelujen_tyopaikkoja: 54.5,
  },
  {
    Kunta: "Rusko",
    Vakiluku: 6436,
    Vakiluvun_muutos: 0.10000000000000001,
    Alle15v: 19.699999999999999,
    Ika15_64v: 59.399999999999999,
    Yli64v: 20.899999999999999,
    Ruotsinkielisia: 1.6000000000000001,
    Ulkomaan_kansalaisia: 1.8999999999999999,
    Taajamaa: 81.299999999999997,
    Syntyneiden_enemmyys: 3,
    Muuttovoitto: -14,
    Perheita: 2006,
    Asuntokuntia: 2635,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 7.5999999999999996,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 77.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 33.100000000000001,
    Taloudellinen_huoltosuhde: 110.2,
    Tyopaikkaomavaraisuus: 65.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 3058,
    Ika20_64v_tyollisyysaste: 86.0,
    Asuinkunnassaan_tyossakayvia: 22.100000000000001,
    Tyottomia: 3.7000000000000002,
    Elakelaisia: 23.0,
    Alueella_olevia_tyopaikkoja: 1998,
    Alkutuotannon_tyopaikkoja: 4.5999999999999996,
    Jalostuksen_tyopaikkoja: 46.5,
    Palvelujen_tyopaikkoja: 47.600000000000001,
  },
  {
    Kunta: "Rääkkylä",
    Vakiluku: 1902,
    Vakiluvun_muutos: -3.0,
    Alle15v: 6.7000000000000002,
    Ika15_64v: 46.200000000000003,
    Yli64v: 47.200000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.7000000000000002,
    Taajamaa: 25.300000000000001,
    Syntyneiden_enemmyys: -45,
    Muuttovoitto: -28,
    Perheita: 542,
    Asuntokuntia: 1080,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.800000000000001,
    Taloudellinen_huoltosuhde: 224.0,
    Tyopaikkaomavaraisuus: 79.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 605,
    Ika20_64v_tyollisyysaste: 66.0,
    Asuinkunnassaan_tyossakayvia: 61.700000000000003,
    Tyottomia: 15.5,
    Elakelaisia: 49.899999999999999,
    Alueella_olevia_tyopaikkoja: 480,
    Alkutuotannon_tyopaikkoja: 26.899999999999999,
    Jalostuksen_tyopaikkoja: 10.4,
    Palvelujen_tyopaikkoja: 59.600000000000001,
  },
  {
    Kunta: "Saarijärvi",
    Vakiluku: 8847,
    Vakiluvun_muutos: -1.3999999999999999,
    Alle15v: 12.300000000000001,
    Ika15_64v: 51.799999999999997,
    Yli64v: 35.899999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.3,
    Taajamaa: 57.600000000000001,
    Syntyneiden_enemmyys: -106,
    Muuttovoitto: -45,
    Perheita: 2370,
    Asuntokuntia: 4633,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 79.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.600000000000001,
    Taloudellinen_huoltosuhde: 195.0,
    Tyopaikkaomavaraisuus: 93.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 3042,
    Ika20_64v_tyollisyysaste: 69.0,
    Asuinkunnassaan_tyossakayvia: 70.400000000000006,
    Tyottomia: 14.5,
    Elakelaisia: 39.0,
    Alueella_olevia_tyopaikkoja: 2836,
    Alkutuotannon_tyopaikkoja: 10.9,
    Jalostuksen_tyopaikkoja: 19.199999999999999,
    Palvelujen_tyopaikkoja: 68.599999999999994,
  },
  {
    Kunta: "Salla",
    Vakiluku: 3344,
    Vakiluvun_muutos: 0.20000000000000001,
    Alle15v: 7.7000000000000002,
    Ika15_64v: 50.799999999999997,
    Yli64v: 41.600000000000001,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 3.2000000000000002,
    Taajamaa: 47.600000000000001,
    Syntyneiden_enemmyys: -45,
    Muuttovoitto: 13,
    Perheita: 888,
    Asuntokuntia: 1760,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 87.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.100000000000001,
    Taloudellinen_huoltosuhde: 192.40000000000001,
    Tyopaikkaomavaraisuus: 93.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1141,
    Ika20_64v_tyollisyysaste: 68.200000000000003,
    Asuinkunnassaan_tyossakayvia: 77.599999999999994,
    Tyottomia: 14.199999999999999,
    Elakelaisia: 45.700000000000003,
    Alueella_olevia_tyopaikkoja: 1063,
    Alkutuotannon_tyopaikkoja: 11.9,
    Jalostuksen_tyopaikkoja: 5.7000000000000002,
    Palvelujen_tyopaikkoja: 81.700000000000003,
  },
  {
    Kunta: "Salo",
    Vakiluku: 51100,
    Vakiluvun_muutos: 0.29999999999999999,
    Alle15v: 12.9,
    Ika15_64v: 57.700000000000003,
    Yli64v: 29.399999999999999,
    Ruotsinkielisia: 1.2,
    Ulkomaan_kansalaisia: 6.0,
    Taajamaa: 75.599999999999994,
    Syntyneiden_enemmyys: -361,
    Muuttovoitto: -140,
    Perheita: 13887,
    Asuntokuntia: 26334,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 70.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 26.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 27.100000000000001,
    Taloudellinen_huoltosuhde: 144.90000000000001,
    Tyopaikkaomavaraisuus: 88.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 20797,
    Ika20_64v_tyollisyysaste: 75.099999999999994,
    Asuinkunnassaan_tyossakayvia: 72.599999999999994,
    Tyottomia: 9.6999999999999993,
    Elakelaisia: 32.5,
    Alueella_olevia_tyopaikkoja: 18496,
    Alkutuotannon_tyopaikkoja: 4.7000000000000002,
    Jalostuksen_tyopaikkoja: 29.100000000000001,
    Palvelujen_tyopaikkoja: 65.0,
  },
  {
    Kunta: "Saltvik",
    Vakiluku: 1791,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 16.300000000000001,
    Ika15_64v: 57.0,
    Yli64v: 26.699999999999999,
    Ruotsinkielisia: 90.5,
    Ulkomaan_kansalaisia: 8.5,
    Taajamaa: 50.200000000000003,
    Syntyneiden_enemmyys: -4,
    Muuttovoitto: -6,
    Perheita: 490,
    Asuntokuntia: 817,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 15.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.0,
    Taloudellinen_huoltosuhde: 116.3,
    Tyopaikkaomavaraisuus: 56.899999999999999,
    Alueella_asuva_tyollinen_tyovoima: 829,
    Ika20_64v_tyollisyysaste: 83.299999999999997,
    Asuinkunnassaan_tyossakayvia: 26.800000000000001,
    Tyottomia: 3.7000000000000002,
    Elakelaisia: 26.699999999999999,
    Alueella_olevia_tyopaikkoja: 472,
    Alkutuotannon_tyopaikkoja: 14.0,
    Jalostuksen_tyopaikkoja: 41.100000000000001,
    Palvelujen_tyopaikkoja: 39.399999999999999,
  },
  {
    Kunta: "Sastamala",
    Vakiluku: 23515,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 13.1,
    Ika15_64v: 55.200000000000003,
    Yli64v: 31.699999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 68.599999999999994,
    Syntyneiden_enemmyys: -214,
    Muuttovoitto: -81,
    Perheita: 6519,
    Asuntokuntia: 11950,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 76.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.199999999999999,
    Taloudellinen_huoltosuhde: 155.19999999999999,
    Tyopaikkaomavaraisuus: 87.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 9300,
    Ika20_64v_tyollisyysaste: 75.5,
    Asuinkunnassaan_tyossakayvia: 65.599999999999994,
    Tyottomia: 7.4000000000000004,
    Elakelaisia: 35.200000000000003,
    Alueella_olevia_tyopaikkoja: 8151,
    Alkutuotannon_tyopaikkoja: 6.2999999999999998,
    Jalostuksen_tyopaikkoja: 27.100000000000001,
    Palvelujen_tyopaikkoja: 65.200000000000003,
  },
  {
    Kunta: "Sauvo",
    Vakiluku: 2974,
    Vakiluvun_muutos: 2.0,
    Alle15v: 15.0,
    Ika15_64v: 57.899999999999999,
    Yli64v: 27.100000000000001,
    Ruotsinkielisia: 2.5,
    Ulkomaan_kansalaisia: 6.0999999999999996,
    Taajamaa: 43.899999999999999,
    Syntyneiden_enemmyys: -13,
    Muuttovoitto: -30,
    Perheita: 859,
    Asuntokuntia: 1389,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 14.1,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 29.199999999999999,
    Taloudellinen_huoltosuhde: 130.19999999999999,
    Tyopaikkaomavaraisuus: 57.899999999999999,
    Alueella_asuva_tyollinen_tyovoima: 1267,
    Ika20_64v_tyollisyysaste: 79.900000000000006,
    Asuinkunnassaan_tyossakayvia: 34.899999999999999,
    Tyottomia: 4.5999999999999996,
    Elakelaisia: 30.899999999999999,
    Alueella_olevia_tyopaikkoja: 733,
    Alkutuotannon_tyopaikkoja: 17.5,
    Jalostuksen_tyopaikkoja: 23.5,
    Palvelujen_tyopaikkoja: 55.799999999999997,
  },
  {
    Kunta: "Savitaipale",
    Vakiluku: 3216,
    Vakiluvun_muutos: -1.2,
    Alle15v: 11.0,
    Ika15_64v: 49.200000000000003,
    Yli64v: 39.799999999999997,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 2.1000000000000001,
    Taajamaa: 52.399999999999999,
    Syntyneiden_enemmyys: -59,
    Muuttovoitto: -22,
    Perheita: 863,
    Asuntokuntia: 1714,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 90.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.899999999999999,
    Taloudellinen_huoltosuhde: 193.59999999999999,
    Tyopaikkaomavaraisuus: 80.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 1109,
    Ika20_64v_tyollisyysaste: 72.299999999999997,
    Asuinkunnassaan_tyossakayvia: 56.799999999999997,
    Tyottomia: 10.300000000000001,
    Elakelaisia: 43.5,
    Alueella_olevia_tyopaikkoja: 890,
    Alkutuotannon_tyopaikkoja: 17.399999999999999,
    Jalostuksen_tyopaikkoja: 15.5,
    Palvelujen_tyopaikkoja: 65.099999999999994,
  },
  {
    Kunta: "Savonlinna",
    Vakiluku: 31843,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 10.6,
    Ika15_64v: 54.600000000000001,
    Yli64v: 34.799999999999997,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 3.0,
    Taajamaa: 77.0,
    Syntyneiden_enemmyys: -355,
    Muuttovoitto: -103,
    Perheita: 8538,
    Asuntokuntia: 17617,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 58.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 31.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.699999999999999,
    Taloudellinen_huoltosuhde: 169.90000000000001,
    Tyopaikkaomavaraisuus: 100.8,
    Alueella_asuva_tyollinen_tyovoima: 11889,
    Ika20_64v_tyollisyysaste: 71.799999999999997,
    Asuinkunnassaan_tyossakayvia: 89.0,
    Tyottomia: 12.1,
    Elakelaisia: 38.0,
    Alueella_olevia_tyopaikkoja: 11989,
    Alkutuotannon_tyopaikkoja: 5.2999999999999998,
    Jalostuksen_tyopaikkoja: 23.5,
    Palvelujen_tyopaikkoja: 70.099999999999994,
  },
  {
    Kunta: "Savukoski",
    Vakiluku: 978,
    Vakiluvun_muutos: -1.0,
    Alle15v: 10.4,
    Ika15_64v: 54.0,
    Yli64v: 35.600000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 2.1000000000000001,
    Taajamaa: 37.799999999999997,
    Syntyneiden_enemmyys: -10,
    Muuttovoitto: -10,
    Perheita: 264,
    Asuntokuntia: 494,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.699999999999999,
    Taloudellinen_huoltosuhde: 168.5,
    Tyopaikkaomavaraisuus: 92.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 368,
    Ika20_64v_tyollisyysaste: 69.700000000000003,
    Asuinkunnassaan_tyossakayvia: 71.200000000000003,
    Tyottomia: 16.199999999999999,
    Elakelaisia: 39.399999999999999,
    Alueella_olevia_tyopaikkoja: 342,
    Alkutuotannon_tyopaikkoja: 36.799999999999997,
    Jalostuksen_tyopaikkoja: 5.5999999999999996,
    Palvelujen_tyopaikkoja: 56.700000000000003,
  },
  {
    Kunta: "Seinäjoki",
    Vakiluku: 66160,
    Vakiluvun_muutos: 1.3,
    Alle15v: 16.5,
    Ika15_64v: 62.600000000000001,
    Yli64v: 20.899999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.2999999999999998,
    Taajamaa: 91.900000000000006,
    Syntyneiden_enemmyys: -36,
    Muuttovoitto: 141,
    Perheita: 17392,
    Asuntokuntia: 33323,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 62.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 36.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 79.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 34.100000000000001,
    Taloudellinen_huoltosuhde: 118.40000000000001,
    Tyopaikkaomavaraisuus: 112.0,
    Alueella_asuva_tyollinen_tyovoima: 29904,
    Ika20_64v_tyollisyysaste: 77.900000000000006,
    Asuinkunnassaan_tyossakayvia: 80.799999999999997,
    Tyottomia: 7.4000000000000004,
    Elakelaisia: 23.5,
    Alueella_olevia_tyopaikkoja: 33489,
    Alkutuotannon_tyopaikkoja: 2.0,
    Jalostuksen_tyopaikkoja: 22.300000000000001,
    Palvelujen_tyopaikkoja: 74.900000000000006,
  },
  {
    Kunta: "Sievi",
    Vakiluku: 4713,
    Vakiluvun_muutos: -0.5,
    Alle15v: 22.800000000000001,
    Ika15_64v: 56.700000000000003,
    Yli64v: 20.5,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.0,
    Taajamaa: 49.5,
    Syntyneiden_enemmyys: -10,
    Muuttovoitto: -57,
    Perheita: 1141,
    Asuntokuntia: 1826,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 18.0,
    Taloudellinen_huoltosuhde: 164.19999999999999,
    Tyopaikkaomavaraisuus: 119.0,
    Alueella_asuva_tyollinen_tyovoima: 1792,
    Ika20_64v_tyollisyysaste: 76.700000000000003,
    Asuinkunnassaan_tyossakayvia: 62.200000000000003,
    Tyottomia: 8.0999999999999996,
    Elakelaisia: 24.600000000000001,
    Alueella_olevia_tyopaikkoja: 2132,
    Alkutuotannon_tyopaikkoja: 12.0,
    Jalostuksen_tyopaikkoja: 54.399999999999999,
    Palvelujen_tyopaikkoja: 32.700000000000003,
  },
  {
    Kunta: "Siikainen",
    Vakiluku: 1283,
    Vakiluvun_muutos: -1.8999999999999999,
    Alle15v: 10.699999999999999,
    Ika15_64v: 48.700000000000003,
    Yli64v: 40.600000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 1.2,
    Taajamaa: 30.300000000000001,
    Syntyneiden_enemmyys: -15,
    Muuttovoitto: -9,
    Perheita: 353,
    Asuntokuntia: 669,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 14.6,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 16.699999999999999,
    Taloudellinen_huoltosuhde: 201.40000000000001,
    Tyopaikkaomavaraisuus: 81.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 434,
    Ika20_64v_tyollisyysaste: 70.599999999999994,
    Asuinkunnassaan_tyossakayvia: 55.799999999999997,
    Tyottomia: 12.300000000000001,
    Elakelaisia: 43.399999999999999,
    Alueella_olevia_tyopaikkoja: 354,
    Alkutuotannon_tyopaikkoja: 19.5,
    Jalostuksen_tyopaikkoja: 40.399999999999999,
    Palvelujen_tyopaikkoja: 37.899999999999999,
  },
  {
    Kunta: "Siikajoki",
    Vakiluku: 4837,
    Vakiluvun_muutos: -1.2,
    Alle15v: 20.100000000000001,
    Ika15_64v: 52.700000000000003,
    Yli64v: 27.100000000000001,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 1.3,
    Taajamaa: 47.100000000000001,
    Syntyneiden_enemmyys: 7,
    Muuttovoitto: -111,
    Perheita: 1262,
    Asuntokuntia: 2111,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.300000000000001,
    Taloudellinen_huoltosuhde: 172.19999999999999,
    Tyopaikkaomavaraisuus: 90.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1799,
    Ika20_64v_tyollisyysaste: 74.799999999999997,
    Asuinkunnassaan_tyossakayvia: 55.700000000000003,
    Tyottomia: 8.8000000000000007,
    Elakelaisia: 30.399999999999999,
    Alueella_olevia_tyopaikkoja: 1631,
    Alkutuotannon_tyopaikkoja: 21.899999999999999,
    Jalostuksen_tyopaikkoja: 20.600000000000001,
    Palvelujen_tyopaikkoja: 56.100000000000001,
  },
  {
    Kunta: "Siikalatva",
    Vakiluku: 4931,
    Vakiluvun_muutos: -1.8999999999999999,
    Alle15v: 14.199999999999999,
    Ika15_64v: 53.0,
    Yli64v: 32.700000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.5,
    Taajamaa: 47.0,
    Syntyneiden_enemmyys: -54,
    Muuttovoitto: -63,
    Perheita: 1291,
    Asuntokuntia: 2450,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 16.600000000000001,
    Taloudellinen_huoltosuhde: 166.80000000000001,
    Tyopaikkaomavaraisuus: 93.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 1885,
    Ika20_64v_tyollisyysaste: 74.400000000000006,
    Asuinkunnassaan_tyossakayvia: 70.700000000000003,
    Tyottomia: 9.6999999999999993,
    Elakelaisia: 36.700000000000003,
    Alueella_olevia_tyopaikkoja: 1770,
    Alkutuotannon_tyopaikkoja: 22.5,
    Jalostuksen_tyopaikkoja: 19.800000000000001,
    Palvelujen_tyopaikkoja: 56.200000000000003,
  },
  {
    Kunta: "Siilinjärvi",
    Vakiluku: 21290,
    Vakiluvun_muutos: 0.29999999999999999,
    Alle15v: 18.600000000000001,
    Ika15_64v: 58.700000000000003,
    Yli64v: 22.800000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.6000000000000001,
    Taajamaa: 81.099999999999994,
    Syntyneiden_enemmyys: -20,
    Muuttovoitto: -75,
    Perheita: 6028,
    Asuntokuntia: 9684,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 77.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 79.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 33.700000000000003,
    Taloudellinen_huoltosuhde: 130.5,
    Tyopaikkaomavaraisuus: 78.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 9213,
    Ika20_64v_tyollisyysaste: 79.799999999999997,
    Asuinkunnassaan_tyossakayvia: 39.5,
    Tyottomia: 7.2000000000000002,
    Elakelaisia: 25.699999999999999,
    Alueella_olevia_tyopaikkoja: 7227,
    Alkutuotannon_tyopaikkoja: 3.6000000000000001,
    Jalostuksen_tyopaikkoja: 30.399999999999999,
    Palvelujen_tyopaikkoja: 64.900000000000006,
  },
  {
    Kunta: "Simo",
    Vakiluku: 2828,
    Vakiluvun_muutos: -1.7,
    Alle15v: 12.4,
    Ika15_64v: 51.299999999999997,
    Yli64v: 36.299999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 0.69999999999999996,
    Taajamaa: 53.600000000000001,
    Syntyneiden_enemmyys: -24,
    Muuttovoitto: -29,
    Perheita: 845,
    Asuntokuntia: 1385,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 98.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 12.1,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.199999999999999,
    Taloudellinen_huoltosuhde: 187.69999999999999,
    Tyopaikkaomavaraisuus: 56.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1000,
    Ika20_64v_tyollisyysaste: 73.0,
    Asuinkunnassaan_tyossakayvia: 38.600000000000001,
    Tyottomia: 11.300000000000001,
    Elakelaisia: 40.200000000000003,
    Alueella_olevia_tyopaikkoja: 562,
    Alkutuotannon_tyopaikkoja: 6.9000000000000004,
    Jalostuksen_tyopaikkoja: 16.399999999999999,
    Palvelujen_tyopaikkoja: 73.700000000000003,
  },
  {
    Kunta: "Sipoo",
    Vakiluku: 22595,
    Vakiluvun_muutos: 1.2,
    Alle15v: 17.100000000000001,
    Ika15_64v: 64.299999999999997,
    Yli64v: 18.5,
    Ruotsinkielisia: 28.100000000000001,
    Ulkomaan_kansalaisia: 5.0999999999999996,
    Taajamaa: 85.200000000000003,
    Syntyneiden_enemmyys: -6,
    Muuttovoitto: 128,
    Perheita: 6393,
    Asuntokuntia: 10068,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 66.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 37.0,
    Taloudellinen_huoltosuhde: 102.0,
    Tyopaikkaomavaraisuus: 64.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 11047,
    Ika20_64v_tyollisyysaste: 82.900000000000006,
    Asuinkunnassaan_tyossakayvia: 28.899999999999999,
    Tyottomia: 6.4000000000000004,
    Elakelaisia: 20.0,
    Alueella_olevia_tyopaikkoja: 7080,
    Alkutuotannon_tyopaikkoja: 1.8999999999999999,
    Jalostuksen_tyopaikkoja: 20.199999999999999,
    Palvelujen_tyopaikkoja: 76.099999999999994,
  },
  {
    Kunta: "Siuntio",
    Vakiluku: 6158,
    Vakiluvun_muutos: -0.90000000000000002,
    Alle15v: 16.0,
    Ika15_64v: 62.600000000000001,
    Yli64v: 21.399999999999999,
    Ruotsinkielisia: 26.300000000000001,
    Ulkomaan_kansalaisia: 6.0999999999999996,
    Taajamaa: 49.299999999999997,
    Syntyneiden_enemmyys: -15,
    Muuttovoitto: -76,
    Perheita: 1822,
    Asuntokuntia: 2689,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 88.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 15.6,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 36.5,
    Taloudellinen_huoltosuhde: 107.59999999999999,
    Tyopaikkaomavaraisuus: 43.600000000000001,
    Alueella_asuva_tyollinen_tyovoima: 2994,
    Ika20_64v_tyollisyysaste: 81.599999999999994,
    Asuinkunnassaan_tyossakayvia: 23.600000000000001,
    Tyottomia: 6.2000000000000002,
    Elakelaisia: 22.5,
    Alueella_olevia_tyopaikkoja: 1305,
    Alkutuotannon_tyopaikkoja: 6.7000000000000002,
    Jalostuksen_tyopaikkoja: 13.300000000000001,
    Palvelujen_tyopaikkoja: 77.200000000000003,
  },
  {
    Kunta: "Sodankylä",
    Vakiluku: 8126,
    Vakiluvun_muutos: -0.10000000000000001,
    Alle15v: 12.800000000000001,
    Ika15_64v: 57.5,
    Yli64v: 29.600000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 63.600000000000001,
    Syntyneiden_enemmyys: -82,
    Muuttovoitto: 43,
    Perheita: 2208,
    Asuntokuntia: 4076,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 86.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 30.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.600000000000001,
    Taloudellinen_huoltosuhde: 127.3,
    Tyopaikkaomavaraisuus: 105.90000000000001,
    Alueella_asuva_tyollinen_tyovoima: 3579,
    Ika20_64v_tyollisyysaste: 79.400000000000006,
    Asuinkunnassaan_tyossakayvia: 84.900000000000006,
    Tyottomia: 6.4000000000000004,
    Elakelaisia: 33.399999999999999,
    Alueella_olevia_tyopaikkoja: 3791,
    Alkutuotannon_tyopaikkoja: 6.2000000000000002,
    Jalostuksen_tyopaikkoja: 28.899999999999999,
    Palvelujen_tyopaikkoja: 64.299999999999997,
  },
  {
    Kunta: "Soini",
    Vakiluku: 1873,
    Vakiluvun_muutos: -3.6000000000000001,
    Alle15v: 15.6,
    Ika15_64v: 50.700000000000003,
    Yli64v: 33.700000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.1000000000000001,
    Taajamaa: 48.600000000000001,
    Syntyneiden_enemmyys: -20,
    Muuttovoitto: -48,
    Perheita: 511,
    Asuntokuntia: 889,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 64.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.100000000000001,
    Taloudellinen_huoltosuhde: 183.09999999999999,
    Tyopaikkaomavaraisuus: 99.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 686,
    Ika20_64v_tyollisyysaste: 73.299999999999997,
    Asuinkunnassaan_tyossakayvia: 67.799999999999997,
    Tyottomia: 9.6999999999999993,
    Elakelaisia: 36.799999999999997,
    Alueella_olevia_tyopaikkoja: 683,
    Alkutuotannon_tyopaikkoja: 15.4,
    Jalostuksen_tyopaikkoja: 25.199999999999999,
    Palvelujen_tyopaikkoja: 58.0,
  },
  {
    Kunta: "Somero",
    Vakiluku: 8410,
    Vakiluvun_muutos: -0.20000000000000001,
    Alle15v: 12.5,
    Ika15_64v: 53.200000000000003,
    Yli64v: 34.299999999999997,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 4.5999999999999996,
    Taajamaa: 57.700000000000003,
    Syntyneiden_enemmyys: -104,
    Muuttovoitto: -79,
    Perheita: 2274,
    Asuntokuntia: 4282,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 86.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.600000000000001,
    Taloudellinen_huoltosuhde: 161.40000000000001,
    Tyopaikkaomavaraisuus: 83.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 3224,
    Ika20_64v_tyollisyysaste: 75.900000000000006,
    Asuinkunnassaan_tyossakayvia: 63.0,
    Tyottomia: 7.7000000000000002,
    Elakelaisia: 37.600000000000001,
    Alueella_olevia_tyopaikkoja: 2700,
    Alkutuotannon_tyopaikkoja: 12.800000000000001,
    Jalostuksen_tyopaikkoja: 25.100000000000001,
    Palvelujen_tyopaikkoja: 60.5,
  },
  {
    Kunta: "Sonkajärvi",
    Vakiluku: 3637,
    Vakiluvun_muutos: -1.0,
    Alle15v: 11.300000000000001,
    Ika15_64v: 51.0,
    Yli64v: 37.700000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.0,
    Taajamaa: 43.700000000000003,
    Syntyneiden_enemmyys: -51,
    Muuttovoitto: -7,
    Perheita: 1022,
    Asuntokuntia: 1909,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 90.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.800000000000001,
    Taloudellinen_huoltosuhde: 186.40000000000001,
    Tyopaikkaomavaraisuus: 84.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 1282,
    Ika20_64v_tyollisyysaste: 70.900000000000006,
    Asuinkunnassaan_tyossakayvia: 54.399999999999999,
    Tyottomia: 11.800000000000001,
    Elakelaisia: 42.5,
    Alueella_olevia_tyopaikkoja: 1084,
    Alkutuotannon_tyopaikkoja: 20.100000000000001,
    Jalostuksen_tyopaikkoja: 15.4,
    Palvelujen_tyopaikkoja: 63.0,
  },
  {
    Kunta: "Sotkamo",
    Vakiluku: 10274,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 14.6,
    Ika15_64v: 56.899999999999999,
    Yli64v: 28.5,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.7000000000000002,
    Taajamaa: 60.5,
    Syntyneiden_enemmyys: -113,
    Muuttovoitto: -35,
    Perheita: 2842,
    Asuntokuntia: 5021,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 78.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 28.0,
    Taloudellinen_huoltosuhde: 134.69999999999999,
    Tyopaikkaomavaraisuus: 105.0,
    Alueella_asuva_tyollinen_tyovoima: 4411,
    Ika20_64v_tyollisyysaste: 79.099999999999994,
    Asuinkunnassaan_tyossakayvia: 67.599999999999994,
    Tyottomia: 6.0999999999999996,
    Elakelaisia: 31.399999999999999,
    Alueella_olevia_tyopaikkoja: 4633,
    Alkutuotannon_tyopaikkoja: 6.4000000000000004,
    Jalostuksen_tyopaikkoja: 36.200000000000003,
    Palvelujen_tyopaikkoja: 56.5,
  },
  {
    Kunta: "Sottunga",
    Vakiluku: 115,
    Vakiluvun_muutos: 3.6000000000000001,
    Alle15v: 18.300000000000001,
    Ika15_64v: 49.600000000000001,
    Yli64v: 32.200000000000003,
    Ruotsinkielisia: 93.0,
    Ulkomaan_kansalaisia: 30.399999999999999,
    Taajamaa: 0.0,
    Syntyneiden_enemmyys: 0,
    Muuttovoitto: 1,
    Perheita: 27,
    Asuntokuntia: 61,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 34.100000000000001,
    Taloudellinen_huoltosuhde: 158.09999999999999,
    Tyopaikkaomavaraisuus: 53.5,
    Alueella_asuva_tyollinen_tyovoima: 43,
    Ika20_64v_tyollisyysaste: 80.799999999999997,
    Asuinkunnassaan_tyossakayvia: 48.799999999999997,
    Tyottomia: 0.0,
    Elakelaisia: 36.0,
    Alueella_olevia_tyopaikkoja: 23,
    Alkutuotannon_tyopaikkoja: 30.399999999999999,
    Jalostuksen_tyopaikkoja: 4.2999999999999998,
    Palvelujen_tyopaikkoja: 60.899999999999999,
  },
  {
    Kunta: "Sulkava",
    Vakiluku: 2368,
    Vakiluvun_muutos: -0.29999999999999999,
    Alle15v: 9.0,
    Ika15_64v: 48.299999999999997,
    Yli64v: 42.700000000000003,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.5,
    Taajamaa: 42.399999999999999,
    Syntyneiden_enemmyys: -35,
    Muuttovoitto: 2,
    Perheita: 661,
    Asuntokuntia: 1262,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.800000000000001,
    Taloudellinen_huoltosuhde: 204.5,
    Tyopaikkaomavaraisuus: 90.5,
    Alueella_asuva_tyollinen_tyovoima: 780,
    Ika20_64v_tyollisyysaste: 70.0,
    Asuinkunnassaan_tyossakayvia: 68.299999999999997,
    Tyottomia: 9.3000000000000007,
    Elakelaisia: 47.0,
    Alueella_olevia_tyopaikkoja: 706,
    Alkutuotannon_tyopaikkoja: 16.600000000000001,
    Jalostuksen_tyopaikkoja: 18.100000000000001,
    Palvelujen_tyopaikkoja: 63.299999999999997,
  },
  {
    Kunta: "Sund",
    Vakiluku: 995,
    Vakiluvun_muutos: -0.59999999999999998,
    Alle15v: 14.199999999999999,
    Ika15_64v: 58.0,
    Yli64v: 27.800000000000001,
    Ruotsinkielisia: 88.0,
    Ulkomaan_kansalaisia: 9.0999999999999996,
    Taajamaa: 0.0,
    Syntyneiden_enemmyys: -7,
    Muuttovoitto: 3,
    Perheita: 285,
    Asuntokuntia: 486,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 15.9,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.899999999999999,
    Taloudellinen_huoltosuhde: 115.3,
    Tyopaikkaomavaraisuus: 43.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 465,
    Ika20_64v_tyollisyysaste: 84.700000000000003,
    Asuinkunnassaan_tyossakayvia: 21.699999999999999,
    Tyottomia: 4.5,
    Elakelaisia: 27.600000000000001,
    Alueella_olevia_tyopaikkoja: 201,
    Alkutuotannon_tyopaikkoja: 15.9,
    Jalostuksen_tyopaikkoja: 14.4,
    Palvelujen_tyopaikkoja: 61.200000000000003,
  },
  {
    Kunta: "Suomussalmi",
    Vakiluku: 7172,
    Vakiluvun_muutos: -2.6000000000000001,
    Alle15v: 9.5,
    Ika15_64v: 49.0,
    Yli64v: 41.600000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.1000000000000001,
    Taajamaa: 63.600000000000001,
    Syntyneiden_enemmyys: -117,
    Muuttovoitto: -97,
    Perheita: 2005,
    Asuntokuntia: 3879,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 79.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 18.699999999999999,
    Taloudellinen_huoltosuhde: 199.30000000000001,
    Tyopaikkaomavaraisuus: 86.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 2461,
    Ika20_64v_tyollisyysaste: 69.0,
    Asuinkunnassaan_tyossakayvia: 78.5,
    Tyottomia: 12.199999999999999,
    Elakelaisia: 45.600000000000001,
    Alueella_olevia_tyopaikkoja: 2137,
    Alkutuotannon_tyopaikkoja: 9.6999999999999993,
    Jalostuksen_tyopaikkoja: 22.399999999999999,
    Palvelujen_tyopaikkoja: 66.5,
  },
  {
    Kunta: "Suonenjoki",
    Vakiluku: 6708,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 12.9,
    Ika15_64v: 53.200000000000003,
    Yli64v: 33.799999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.1000000000000001,
    Taajamaa: 72.200000000000003,
    Syntyneiden_enemmyys: -86,
    Muuttovoitto: -59,
    Perheita: 1798,
    Asuntokuntia: 3583,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 66.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 28.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.199999999999999,
    Taloudellinen_huoltosuhde: 169.5,
    Tyopaikkaomavaraisuus: 94.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 2509,
    Ika20_64v_tyollisyysaste: 72.900000000000006,
    Asuinkunnassaan_tyossakayvia: 66.0,
    Tyottomia: 9.1999999999999993,
    Elakelaisia: 38.5,
    Alueella_olevia_tyopaikkoja: 2360,
    Alkutuotannon_tyopaikkoja: 7.2000000000000002,
    Jalostuksen_tyopaikkoja: 28.699999999999999,
    Palvelujen_tyopaikkoja: 62.799999999999997,
  },
  {
    Kunta: "Sysmä",
    Vakiluku: 3496,
    Vakiluvun_muutos: -0.20000000000000001,
    Alle15v: 7.7999999999999998,
    Ika15_64v: 46.100000000000001,
    Yli64v: 46.100000000000001,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 2.2000000000000002,
    Taajamaa: 52.200000000000003,
    Syntyneiden_enemmyys: -64,
    Muuttovoitto: 30,
    Perheita: 932,
    Asuntokuntia: 2005,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 83.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 64.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.0,
    Taloudellinen_huoltosuhde: 212.90000000000001,
    Tyopaikkaomavaraisuus: 86.5,
    Alueella_asuva_tyollinen_tyovoima: 1120,
    Ika20_64v_tyollisyysaste: 70.700000000000003,
    Asuinkunnassaan_tyossakayvia: 69.599999999999994,
    Tyottomia: 11.1,
    Elakelaisia: 49.100000000000001,
    Alueella_olevia_tyopaikkoja: 969,
    Alkutuotannon_tyopaikkoja: 20.699999999999999,
    Jalostuksen_tyopaikkoja: 14.0,
    Palvelujen_tyopaikkoja: 62.799999999999997,
  },
  {
    Kunta: "Säkylä",
    Vakiluku: 6377,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 12.5,
    Ika15_64v: 54.399999999999999,
    Yli64v: 33.100000000000001,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 4.4000000000000004,
    Taajamaa: 73.0,
    Syntyneiden_enemmyys: -75,
    Muuttovoitto: -41,
    Perheita: 1785,
    Asuntokuntia: 3300,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 86.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 24.5,
    Taloudellinen_huoltosuhde: 150.09999999999999,
    Tyopaikkaomavaraisuus: 121.59999999999999,
    Alueella_asuva_tyollinen_tyovoima: 2567,
    Ika20_64v_tyollisyysaste: 77.799999999999997,
    Asuinkunnassaan_tyossakayvia: 60.399999999999999,
    Tyottomia: 7.2000000000000002,
    Elakelaisia: 36.799999999999997,
    Alueella_olevia_tyopaikkoja: 3122,
    Alkutuotannon_tyopaikkoja: 5.4000000000000004,
    Jalostuksen_tyopaikkoja: 33.899999999999999,
    Palvelujen_tyopaikkoja: 59.899999999999999,
  },
  {
    Kunta: "Taipalsaari",
    Vakiluku: 4625,
    Vakiluvun_muutos: 1.3999999999999999,
    Alle15v: 14.699999999999999,
    Ika15_64v: 56.5,
    Yli64v: 28.800000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 4.2999999999999998,
    Taajamaa: 59.200000000000003,
    Syntyneiden_enemmyys: -30,
    Muuttovoitto: 0,
    Perheita: 1383,
    Asuntokuntia: 2094,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 10.1,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 77.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 36.200000000000003,
    Taloudellinen_huoltosuhde: 145.80000000000001,
    Tyopaikkaomavaraisuus: 42.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1855,
    Ika20_64v_tyollisyysaste: 76.700000000000003,
    Asuinkunnassaan_tyossakayvia: 24.300000000000001,
    Tyottomia: 9.0,
    Elakelaisia: 31.5,
    Alueella_olevia_tyopaikkoja: 782,
    Alkutuotannon_tyopaikkoja: 9.0,
    Jalostuksen_tyopaikkoja: 12.800000000000001,
    Palvelujen_tyopaikkoja: 74.299999999999997,
  },
  {
    Kunta: "Taivalkoski",
    Vakiluku: 3731,
    Vakiluvun_muutos: -2.5,
    Alle15v: 14.1,
    Ika15_64v: 52.299999999999997,
    Yli64v: 33.700000000000003,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.7,
    Taajamaa: 47.399999999999999,
    Syntyneiden_enemmyys: -52,
    Muuttovoitto: -56,
    Perheita: 988,
    Asuntokuntia: 1784,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 85.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 18.100000000000001,
    Taloudellinen_huoltosuhde: 182.69999999999999,
    Tyopaikkaomavaraisuus: 91.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1353,
    Ika20_64v_tyollisyysaste: 69.700000000000003,
    Asuinkunnassaan_tyossakayvia: 80.299999999999997,
    Tyottomia: 12.5,
    Elakelaisia: 37.700000000000003,
    Alueella_olevia_tyopaikkoja: 1241,
    Alkutuotannon_tyopaikkoja: 14.300000000000001,
    Jalostuksen_tyopaikkoja: 19.399999999999999,
    Palvelujen_tyopaikkoja: 65.099999999999994,
  },
  {
    Kunta: "Taivassalo",
    Vakiluku: 1705,
    Vakiluvun_muutos: 0.80000000000000004,
    Alle15v: 12.800000000000001,
    Ika15_64v: 51.299999999999997,
    Yli64v: 36.0,
    Ruotsinkielisia: 1.1000000000000001,
    Ulkomaan_kansalaisia: 5.9000000000000004,
    Taajamaa: 39.299999999999997,
    Syntyneiden_enemmyys: -13,
    Muuttovoitto: 7,
    Perheita: 483,
    Asuntokuntia: 838,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 66.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.0,
    Taloudellinen_huoltosuhde: 161.80000000000001,
    Tyopaikkaomavaraisuus: 74.0,
    Alueella_asuva_tyollinen_tyovoima: 646,
    Ika20_64v_tyollisyysaste: 75.299999999999997,
    Asuinkunnassaan_tyossakayvia: 48.0,
    Tyottomia: 8.8000000000000007,
    Elakelaisia: 38.5,
    Alueella_olevia_tyopaikkoja: 478,
    Alkutuotannon_tyopaikkoja: 15.300000000000001,
    Jalostuksen_tyopaikkoja: 26.600000000000001,
    Palvelujen_tyopaikkoja: 55.899999999999999,
  },
  {
    Kunta: "Tammela",
    Vakiluku: 5844,
    Vakiluvun_muutos: -0.59999999999999998,
    Alle15v: 13.5,
    Ika15_64v: 56.899999999999999,
    Yli64v: 29.600000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.3999999999999999,
    Taajamaa: 52.600000000000001,
    Syntyneiden_enemmyys: -48,
    Muuttovoitto: -21,
    Perheita: 1688,
    Asuntokuntia: 2768,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 88.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 28.800000000000001,
    Taloudellinen_huoltosuhde: 136.30000000000001,
    Tyopaikkaomavaraisuus: 68.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 2488,
    Ika20_64v_tyollisyysaste: 78.900000000000006,
    Asuinkunnassaan_tyossakayvia: 35.799999999999997,
    Tyottomia: 7.7000000000000002,
    Elakelaisia: 32.0,
    Alueella_olevia_tyopaikkoja: 1714,
    Alkutuotannon_tyopaikkoja: 9.5,
    Jalostuksen_tyopaikkoja: 29.800000000000001,
    Palvelujen_tyopaikkoja: 58.799999999999997,
  },
  {
    Kunta: "Tampere",
    Vakiluku: 255050,
    Vakiluvun_muutos: 2.3999999999999999,
    Alle15v: 12.6,
    Ika15_64v: 68.5,
    Yli64v: 18.899999999999999,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 6.7999999999999998,
    Taajamaa: 98.700000000000003,
    Syntyneiden_enemmyys: -256,
    Muuttovoitto: 3145,
    Perheita: 61762,
    Asuntokuntia: 144123,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 22.300000000000001,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 51.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 79.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 38.899999999999999,
    Taloudellinen_huoltosuhde: 116.0,
    Tyopaikkaomavaraisuus: 118.7,
    Alueella_asuva_tyollinen_tyovoima: 115260,
    Ika20_64v_tyollisyysaste: 71.099999999999994,
    Asuinkunnassaan_tyossakayvia: 77.599999999999994,
    Tyottomia: 9.9000000000000004,
    Elakelaisia: 21.600000000000001,
    Alueella_olevia_tyopaikkoja: 136760,
    Alkutuotannon_tyopaikkoja: 0.20000000000000001,
    Jalostuksen_tyopaikkoja: 17.899999999999999,
    Palvelujen_tyopaikkoja: 80.900000000000006,
  },
  {
    Kunta: "Tervo",
    Vakiluku: 1412,
    Vakiluvun_muutos: -2.0,
    Alle15v: 8.9000000000000004,
    Ika15_64v: 47.799999999999997,
    Yli64v: 43.299999999999997,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.7,
    Taajamaa: 34.799999999999997,
    Syntyneiden_enemmyys: -29,
    Muuttovoitto: -4,
    Perheita: 392,
    Asuntokuntia: 777,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.699999999999999,
    Taloudellinen_huoltosuhde: 195.30000000000001,
    Tyopaikkaomavaraisuus: 71.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 488,
    Ika20_64v_tyollisyysaste: 69.299999999999997,
    Asuinkunnassaan_tyossakayvia: 46.299999999999997,
    Tyottomia: 12.4,
    Elakelaisia: 47.5,
    Alueella_olevia_tyopaikkoja: 347,
    Alkutuotannon_tyopaikkoja: 18.399999999999999,
    Jalostuksen_tyopaikkoja: 6.2999999999999998,
    Palvelujen_tyopaikkoja: 74.099999999999994,
  },
  {
    Kunta: "Tervola",
    Vakiluku: 2831,
    Vakiluvun_muutos: -1.1000000000000001,
    Alle15v: 15.199999999999999,
    Ika15_64v: 53.0,
    Yli64v: 31.800000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 34.299999999999997,
    Syntyneiden_enemmyys: -24,
    Muuttovoitto: -13,
    Perheita: 729,
    Asuntokuntia: 1428,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 22.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.0,
    Taloudellinen_huoltosuhde: 165.30000000000001,
    Tyopaikkaomavaraisuus: 93.099999999999994,
    Alueella_asuva_tyollinen_tyovoima: 1079,
    Ika20_64v_tyollisyysaste: 74.200000000000003,
    Asuinkunnassaan_tyossakayvia: 65.599999999999994,
    Tyottomia: 11.5,
    Elakelaisia: 35.100000000000001,
    Alueella_olevia_tyopaikkoja: 1005,
    Alkutuotannon_tyopaikkoja: 12.800000000000001,
    Jalostuksen_tyopaikkoja: 28.100000000000001,
    Palvelujen_tyopaikkoja: 58.5,
  },
  {
    Kunta: "Teuva",
    Vakiluku: 4758,
    Vakiluvun_muutos: -2.1000000000000001,
    Alle15v: 13.5,
    Ika15_64v: 51.299999999999997,
    Yli64v: 35.100000000000001,
    Ruotsinkielisia: 0.90000000000000002,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 66.400000000000006,
    Syntyneiden_enemmyys: -84,
    Muuttovoitto: -27,
    Perheita: 1319,
    Asuntokuntia: 2314,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 15.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.600000000000001,
    Taloudellinen_huoltosuhde: 177.0,
    Tyopaikkaomavaraisuus: 87.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1755,
    Ika20_64v_tyollisyysaste: 74.799999999999997,
    Asuinkunnassaan_tyossakayvia: 62.299999999999997,
    Tyottomia: 9.9000000000000004,
    Elakelaisia: 38.700000000000003,
    Alueella_olevia_tyopaikkoja: 1531,
    Alkutuotannon_tyopaikkoja: 17.600000000000001,
    Jalostuksen_tyopaikkoja: 28.5,
    Palvelujen_tyopaikkoja: 52.700000000000003,
  },
  {
    Kunta: "Tohmajärvi",
    Vakiluku: 4066,
    Vakiluvun_muutos: -2.2999999999999998,
    Alle15v: 12.699999999999999,
    Ika15_64v: 51.0,
    Yli64v: 36.299999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.0,
    Taajamaa: 34.700000000000003,
    Syntyneiden_enemmyys: -55,
    Muuttovoitto: -61,
    Perheita: 1120,
    Asuntokuntia: 2088,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 90.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.199999999999999,
    Taloudellinen_huoltosuhde: 189.90000000000001,
    Tyopaikkaomavaraisuus: 84.5,
    Alueella_asuva_tyollinen_tyovoima: 1435,
    Ika20_64v_tyollisyysaste: 69.799999999999997,
    Asuinkunnassaan_tyossakayvia: 56.200000000000003,
    Tyottomia: 15.6,
    Elakelaisia: 39.399999999999999,
    Alueella_olevia_tyopaikkoja: 1213,
    Alkutuotannon_tyopaikkoja: 16.100000000000001,
    Jalostuksen_tyopaikkoja: 12.5,
    Palvelujen_tyopaikkoja: 70.299999999999997,
  },
  {
    Kunta: "Toholampi",
    Vakiluku: 2849,
    Vakiluvun_muutos: -1.8999999999999999,
    Alle15v: 17.100000000000001,
    Ika15_64v: 52.799999999999997,
    Yli64v: 30.199999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.0,
    Taajamaa: 52.200000000000003,
    Syntyneiden_enemmyys: -26,
    Muuttovoitto: -35,
    Perheita: 771,
    Asuntokuntia: 1293,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.600000000000001,
    Taloudellinen_huoltosuhde: 167.30000000000001,
    Tyopaikkaomavaraisuus: 90.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 1086,
    Ika20_64v_tyollisyysaste: 78.0,
    Asuinkunnassaan_tyossakayvia: 66.0,
    Tyottomia: 6.0999999999999996,
    Elakelaisia: 32.899999999999999,
    Alueella_olevia_tyopaikkoja: 981,
    Alkutuotannon_tyopaikkoja: 20.600000000000001,
    Jalostuksen_tyopaikkoja: 23.899999999999999,
    Palvelujen_tyopaikkoja: 54.100000000000001,
  },
  {
    Kunta: "Toivakka",
    Vakiluku: 2368,
    Vakiluvun_muutos: -1.6000000000000001,
    Alle15v: 17.5,
    Ika15_64v: 52.600000000000001,
    Yli64v: 29.899999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.5,
    Taajamaa: 43.5,
    Syntyneiden_enemmyys: -19,
    Muuttovoitto: -22,
    Perheita: 643,
    Asuntokuntia: 1096,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 98.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 15.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.5,
    Taloudellinen_huoltosuhde: 158.80000000000001,
    Tyopaikkaomavaraisuus: 61.600000000000001,
    Alueella_asuva_tyollinen_tyovoima: 930,
    Ika20_64v_tyollisyysaste: 78.0,
    Asuinkunnassaan_tyossakayvia: 35.799999999999997,
    Tyottomia: 9.4000000000000004,
    Elakelaisia: 32.100000000000001,
    Alueella_olevia_tyopaikkoja: 573,
    Alkutuotannon_tyopaikkoja: 5.9000000000000004,
    Jalostuksen_tyopaikkoja: 35.299999999999997,
    Palvelujen_tyopaikkoja: 56.399999999999999,
  },
  {
    Kunta: "Tornio",
    Vakiluku: 21018,
    Vakiluvun_muutos: -1.0,
    Alle15v: 16.0,
    Ika15_64v: 58.0,
    Yli64v: 26.0,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 3.2000000000000002,
    Taajamaa: 87.5,
    Syntyneiden_enemmyys: -92,
    Muuttovoitto: -195,
    Perheita: 5671,
    Asuntokuntia: 10257,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 66.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 29.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.699999999999999,
    Taloudellinen_huoltosuhde: 145.09999999999999,
    Tyopaikkaomavaraisuus: 102.2,
    Alueella_asuva_tyollinen_tyovoima: 8661,
    Ika20_64v_tyollisyysaste: 75.299999999999997,
    Asuinkunnassaan_tyossakayvia: 76.799999999999997,
    Tyottomia: 10.1,
    Elakelaisia: 28.399999999999999,
    Alueella_olevia_tyopaikkoja: 8853,
    Alkutuotannon_tyopaikkoja: 1.8999999999999999,
    Jalostuksen_tyopaikkoja: 40.899999999999999,
    Palvelujen_tyopaikkoja: 53.899999999999999,
  },
  {
    Kunta: "Turku",
    Vakiluku: 201863,
    Vakiluvun_muutos: 2.0,
    Alle15v: 12.199999999999999,
    Ika15_64v: 67.299999999999997,
    Yli64v: 20.5,
    Ruotsinkielisia: 5.4000000000000004,
    Ulkomaan_kansalaisia: 9.4000000000000004,
    Taajamaa: 99.099999999999994,
    Syntyneiden_enemmyys: -590,
    Muuttovoitto: 1424,
    Perheita: 47630,
    Asuntokuntia: 114665,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 23.399999999999999,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 51.799999999999997,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 77.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 36.100000000000001,
    Taloudellinen_huoltosuhde: 123.40000000000001,
    Tyopaikkaomavaraisuus: 121.8,
    Alueella_asuva_tyollinen_tyovoima: 88595,
    Ika20_64v_tyollisyysaste: 69.700000000000003,
    Asuinkunnassaan_tyossakayvia: 75.099999999999994,
    Tyottomia: 11.5,
    Elakelaisia: 23.300000000000001,
    Alueella_olevia_tyopaikkoja: 107904,
    Alkutuotannon_tyopaikkoja: 0.29999999999999999,
    Jalostuksen_tyopaikkoja: 16.5,
    Palvelujen_tyopaikkoja: 82.0,
  },
  {
    Kunta: "Tuusniemi",
    Vakiluku: 2313,
    Vakiluvun_muutos: -3.3999999999999999,
    Alle15v: 9.4000000000000004,
    Ika15_64v: 49.5,
    Yli64v: 41.100000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.1000000000000001,
    Taajamaa: 40.200000000000003,
    Syntyneiden_enemmyys: -57,
    Muuttovoitto: -24,
    Perheita: 618,
    Asuntokuntia: 1288,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 89.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.800000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.399999999999999,
    Taloudellinen_huoltosuhde: 212.90000000000001,
    Tyopaikkaomavaraisuus: 81.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 765,
    Ika20_64v_tyollisyysaste: 64.099999999999994,
    Asuinkunnassaan_tyossakayvia: 53.100000000000001,
    Tyottomia: 12.9,
    Elakelaisia: 47.5,
    Alueella_olevia_tyopaikkoja: 621,
    Alkutuotannon_tyopaikkoja: 21.600000000000001,
    Jalostuksen_tyopaikkoja: 19.0,
    Palvelujen_tyopaikkoja: 57.299999999999997,
  },
  {
    Kunta: "Tuusula",
    Vakiluku: 41338,
    Vakiluvun_muutos: 2.3999999999999999,
    Alle15v: 17.300000000000001,
    Ika15_64v: 64.0,
    Yli64v: 18.699999999999999,
    Ruotsinkielisia: 1.3999999999999999,
    Ulkomaan_kansalaisia: 5.7999999999999998,
    Taajamaa: 95.299999999999997,
    Syntyneiden_enemmyys: -9,
    Muuttovoitto: 693,
    Perheita: 11632,
    Asuntokuntia: 18642,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 66.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 34.200000000000003,
    Taloudellinen_huoltosuhde: 105.7,
    Tyopaikkaomavaraisuus: 71.900000000000006,
    Alueella_asuva_tyollinen_tyovoima: 19634,
    Ika20_64v_tyollisyysaste: 82.099999999999994,
    Asuinkunnassaan_tyossakayvia: 26.800000000000001,
    Tyottomia: 6.2999999999999998,
    Elakelaisia: 20.899999999999999,
    Alueella_olevia_tyopaikkoja: 14123,
    Alkutuotannon_tyopaikkoja: 0.90000000000000002,
    Jalostuksen_tyopaikkoja: 32.0,
    Palvelujen_tyopaikkoja: 65.5,
  },
  {
    Kunta: "Tyrnävä",
    Vakiluku: 6525,
    Vakiluvun_muutos: -0.59999999999999998,
    Alle15v: 28.399999999999999,
    Ika15_64v: 56.600000000000001,
    Yli64v: 15.0,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 0.80000000000000004,
    Taajamaa: 70.900000000000006,
    Syntyneiden_enemmyys: 20,
    Muuttovoitto: -72,
    Perheita: 1628,
    Asuntokuntia: 2332,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 13.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 74.400000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.800000000000001,
    Taloudellinen_huoltosuhde: 151.30000000000001,
    Tyopaikkaomavaraisuus: 54.399999999999999,
    Alueella_asuva_tyollinen_tyovoima: 2611,
    Ika20_64v_tyollisyysaste: 79.799999999999997,
    Asuinkunnassaan_tyossakayvia: 32.700000000000003,
    Tyottomia: 7.0999999999999996,
    Elakelaisia: 17.100000000000001,
    Alueella_olevia_tyopaikkoja: 1420,
    Alkutuotannon_tyopaikkoja: 11.199999999999999,
    Jalostuksen_tyopaikkoja: 18.699999999999999,
    Palvelujen_tyopaikkoja: 68.700000000000003,
  },
  {
    Kunta: "Ulvila",
    Vakiluku: 12533,
    Vakiluvun_muutos: -0.5,
    Alle15v: 16.199999999999999,
    Ika15_64v: 56.100000000000001,
    Yli64v: 27.699999999999999,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 1.8999999999999999,
    Taajamaa: 85.400000000000006,
    Syntyneiden_enemmyys: -83,
    Muuttovoitto: -55,
    Perheita: 3635,
    Asuntokuntia: 5959,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 83.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 28.899999999999999,
    Taloudellinen_huoltosuhde: 139.40000000000001,
    Tyopaikkaomavaraisuus: 73.5,
    Alueella_asuva_tyollinen_tyovoima: 5262,
    Ika20_64v_tyollisyysaste: 78.900000000000006,
    Asuinkunnassaan_tyossakayvia: 30.5,
    Tyottomia: 8.3000000000000007,
    Elakelaisia: 30.0,
    Alueella_olevia_tyopaikkoja: 3868,
    Alkutuotannon_tyopaikkoja: 3.6000000000000001,
    Jalostuksen_tyopaikkoja: 40.600000000000001,
    Palvelujen_tyopaikkoja: 54.200000000000003,
  },
  {
    Kunta: "Urjala",
    Vakiluku: 4568,
    Vakiluvun_muutos: 0.0,
    Alle15v: 12.4,
    Ika15_64v: 52.899999999999999,
    Yli64v: 34.700000000000003,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 2.7000000000000002,
    Taajamaa: 49.5,
    Syntyneiden_enemmyys: -44,
    Muuttovoitto: 20,
    Perheita: 1224,
    Asuntokuntia: 2389,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 87.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 67.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.699999999999999,
    Taloudellinen_huoltosuhde: 167.0,
    Tyopaikkaomavaraisuus: 78.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 1711,
    Ika20_64v_tyollisyysaste: 74.400000000000006,
    Asuinkunnassaan_tyossakayvia: 53.200000000000003,
    Tyottomia: 9.6999999999999993,
    Elakelaisia: 37.399999999999999,
    Alueella_olevia_tyopaikkoja: 1341,
    Alkutuotannon_tyopaikkoja: 12.300000000000001,
    Jalostuksen_tyopaikkoja: 28.899999999999999,
    Palvelujen_tyopaikkoja: 56.700000000000003,
  },
  {
    Kunta: "Utajärvi",
    Vakiluku: 2491,
    Vakiluvun_muutos: -1.3,
    Alle15v: 14.6,
    Ika15_64v: 52.100000000000001,
    Yli64v: 33.200000000000003,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 2.7000000000000002,
    Taajamaa: 50.0,
    Syntyneiden_enemmyys: -33,
    Muuttovoitto: -32,
    Perheita: 646,
    Asuntokuntia: 1237,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 16.300000000000001,
    Taloudellinen_huoltosuhde: 183.80000000000001,
    Tyopaikkaomavaraisuus: 84.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 889,
    Ika20_64v_tyollisyysaste: 71.5,
    Asuinkunnassaan_tyossakayvia: 60.299999999999997,
    Tyottomia: 12.199999999999999,
    Elakelaisia: 38.0,
    Alueella_olevia_tyopaikkoja: 754,
    Alkutuotannon_tyopaikkoja: 12.6,
    Jalostuksen_tyopaikkoja: 20.399999999999999,
    Palvelujen_tyopaikkoja: 65.400000000000006,
  },
  {
    Kunta: "Utsjoki",
    Vakiluku: 1139,
    Vakiluvun_muutos: -3.5,
    Alle15v: 11.300000000000001,
    Ika15_64v: 56.299999999999997,
    Yli64v: 32.399999999999999,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 4.2999999999999998,
    Taajamaa: 29.399999999999999,
    Syntyneiden_enemmyys: -12,
    Muuttovoitto: -29,
    Perheita: 272,
    Asuntokuntia: 581,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 31.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 28.300000000000001,
    Taloudellinen_huoltosuhde: 147.40000000000001,
    Tyopaikkaomavaraisuus: 95.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 477,
    Ika20_64v_tyollisyysaste: 75.099999999999994,
    Asuinkunnassaan_tyossakayvia: 79.900000000000006,
    Tyottomia: 8.8000000000000007,
    Elakelaisia: 33.100000000000001,
    Alueella_olevia_tyopaikkoja: 454,
    Alkutuotannon_tyopaikkoja: 10.1,
    Jalostuksen_tyopaikkoja: 4.4000000000000004,
    Palvelujen_tyopaikkoja: 76.900000000000006,
  },
  {
    Kunta: "Uurainen",
    Vakiluku: 3615,
    Vakiluvun_muutos: 0.59999999999999998,
    Alle15v: 24.100000000000001,
    Ika15_64v: 54.5,
    Yli64v: 21.399999999999999,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 1.2,
    Taajamaa: 45.899999999999999,
    Syntyneiden_enemmyys: 12,
    Muuttovoitto: -13,
    Perheita: 958,
    Asuntokuntia: 1457,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 14.4,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 25.399999999999999,
    Taloudellinen_huoltosuhde: 158.59999999999999,
    Tyopaikkaomavaraisuus: 57.0,
    Alueella_asuva_tyollinen_tyovoima: 1389,
    Ika20_64v_tyollisyysaste: 77.900000000000006,
    Asuinkunnassaan_tyossakayvia: 33.600000000000001,
    Tyottomia: 10.6,
    Elakelaisia: 23.699999999999999,
    Alueella_olevia_tyopaikkoja: 792,
    Alkutuotannon_tyopaikkoja: 8.0999999999999996,
    Jalostuksen_tyopaikkoja: 26.100000000000001,
    Palvelujen_tyopaikkoja: 64.099999999999994,
  },
  {
    Kunta: "Uusikaarlepyy",
    Vakiluku: 7500,
    Vakiluvun_muutos: 0.90000000000000002,
    Alle15v: 17.5,
    Ika15_64v: 56.399999999999999,
    Yli64v: 26.100000000000001,
    Ruotsinkielisia: 83.700000000000003,
    Ulkomaan_kansalaisia: 8.4000000000000004,
    Taajamaa: 63.0,
    Syntyneiden_enemmyys: 9,
    Muuttovoitto: -53,
    Perheita: 2122,
    Asuntokuntia: 3253,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 80.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.199999999999999,
    Taloudellinen_huoltosuhde: 131.0,
    Tyopaikkaomavaraisuus: 98.0,
    Alueella_asuva_tyollinen_tyovoima: 3218,
    Ika20_64v_tyollisyysaste: 81.400000000000006,
    Asuinkunnassaan_tyossakayvia: 67.200000000000003,
    Tyottomia: 5.0,
    Elakelaisia: 27.600000000000001,
    Alueella_olevia_tyopaikkoja: 3155,
    Alkutuotannon_tyopaikkoja: 13.699999999999999,
    Jalostuksen_tyopaikkoja: 37.899999999999999,
    Palvelujen_tyopaikkoja: 47.399999999999999,
  },
  {
    Kunta: "Uusikaupunki",
    Vakiluku: 14938,
    Vakiluvun_muutos: -1.0,
    Alle15v: 12.800000000000001,
    Ika15_64v: 55.899999999999999,
    Yli64v: 31.300000000000001,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 6.2999999999999998,
    Taajamaa: 77.0,
    Syntyneiden_enemmyys: -89,
    Muuttovoitto: -248,
    Perheita: 4076,
    Asuntokuntia: 7824,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 64.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 28.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.300000000000001,
    Taloudellinen_huoltosuhde: 143.0,
    Tyopaikkaomavaraisuus: 121.90000000000001,
    Alueella_asuva_tyollinen_tyovoima: 6211,
    Ika20_64v_tyollisyysaste: 76.400000000000006,
    Asuinkunnassaan_tyossakayvia: 80.299999999999997,
    Tyottomia: 9.4000000000000004,
    Elakelaisia: 34.0,
    Alueella_olevia_tyopaikkoja: 7571,
    Alkutuotannon_tyopaikkoja: 3.2000000000000002,
    Jalostuksen_tyopaikkoja: 52.299999999999997,
    Palvelujen_tyopaikkoja: 43.899999999999999,
  },
  {
    Kunta: "Vaala",
    Vakiluku: 2589,
    Vakiluvun_muutos: -1.3999999999999999,
    Alle15v: 10.800000000000001,
    Ika15_64v: 49.700000000000003,
    Yli64v: 39.600000000000001,
    Ruotsinkielisia: 0.0,
    Ulkomaan_kansalaisia: 2.5,
    Taajamaa: 42.600000000000001,
    Syntyneiden_enemmyys: -47,
    Muuttovoitto: -17,
    Perheita: 689,
    Asuntokuntia: 1412,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 93.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 19.300000000000001,
    Taloudellinen_huoltosuhde: 210.40000000000001,
    Tyopaikkaomavaraisuus: 97.5,
    Alueella_asuva_tyollinen_tyovoima: 846,
    Ika20_64v_tyollisyysaste: 67.400000000000006,
    Asuinkunnassaan_tyossakayvia: 72.099999999999994,
    Tyottomia: 13.800000000000001,
    Elakelaisia: 45.299999999999997,
    Alueella_olevia_tyopaikkoja: 825,
    Alkutuotannon_tyopaikkoja: 18.100000000000001,
    Jalostuksen_tyopaikkoja: 14.800000000000001,
    Palvelujen_tyopaikkoja: 66.099999999999994,
  },
  {
    Kunta: "Vaasa",
    Vakiluku: 68956,
    Vakiluvun_muutos: 1.3999999999999999,
    Alle15v: 14.1,
    Ika15_64v: 65.200000000000003,
    Yli64v: 20.600000000000001,
    Ruotsinkielisia: 23.199999999999999,
    Ulkomaan_kansalaisia: 8.5,
    Taajamaa: 98.400000000000006,
    Syntyneiden_enemmyys: -200,
    Muuttovoitto: -257,
    Perheita: 17329,
    Asuntokuntia: 36343,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 35.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 43.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 77.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 36.5,
    Taloudellinen_huoltosuhde: 118.7,
    Tyopaikkaomavaraisuus: 124.8,
    Alueella_asuva_tyollinen_tyovoima: 31082,
    Ika20_64v_tyollisyysaste: 74.700000000000003,
    Asuinkunnassaan_tyossakayvia: 84.5,
    Tyottomia: 6.7999999999999998,
    Elakelaisia: 22.899999999999999,
    Alueella_olevia_tyopaikkoja: 38781,
    Alkutuotannon_tyopaikkoja: 0.40000000000000002,
    Jalostuksen_tyopaikkoja: 26.899999999999999,
    Palvelujen_tyopaikkoja: 71.900000000000006,
  },
  {
    Kunta: "Valkeakoski",
    Vakiluku: 20694,
    Vakiluvun_muutos: 0.0,
    Alle15v: 14.6,
    Ika15_64v: 57.100000000000001,
    Yli64v: 28.300000000000001,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 4.0999999999999996,
    Taajamaa: 88.400000000000006,
    Syntyneiden_enemmyys: -146,
    Muuttovoitto: -152,
    Perheita: 5613,
    Asuntokuntia: 10440,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 54.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 26.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.299999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 28.300000000000001,
    Taloudellinen_huoltosuhde: 149.90000000000001,
    Tyopaikkaomavaraisuus: 80.799999999999997,
    Alueella_asuva_tyollinen_tyovoima: 8284,
    Ika20_64v_tyollisyysaste: 75.799999999999997,
    Asuinkunnassaan_tyossakayvia: 56.100000000000001,
    Tyottomia: 9.5999999999999996,
    Elakelaisia: 30.899999999999999,
    Alueella_olevia_tyopaikkoja: 6693,
    Alkutuotannon_tyopaikkoja: 1.6000000000000001,
    Jalostuksen_tyopaikkoja: 34.100000000000001,
    Palvelujen_tyopaikkoja: 63.299999999999997,
  },
  {
    Kunta: "Vantaa",
    Vakiluku: 247443,
    Vakiluvun_muutos: 1.8999999999999999,
    Alle15v: 16.5,
    Ika15_64v: 67.900000000000006,
    Yli64v: 15.699999999999999,
    Ruotsinkielisia: 2.2000000000000002,
    Ulkomaan_kansalaisia: 17.100000000000001,
    Taajamaa: 99.799999999999997,
    Syntyneiden_enemmyys: 747,
    Muuttovoitto: -897,
    Perheita: 63193,
    Asuntokuntia: 120055,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 33.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 43.200000000000003,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 31.5,
    Taloudellinen_huoltosuhde: 106.2,
    Tyopaikkaomavaraisuus: 107.8,
    Alueella_asuva_tyollinen_tyovoima: 117742,
    Ika20_64v_tyollisyysaste: 75.599999999999994,
    Asuinkunnassaan_tyossakayvia: 46.200000000000003,
    Tyottomia: 10.4,
    Elakelaisia: 17.399999999999999,
    Alueella_olevia_tyopaikkoja: 126921,
    Alkutuotannon_tyopaikkoja: 0.20000000000000001,
    Jalostuksen_tyopaikkoja: 22.399999999999999,
    Palvelujen_tyopaikkoja: 76.099999999999994,
  },
  {
    Kunta: "Varkaus",
    Vakiluku: 19727,
    Vakiluvun_muutos: -0.20000000000000001,
    Alle15v: 11.4,
    Ika15_64v: 54.899999999999999,
    Yli64v: 33.799999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 3.7000000000000002,
    Taajamaa: 91.200000000000003,
    Syntyneiden_enemmyys: -203,
    Muuttovoitto: -122,
    Perheita: 5196,
    Asuntokuntia: 11080,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 57.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 32.799999999999997,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.0,
    Taloudellinen_huoltosuhde: 175.69999999999999,
    Tyopaikkaomavaraisuus: 112.09999999999999,
    Alueella_asuva_tyollinen_tyovoima: 7168,
    Ika20_64v_tyollisyysaste: 69.099999999999994,
    Asuinkunnassaan_tyossakayvia: 78.200000000000003,
    Tyottomia: 12.4,
    Elakelaisia: 38.299999999999997,
    Alueella_olevia_tyopaikkoja: 8035,
    Alkutuotannon_tyopaikkoja: 1.7,
    Jalostuksen_tyopaikkoja: 34.299999999999997,
    Palvelujen_tyopaikkoja: 63.399999999999999,
  },
  {
    Kunta: "Vehmaa",
    Vakiluku: 2245,
    Vakiluvun_muutos: 0.80000000000000004,
    Alle15v: 13.9,
    Ika15_64v: 55.5,
    Yli64v: 30.600000000000001,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 4.7999999999999998,
    Taajamaa: 48.0,
    Syntyneiden_enemmyys: -16,
    Muuttovoitto: -11,
    Perheita: 617,
    Asuntokuntia: 1126,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 18.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.600000000000001,
    Taloudellinen_huoltosuhde: 140.90000000000001,
    Tyopaikkaomavaraisuus: 71.5,
    Alueella_asuva_tyollinen_tyovoima: 925,
    Ika20_64v_tyollisyysaste: 77.700000000000003,
    Asuinkunnassaan_tyossakayvia: 40.899999999999999,
    Tyottomia: 7.9000000000000004,
    Elakelaisia: 33.799999999999997,
    Alueella_olevia_tyopaikkoja: 661,
    Alkutuotannon_tyopaikkoja: 17.100000000000001,
    Jalostuksen_tyopaikkoja: 22.100000000000001,
    Palvelujen_tyopaikkoja: 59.0,
  },
  {
    Kunta: "Vesanto",
    Vakiluku: 1895,
    Vakiluvun_muutos: 0.10000000000000001,
    Alle15v: 8.5,
    Ika15_64v: 47.899999999999999,
    Yli64v: 43.5,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.2000000000000002,
    Taajamaa: 39.700000000000003,
    Syntyneiden_enemmyys: -42,
    Muuttovoitto: 22,
    Perheita: 512,
    Asuntokuntia: 1034,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 21.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 63.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 17.600000000000001,
    Taloudellinen_huoltosuhde: 205.5,
    Tyopaikkaomavaraisuus: 81.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 620,
    Ika20_64v_tyollisyysaste: 69.299999999999997,
    Asuinkunnassaan_tyossakayvia: 61.899999999999999,
    Tyottomia: 10.9,
    Elakelaisia: 48.399999999999999,
    Alueella_olevia_tyopaikkoja: 504,
    Alkutuotannon_tyopaikkoja: 20.199999999999999,
    Jalostuksen_tyopaikkoja: 5.7999999999999998,
    Palvelujen_tyopaikkoja: 71.799999999999997,
  },
  {
    Kunta: "Vesilahti",
    Vakiluku: 4469,
    Vakiluvun_muutos: -0.69999999999999996,
    Alle15v: 19.0,
    Ika15_64v: 61.5,
    Yli64v: 19.600000000000001,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 1.3,
    Taajamaa: 57.100000000000001,
    Syntyneiden_enemmyys: -21,
    Muuttovoitto: -6,
    Perheita: 1294,
    Asuntokuntia: 1861,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 97.200000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 9.5999999999999996,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 78.099999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 35.399999999999999,
    Taloudellinen_huoltosuhde: 114.2,
    Tyopaikkaomavaraisuus: 44.0,
    Alueella_asuva_tyollinen_tyovoima: 2101,
    Ika20_64v_tyollisyysaste: 83.299999999999997,
    Asuinkunnassaan_tyossakayvia: 25.300000000000001,
    Tyottomia: 5.0,
    Elakelaisia: 21.300000000000001,
    Alueella_olevia_tyopaikkoja: 925,
    Alkutuotannon_tyopaikkoja: 13.199999999999999,
    Jalostuksen_tyopaikkoja: 13.1,
    Palvelujen_tyopaikkoja: 70.900000000000006,
  },
  {
    Kunta: "Veteli",
    Vakiluku: 2936,
    Vakiluvun_muutos: -0.29999999999999999,
    Alle15v: 14.1,
    Ika15_64v: 53.0,
    Yli64v: 32.899999999999999,
    Ruotsinkielisia: 1.7,
    Ulkomaan_kansalaisia: 2.0,
    Taajamaa: 55.899999999999999,
    Syntyneiden_enemmyys: -27,
    Muuttovoitto: 2,
    Perheita: 830,
    Asuntokuntia: 1372,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.299999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.399999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.300000000000001,
    Taloudellinen_huoltosuhde: 155.09999999999999,
    Tyopaikkaomavaraisuus: 86.0,
    Alueella_asuva_tyollinen_tyovoima: 1155,
    Ika20_64v_tyollisyysaste: 78.400000000000006,
    Asuinkunnassaan_tyossakayvia: 58.600000000000001,
    Tyottomia: 7.2000000000000002,
    Elakelaisia: 36.100000000000001,
    Alueella_olevia_tyopaikkoja: 993,
    Alkutuotannon_tyopaikkoja: 19.100000000000001,
    Jalostuksen_tyopaikkoja: 22.300000000000001,
    Palvelujen_tyopaikkoja: 56.5,
  },
  {
    Kunta: "Vieremä",
    Vakiluku: 3387,
    Vakiluvun_muutos: -1.2,
    Alle15v: 14.300000000000001,
    Ika15_64v: 57.0,
    Yli64v: 28.800000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 3.7999999999999998,
    Taajamaa: 39.200000000000003,
    Syntyneiden_enemmyys: -23,
    Muuttovoitto: -42,
    Perheita: 931,
    Asuntokuntia: 1671,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.699999999999999,
    Taloudellinen_huoltosuhde: 131.19999999999999,
    Tyopaikkaomavaraisuus: 136.19999999999999,
    Alueella_asuva_tyollinen_tyovoima: 1482,
    Ika20_64v_tyollisyysaste: 79.099999999999994,
    Asuinkunnassaan_tyossakayvia: 68.900000000000006,
    Tyottomia: 7.9000000000000004,
    Elakelaisia: 32.299999999999997,
    Alueella_olevia_tyopaikkoja: 2018,
    Alkutuotannon_tyopaikkoja: 16.699999999999999,
    Jalostuksen_tyopaikkoja: 55.899999999999999,
    Palvelujen_tyopaikkoja: 26.600000000000001,
  },
  {
    Kunta: "Vihti",
    Vakiluku: 28811,
    Vakiluvun_muutos: -0.40000000000000002,
    Alle15v: 16.699999999999999,
    Ika15_64v: 61.899999999999999,
    Yli64v: 21.399999999999999,
    Ruotsinkielisia: 1.7,
    Ulkomaan_kansalaisia: 5.4000000000000004,
    Taajamaa: 75.700000000000003,
    Syntyneiden_enemmyys: 8,
    Muuttovoitto: -227,
    Perheita: 8102,
    Asuntokuntia: 13248,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 74.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.300000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 73.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 31.699999999999999,
    Taloudellinen_huoltosuhde: 113.59999999999999,
    Tyopaikkaomavaraisuus: 59.100000000000001,
    Alueella_asuva_tyollinen_tyovoima: 13538,
    Ika20_64v_tyollisyysaste: 81.400000000000006,
    Asuinkunnassaan_tyossakayvia: 37.200000000000003,
    Tyottomia: 7.5,
    Elakelaisia: 23.0,
    Alueella_olevia_tyopaikkoja: 7998,
    Alkutuotannon_tyopaikkoja: 2.3999999999999999,
    Jalostuksen_tyopaikkoja: 24.300000000000001,
    Palvelujen_tyopaikkoja: 71.200000000000003,
  },
  {
    Kunta: "Viitasaari",
    Vakiluku: 5877,
    Vakiluvun_muutos: -1.2,
    Alle15v: 11.1,
    Ika15_64v: 49.700000000000003,
    Yli64v: 39.200000000000003,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.0,
    Taajamaa: 57.899999999999999,
    Syntyneiden_enemmyys: -60,
    Muuttovoitto: -64,
    Perheita: 1589,
    Asuntokuntia: 3176,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 74.599999999999994,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 24.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.799999999999997,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.399999999999999,
    Taloudellinen_huoltosuhde: 182.59999999999999,
    Tyopaikkaomavaraisuus: 104.09999999999999,
    Alueella_asuva_tyollinen_tyovoima: 2106,
    Ika20_64v_tyollisyysaste: 72.700000000000003,
    Asuinkunnassaan_tyossakayvia: 79.900000000000006,
    Tyottomia: 10.800000000000001,
    Elakelaisia: 42.399999999999999,
    Alueella_olevia_tyopaikkoja: 2193,
    Alkutuotannon_tyopaikkoja: 9.8000000000000007,
    Jalostuksen_tyopaikkoja: 23.800000000000001,
    Palvelujen_tyopaikkoja: 65.299999999999997,
  },
  {
    Kunta: "Vimpeli",
    Vakiluku: 2656,
    Vakiluvun_muutos: -0.59999999999999998,
    Alle15v: 12.800000000000001,
    Ika15_64v: 54.399999999999999,
    Yli64v: 32.799999999999997,
    Ruotsinkielisia: 0.20000000000000001,
    Ulkomaan_kansalaisia: 2.2000000000000002,
    Taajamaa: 68.299999999999997,
    Syntyneiden_enemmyys: -34,
    Muuttovoitto: -3,
    Perheita: 750,
    Asuntokuntia: 1270,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 94.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 70.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 23.100000000000001,
    Taloudellinen_huoltosuhde: 152.19999999999999,
    Tyopaikkaomavaraisuus: 91.299999999999997,
    Alueella_asuva_tyollinen_tyovoima: 1059,
    Ika20_64v_tyollisyysaste: 78.200000000000003,
    Asuinkunnassaan_tyossakayvia: 64.0,
    Tyottomia: 6.5,
    Elakelaisia: 36.399999999999999,
    Alueella_olevia_tyopaikkoja: 967,
    Alkutuotannon_tyopaikkoja: 7.2000000000000002,
    Jalostuksen_tyopaikkoja: 39.100000000000001,
    Palvelujen_tyopaikkoja: 52.5,
  },
  {
    Kunta: "Virolahti",
    Vakiluku: 2927,
    Vakiluvun_muutos: -1.8999999999999999,
    Alle15v: 10.699999999999999,
    Ika15_64v: 54.0,
    Yli64v: 35.299999999999997,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 4.4000000000000004,
    Taajamaa: 47.200000000000003,
    Syntyneiden_enemmyys: -39,
    Muuttovoitto: -40,
    Perheita: 839,
    Asuntokuntia: 1508,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 96.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.5,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.100000000000001,
    Taloudellinen_huoltosuhde: 175.09999999999999,
    Tyopaikkaomavaraisuus: 98.200000000000003,
    Alueella_asuva_tyollinen_tyovoima: 1085,
    Ika20_64v_tyollisyysaste: 69.5,
    Asuinkunnassaan_tyossakayvia: 49.700000000000003,
    Tyottomia: 13.199999999999999,
    Elakelaisia: 38.799999999999997,
    Alueella_olevia_tyopaikkoja: 1065,
    Alkutuotannon_tyopaikkoja: 10.1,
    Jalostuksen_tyopaikkoja: 8.5,
    Palvelujen_tyopaikkoja: 79.700000000000003,
  },
  {
    Kunta: "Virrat",
    Vakiluku: 6275,
    Vakiluvun_muutos: -1.8999999999999999,
    Alle15v: 11.6,
    Ika15_64v: 49.899999999999999,
    Yli64v: 38.5,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.8999999999999999,
    Taajamaa: 52.200000000000003,
    Syntyneiden_enemmyys: -95,
    Muuttovoitto: -74,
    Perheita: 1695,
    Asuntokuntia: 3292,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 74.799999999999997,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 23.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 68.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.199999999999999,
    Taloudellinen_huoltosuhde: 179.90000000000001,
    Tyopaikkaomavaraisuus: 98.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 2285,
    Ika20_64v_tyollisyysaste: 75.299999999999997,
    Asuinkunnassaan_tyossakayvia: 76.700000000000003,
    Tyottomia: 8.8000000000000007,
    Elakelaisia: 41.899999999999999,
    Alueella_olevia_tyopaikkoja: 2254,
    Alkutuotannon_tyopaikkoja: 11.300000000000001,
    Jalostuksen_tyopaikkoja: 28.0,
    Palvelujen_tyopaikkoja: 59.600000000000001,
  },
  {
    Kunta: "Vårdö",
    Vakiluku: 471,
    Vakiluvun_muutos: 4.4000000000000004,
    Alle15v: 15.9,
    Ika15_64v: 57.299999999999997,
    Yli64v: 26.800000000000001,
    Ruotsinkielisia: 83.400000000000006,
    Ulkomaan_kansalaisia: 15.5,
    Taajamaa: 0.0,
    Syntyneiden_enemmyys: -1,
    Muuttovoitto: 13,
    Perheita: 128,
    Asuntokuntia: 200,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 95.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 13.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 65.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 26.600000000000001,
    Taloudellinen_huoltosuhde: 125.5,
    Tyopaikkaomavaraisuus: 59.5,
    Alueella_asuva_tyollinen_tyovoima: 200,
    Ika20_64v_tyollisyysaste: 83.299999999999997,
    Asuinkunnassaan_tyossakayvia: 44.0,
    Tyottomia: 3.7999999999999998,
    Elakelaisia: 26.800000000000001,
    Alueella_olevia_tyopaikkoja: 119,
    Alkutuotannon_tyopaikkoja: 27.699999999999999,
    Jalostuksen_tyopaikkoja: 11.800000000000001,
    Palvelujen_tyopaikkoja: 54.600000000000001,
  },
  {
    Kunta: "Vöyri",
    Vakiluku: 6291,
    Vakiluvun_muutos: 0.10000000000000001,
    Alle15v: 17.300000000000001,
    Ika15_64v: 54.600000000000001,
    Yli64v: 28.100000000000001,
    Ruotsinkielisia: 80.900000000000006,
    Ulkomaan_kansalaisia: 5.2999999999999998,
    Taajamaa: 50.600000000000001,
    Syntyneiden_enemmyys: -34,
    Muuttovoitto: -93,
    Perheita: 1784,
    Asuntokuntia: 2844,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 90.900000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.0,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.700000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 28.399999999999999,
    Taloudellinen_huoltosuhde: 132.19999999999999,
    Tyopaikkaomavaraisuus: 86.400000000000006,
    Alueella_asuva_tyollinen_tyovoima: 2707,
    Ika20_64v_tyollisyysaste: 83.599999999999994,
    Asuinkunnassaan_tyossakayvia: 59.200000000000003,
    Tyottomia: 4.7999999999999998,
    Elakelaisia: 29.199999999999999,
    Alueella_olevia_tyopaikkoja: 2338,
    Alkutuotannon_tyopaikkoja: 12.5,
    Jalostuksen_tyopaikkoja: 35.799999999999997,
    Palvelujen_tyopaikkoja: 50.5,
  },
  {
    Kunta: "Ylitornio",
    Vakiluku: 3765,
    Vakiluvun_muutos: -0.59999999999999998,
    Alle15v: 10.300000000000001,
    Ika15_64v: 49.200000000000003,
    Yli64v: 40.5,
    Ruotsinkielisia: 0.69999999999999996,
    Ulkomaan_kansalaisia: 3.8999999999999999,
    Taajamaa: 47.799999999999997,
    Syntyneiden_enemmyys: -60,
    Muuttovoitto: 6,
    Perheita: 1044,
    Asuntokuntia: 1923,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 92.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 19.199999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 69.200000000000003,
    Korkeaasteen_tutkinnon_suorittaneita15v: 20.600000000000001,
    Taloudellinen_huoltosuhde: 189.80000000000001,
    Tyopaikkaomavaraisuus: 90.599999999999994,
    Alueella_asuva_tyollinen_tyovoima: 1307,
    Ika20_64v_tyollisyysaste: 70.400000000000006,
    Asuinkunnassaan_tyossakayvia: 75.299999999999997,
    Tyottomia: 11.699999999999999,
    Elakelaisia: 44.0,
    Alueella_olevia_tyopaikkoja: 1184,
    Alkutuotannon_tyopaikkoja: 10.1,
    Jalostuksen_tyopaikkoja: 16.399999999999999,
    Palvelujen_tyopaikkoja: 67.5,
  },
  {
    Kunta: "Ylivieska",
    Vakiluku: 15369,
    Vakiluvun_muutos: 0.5,
    Alle15v: 19.899999999999999,
    Ika15_64v: 58.0,
    Yli64v: 22.100000000000001,
    Ruotsinkielisia: 0.29999999999999999,
    Ulkomaan_kansalaisia: 1.7,
    Taajamaa: 86.299999999999997,
    Syntyneiden_enemmyys: -11,
    Muuttovoitto: 12,
    Perheita: 4017,
    Asuntokuntia: 7202,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 73.0,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 28.600000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 75.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 27.199999999999999,
    Taloudellinen_huoltosuhde: 140.0,
    Tyopaikkaomavaraisuus: 108.90000000000001,
    Alueella_asuva_tyollinen_tyovoima: 6372,
    Ika20_64v_tyollisyysaste: 78.0,
    Asuinkunnassaan_tyossakayvia: 70.599999999999994,
    Tyottomia: 7.9000000000000004,
    Elakelaisia: 25.5,
    Alueella_olevia_tyopaikkoja: 6936,
    Alkutuotannon_tyopaikkoja: 2.1000000000000001,
    Jalostuksen_tyopaikkoja: 21.699999999999999,
    Palvelujen_tyopaikkoja: 75.200000000000003,
  },
  {
    Kunta: "Ylöjärvi",
    Vakiluku: 33677,
    Vakiluvun_muutos: 0.20000000000000001,
    Alle15v: 19.800000000000001,
    Ika15_64v: 60.100000000000001,
    Yli64v: 20.0,
    Ruotsinkielisia: 0.40000000000000002,
    Ulkomaan_kansalaisia: 1.5,
    Taajamaa: 89.200000000000003,
    Syntyneiden_enemmyys: 70,
    Muuttovoitto: -23,
    Perheita: 9670,
    Asuntokuntia: 14595,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 80.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 17.100000000000001,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 77.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 33.5,
    Taloudellinen_huoltosuhde: 117.5,
    Tyopaikkaomavaraisuus: 66.700000000000003,
    Alueella_asuva_tyollinen_tyovoima: 15455,
    Ika20_64v_tyollisyysaste: 82.299999999999997,
    Asuinkunnassaan_tyossakayvia: 34.0,
    Tyottomia: 5.9000000000000004,
    Elakelaisia: 22.0,
    Alueella_olevia_tyopaikkoja: 10314,
    Alkutuotannon_tyopaikkoja: 2.1000000000000001,
    Jalostuksen_tyopaikkoja: 30.0,
    Palvelujen_tyopaikkoja: 66.400000000000006,
  },
  {
    Kunta: "Ypäjä",
    Vakiluku: 2207,
    Vakiluvun_muutos: -1.3,
    Alle15v: 10.699999999999999,
    Ika15_64v: 58.899999999999999,
    Yli64v: 30.399999999999999,
    Ruotsinkielisia: 0.5,
    Ulkomaan_kansalaisia: 1.3999999999999999,
    Taajamaa: 41.399999999999999,
    Syntyneiden_enemmyys: -37,
    Muuttovoitto: 2,
    Perheita: 611,
    Asuntokuntia: 1143,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 91.700000000000003,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 16.699999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.900000000000006,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.100000000000001,
    Taloudellinen_huoltosuhde: 130.09999999999999,
    Tyopaikkaomavaraisuus: 59.5,
    Alueella_asuva_tyollinen_tyovoima: 972,
    Ika20_64v_tyollisyysaste: 79.900000000000006,
    Asuinkunnassaan_tyossakayvia: 40.100000000000001,
    Tyottomia: 7.2999999999999998,
    Elakelaisia: 33.5,
    Alueella_olevia_tyopaikkoja: 578,
    Alkutuotannon_tyopaikkoja: 17.100000000000001,
    Jalostuksen_tyopaikkoja: 18.5,
    Palvelujen_tyopaikkoja: 61.100000000000001,
  },
  {
    Kunta: "Ähtäri",
    Vakiluku: 5316,
    Vakiluvun_muutos: -1.7,
    Alle15v: 12.300000000000001,
    Ika15_64v: 52.100000000000001,
    Yli64v: 35.600000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.2999999999999998,
    Taajamaa: 62.0,
    Syntyneiden_enemmyys: -86,
    Muuttovoitto: -65,
    Perheita: 1471,
    Asuntokuntia: 2707,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 87.5,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 20.899999999999999,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 72.0,
    Korkeaasteen_tutkinnon_suorittaneita15v: 22.699999999999999,
    Taloudellinen_huoltosuhde: 175.0,
    Tyopaikkaomavaraisuus: 102.0,
    Alueella_asuva_tyollinen_tyovoima: 1966,
    Ika20_64v_tyollisyysaste: 74.400000000000006,
    Asuinkunnassaan_tyossakayvia: 74.900000000000006,
    Tyottomia: 8.0,
    Elakelaisia: 39.200000000000003,
    Alueella_olevia_tyopaikkoja: 2005,
    Alkutuotannon_tyopaikkoja: 10.699999999999999,
    Jalostuksen_tyopaikkoja: 28.0,
    Palvelujen_tyopaikkoja: 59.799999999999997,
  },
  {
    Kunta: "Äänekoski",
    Vakiluku: 17971,
    Vakiluvun_muutos: -0.80000000000000004,
    Alle15v: 14.199999999999999,
    Ika15_64v: 56.200000000000003,
    Yli64v: 29.600000000000001,
    Ruotsinkielisia: 0.10000000000000001,
    Ulkomaan_kansalaisia: 2.2000000000000002,
    Taajamaa: 76.599999999999994,
    Syntyneiden_enemmyys: -162,
    Muuttovoitto: -141,
    Perheita: 4871,
    Asuntokuntia: 9299,
    Rivi_ja_pientaloissa_asuvia_asuntokuntia: 65.400000000000006,
    Vuokra_asunnoissa_asuvia_asuntokuntia: 27.5,
    Toisen_asteen_tutkinnon_suorittaneita_15v: 71.599999999999994,
    Korkeaasteen_tutkinnon_suorittaneita15v: 21.600000000000001,
    Taloudellinen_huoltosuhde: 168.09999999999999,
    Tyopaikkaomavaraisuus: 108.5,
    Alueella_asuva_tyollinen_tyovoima: 6759,
    Ika20_64v_tyollisyysaste: 71.700000000000003,
    Asuinkunnassaan_tyossakayvia: 73.099999999999994,
    Tyottomia: 12.199999999999999,
    Elakelaisia: 33.399999999999999,
    Alueella_olevia_tyopaikkoja: 7333,
    Alkutuotannon_tyopaikkoja: 2.0,
    Jalostuksen_tyopaikkoja: 45.5,
    Palvelujen_tyopaikkoja: 51.700000000000003,
  },
];

/*
  {
    Kunta: "Pori",
    Vakiluku: 83106,
    Vakilukumuutos: -0.1,
    Alle15v: 13.3,
    ika15_64v: 59.7,
    Yli64v: 27,
    Ruotsinkielisia: 0.6,
    Ulkomaalaalaisia: 4,
    Taajamaa: 94,
    Syntyneidenenemmyys: -619,
    Muuttovoitto: -178,
    Perheita: 21642,
    Asuntokuntia: 44907,
    Rivi_ja_pientaloissa: 53.9,
    Vuokra_asunnoissa: 35,
    Toisen_asteen_tutkinto_yli15v: 74.9,
    Korkea_asteen_tutkinto_yli15v: 29.3,
    Taloudellinen_huoltosuhde: 146.1,
    Tyopaikkaomavaraisuus: 102.7,
    Tyollinen_tyovoima: 33806,
    ika20_64v_tyollisyysaste: 72.2,
    Asuinkunnassaan_tyossakayvia: 79.4,
    Tyottomia: 11.9,
    Elakelaisia: 30.3,
    Alueella_tyopaikkoja: 34715,
    Alkutuotannon_tyopaikkoja: 1.4,
    Jalostuksen_tyopaikkoja: 20.3,
    Palvelujen_tyopaikkoja: 77.3,,
  },
  {
    Kunta: "Siikainen",
    Vakiluku: 1283,
    Vakilukumuutos: -1.9,
    Alle15v: 10.7,
    ika15_64v: 48.7,
    Yli64v: 40.6,
    Ruotsinkielisia: 0.2,
    Ulkomaalaalaisia: 1.2,
    Taajamaa: 30.3,
    Syntyneidenenemmyys: -15,
    Muuttovoitto: -9,
    Perheita: 353,
    Asuntokuntia: 669,
    Rivi_ja_pientaloissa: 96.7,
    Vuokra_asunnoissa: 14.6,
    Toisen_asteen_tutkinto_yli15v: 65.6,
    Korkea_asteen_tutkinto_yli15v: 16.7,
    Taloudellinen_huoltosuhde: 201.4,
    Tyopaikkaomavaraisuus: 81.6,
    Tyollinen_tyovoima: 434,
    ika20_64v_tyollisyysaste: 70.6,
    Asuinkunnassaan_tyossakayvia: 55.8,
    Tyottomia: 12.3,
    Elakelaisia: 43.4,
    Alueella_tyopaikkoja: 354,
    Alkutuotannon_tyopaikkoja: 19.5,
    Jalostuksen_tyopaikkoja: 40.4,
    Palvelujen_tyopaikkoja: 37.9,,
  },
];
*/
export default stats;
